import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    'pt-br': {
        genericError: 'Algo deu errado. Tente novamente.',
        projectDescriptionShortenUrl : `O Migly é uma ferramenta eficaz para encurtar links. Crie sua conta agora e acesse nosso painel. Use nosso encurtador para transformar URLs longas em links curtos.`,
        shortenUrlBenefit1: 'Encurte links do Instagram, YouTube, WhatsApp ou qualquer outro site.',
        shortenUrlBenefit2: 'Crie um link único que leva para todas as suas redes sociais e projetos.',
        shortenUrlBenefit3: 'Você pode acompanhar a análise e ter controle total sobre seus links.',
        projectDescription : `Encurtador de URL migly é uma ferramenta poderosa para encurtar link. 
        Use o nosso Encurtador de Link para diminuir uma URL longa e gerar um link curto. 
        Crie URLs personalizadas, acompanhe as análises e tenha controle total dos seus links. 
        Crie sua conta agora no link abaixo e acesse nosso painel. 
        Encurte links do Facebook, Instagram, Youtube & Whatsapp. Encurte o link que você quiser.`,
        shortenToURL: 'Encurte seu link',
        shortenToURLExample: 'Exemplo youtube.com ou um número de telefone',
        shortenedUrl: `URL encurtada`,
        originalLink: 'Link original',
        plans: 'Planos',
        shortenAddress: `Encurtar links`,
        uniqueLink: 'Conecte tudo com um único link',
        bioPageMarketingText: `O meu migly conecta todas suas páginas, post nas redes sociais, videos no youtube, qualquer conteúdo ou projeto que você tenha online em uma única página biográfica.
        Além de um link curto você terá um QRCode associado a sua bio. Imprima e facilite o acesso ao seus projetos.`,
        urlCopiedToClipboard: 'Link copiado',
        copyUrl: 'Copiar link',
        viewUrl: 'Visitar link',
        toClean: 'Limpar',
        invalidUrl : `URL inválida`,
        login: `Entrar`,
        signUp: `Criar Conta`,
        anchorLink1: `redução de urls para economizar espaço`,
        areYouSure: 'Você tem certeza?',
        credit: 'Crédito',
        submissions: 'Envios',
        accessCount: 'Contagem de Acessos',
        accessCountBlockMessage: 'Recurso disponível para assinantes do plano básico do encurtador de URLs.',
        of: 'de',
        smsConfig: 'Configuração dos disparos',
        businessName: 'Nome do negócio, serviço ou programa',
        exemple: 'Exemplo',
        exempleSmsOptIn: 'SMS para solicitação de permissão',
        exempleSmsOptInDesc: 'Gostaria de receber SMS de _? Acesse migly.in/i/xXx para confirmar. Ate aceitar, nao enviaremos mais. O envio de respostas pode gerar custos de dados móveis.',
        exempleSmsMarketing: 'SMS Exemplo de Marketing',
        exempleSmsMarketingDesc: '_: Economize de 25 a 50% em itens em promocao em loja.com. Clique aqui para navegar pela venda: https://loja.com. Click migly.in/o/xXx p/ sair.',
        
        smsTryInfo: `Estamos entusiasmados em oferecer a você a oportunidade de testar nossa API (interface de programação de aplicativos) permite o envio de SMS de forma integrada. Com esta API, você poderá integrar facilmente a capacidade de enviar mensagens de texto para seus clientes ou usuários em seu próprio aplicativo ou plataforma. Para começar o teste gratuito, envie um email solicitando o teste da ferramenta para <b>contato@exatamente-solucoes.com</b>.`,

        businerRequiredInfo: 'Configure os disparos informando o nome do negócio, programa ou serviço para salvar contatos e enviar mensagens.',

        createEbook: 'Crie um e-book',
        createEbookSubtitle: 'Ofereça uma oferta de valor',
        createEbookText: 'Para incentivar os visitantes a compartilharem suas informações de contato, ofereça uma oferta de valor em troca, como um e-book gratuito.',

        operationCannotBeUndone: 'Essa operação não poderá ser desfeita',
        deleteConfirm: 'Confirmar Exclusão',
        searchShortURL: 'Buscar Links',
        save: 'Salvar',
        edit: 'Editar',
        unique_views: 'Visitantes',
        invalid: 'inválido',
        provideYourEmail: 'Informe seu e-mail',
        'invalid.sms.text.size' : 'A mensagem não pode ultrapassar 160 caracteres',
        editAddress: 'Editar link migly',
        createBio: 'Crie sua página biográfica',
        pageBio: 'Bio Migly',
        followMetrics: 'Acompanhar métricas',
        generateWhatsAppLink: 'Gerar link para WhatsApp',
        whatsAppNumber: 'Número',
        loggout: 'Sair',
        add: 'Adicionar',
        sample_link: 'Link Simples',
        youtube: 'YouTube',
        add_sample_link: 'Adicionar link Simples',
        add_youtube: 'Adicionar video do YouTube',
        whatsapp: 'WhatsApp',
        add_whatsapp: 'Adicionar WhatsApp',
        addLink: 'Adicionar link',
        add_image: 'Adicionar imagem',
        instagram: 'Instagram',
        add_instagram: 'Adicionar Instagram',
        link_instagram_profile: 'Link para o perfil no instagram',
        errorLinkLoad: 'Erro ao buscar por informações do link',
        invalidImageFile: 'Não foi possível usar este arquivo - selecione uma imagem válida.',
        instagramAutofillFailed: 'Não foi possível buscar a foto do perfil automaticamente. Um ícone padrão do Instagram será exibido no lugar.',
        username_instagram_profile: 'Nome do usuário no instagram',
        newSection: 'Adicionar seção',
        pageNotFoundTitle: 'Esta página não existe',
        pageNotFoundDesc: 'O link que você acessou pode ter sido removido ou nunca existiu.',
        backToHome: 'Voltar para o início',
        securityVerifyingTitle: 'Estamos verificando este endereço',
        securityVerifyingDesc: 'O destino ainda não foi validado pelo Migly.',
        securityVerifyingStillInProgress: 'A verificação ainda está em andamento. Tente novamente em instantes.',
        securityContinueButton: 'Continuar para o endereço',
        securityBlockedTitle: 'Navegação interrompida',
        securityBlockedDesc: 'O Migly identificou que o endereço de destino deste link pode representar um risco de segurança. Por segurança, o acesso ao endereço foi bloqueado.',
        securityBlockedCta: 'Ir para o Migly',
        accountSuspendedTitle: 'Conta suspensa por segurança',
        accountSuspendedDesc: 'Identificamos conteúdo potencialmente malicioso associado à sua conta e o acesso foi suspenso até a análise do caso.',
        accountSuspendedContact: 'Entre em contato pelo e-mail contato@exatamente-solucoes.com para mais informações.',
        accountSuspendedClose: 'Entendi',
        aspectRatio: 'Proporção da tela',
        original: 'Original',
        optional: 'opcional',
        destinationURL: 'URL de destino',
        whatsAppText: 'Mensagem Padrão',
        deleteAddressInfoPlan: 'O endereço dos links so podem ser alterados a partir do plano básico',
        toChart: `Analizar clicks nesse link`,
        yourPageAvailibleIn: 'Sua página estará disponível em ',
        panel: 'Painel',
        infoProduct: 'Página de Vendas',
        infoProducts: 'Páginas de Vendas',
        productImage: 'Imagem do produto',
        topicsAndThemes: 'Tópicos, itens e benefícios',
        topicsAndThemesTitle: 'Título dos itens do seu produto',
        topicAndThemesTitle: 'Assunto, tópico, benefício ou item',
        infoproductMoreTitle: 'Mais sobre sua página de vendas',
        infoproductMoreSubtitle: 'Escreva a descrição completa do que o lead vai receber. Esse texto aparece em uma seção própria, mais abaixo na página.',
        fillInFormForReceiveEbook: 'Preencha o formulário para receber o e-book',
        fillInFormForReceiveLink: 'Preencha o formulário para receber o link',
        fillInYourEmailPolicyPrivacy: 'A Exatamente Soluções Educacionais precisa das informações de contato que você nos fornece para contatá-lo e enviar o link do produto. Você pode cancelar a assinatura dessas comunicações a qualquer momento. Para obter informações sobre como cancelar a assinatura, bem como nossas práticas de privacidade e compromisso com a proteção de sua privacidade, consulte nossa Política de Privacidade no final da página.',
        topicsAndThemesSubtitle: 'Liste os principais tópicos, benefícios ou resultados do seu produto — isso ajuda o lead a decidir se vale preencher o formulário.',
        product: 'Produto',
        editLinkSubdomain: 'Subdomínio',
        editLinkSubdomainSubtitle: 'Escolha o endereço da sua página de vendas — é esse link que você vai divulgar e rastrear.',
        productSubtitle: 'Escolha o que o lead vai receber ao preencher o formulário: um e-book em PDF ou um link de acesso.',
        pageAparence: 'Aparência da página',
        pageAparenceSubtitle: 'Personalize cabeçalho, logo, textos e imagem principal da sua página de vendas.',
        linkAparencePreview: 'Defina a aparência do link quando compartilhar no whattsapp e redes sociais',
        logoOrlogotipo: 'Logotipo do site ou produto',
        logoOrlogotipoSizeInfo: 'Escolha uma imagem quadrada (proporção 1:1), como 500 x 500 pixels, com fundo transparente.',
        recommendedImageSize: 'Dimensão recomendada:',
        cropImageTitle: 'Cortar e redimensionar imagem',
        subtitle: 'Subtítulo',
        shortDescription: 'Uma breve descrição',
        actionName: 'Nome da ação',
        infoproductType: 'Tipo de página de vendas',
        downloadNow: 'Baixe agora',
        accessNow: 'Tenha acesso agora',
        eBook: 'E-Book',
        file: 'Arquivo',
        editInfoProduct: 'Editar Página de Vendas',
        learnMore: 'Saiba mais',
        createInfoProduct: 'Criar Página de Vendas',
        send: 'Enviar',
        reportLinkTitle: 'Reporte de Links Suspeitos e Maliciosos',
        reportLinkSendTitle: 'Obrigado por seu relatório!',
        reportLinkSendDescription: 'Agradecemos sua colaboração em manter a web segura. Sua contribuição é essencial para garantir uma experiência online mais confiável e protegida. Nossa equipe analisará o link reportado e tomará as medidas necessárias.',
        reportLinkDescription: 'Ajude-nos a manter a web segura! Utilize este formulário para reportar links com erro, falsos, suspeitos ou potencialmente maliciosos. Sua contribuição é essencial para garantir uma experiência online mais confiável e protegida para todos.',
        reportLinkPlaceholder: 'Por exemplo: O link encurtado direciona para site suspeito de fishing.',
        eBookSendDescription: 'Assim que seus clientes preencherem o formulário de interesse em seu produto, seu arquivo em PDF será prontamente enviado a eles.',
        linkSendDescription: 'Assim que seus clientes preencherem o formulário de interesse em seu produto, seu link será prontamente enviado a eles.',
        createNewInfoproduct: 'Criar nova página de vendas',
        messageToUserNotLoggedInURLShortener: 'Seu link foi gerado com sucesso, no entanto, ele ainda não está associado à sua conta. Como resultado, você não poderá acessar métricas detalhadas nem personalizar a prévia do link nas redes sociais.',
        plansAndPrices: `Planos e preços`,
        plansAndPricesDescription: 'Obtenha uma solução essencial para gerar, compartilhar e rastrear links para todas as formas de comunicação. Escolha seu plano abaixo. Você terá 7 dias para testar.',
        plansLadderBaseTitle: 'Comece com o {plan}',
        plansLadderMoreTitle: 'Tudo do {plan} mais',
        planFilterTag: 'Encontre seu plano',
        planFilterTitle: 'Qual plano é ideal pra você?',
        planFilterSubtitle: 'Marque os recursos que você precisa e mostramos o plano mais barato que já inclui tudo isso.',
        planFilterEmptyState: 'Marque ao menos um recurso ao lado para ver a recomendação.',
        planFilterRecommendedLabel: 'Plano recomendado',
        plan_FREE: 'Gratuito',

        URL_SHORTNER_FREE: 'Encurtador de links gratuito',
        URL_SHORTNER_BASIC: 'Encurtador de links básico',
        URL_SHORTNER_PRO: 'Encurtador de links profissional',
        URL_SHORTNER_BUSINESS: 'Encurtador de links empresarial',

        plan_URL_SHORTNER_FREE: 'Gratuito',
        plan_URL_SHORTNER_BASIC: 'Básico',
        plan_URL_SHORTNER_PRO: 'Profissional',
        plan_URL_SHORTNER_BUSINESS: 'Empresarial',

        PLAN_URL_SHORTNER_FREE_SUBSCRIPTION: 'Gratuito',
        PLAN_URL_SHORTNER_BASIC_SUBSCRIPTION: 'Básico',
        PLAN_URL_SHORTNER_PRO_SUBSCRIPTION: 'Profissional',
        PLAN_URL_SHORTNER_BUSINESS_SUBSCRIPTION: 'Empresarial',
        excluded: 'Excluído',

        trialPeriod: 'Se esta for sua primeira ativação, você terá sete dias para testar.',

        LOADING_PAGE: 'Personalização da tela de carregamento',
        LOADING_PAGE_DESC: 'Recurso disponível para assinantes do plano profissional do encurtador de URLs.',

        plan_BASIC: 'Básico',
        plan_PRO: 'Profissional',
        UNLIMITED_LINKS: 'Links ilimitados',
        dateCreateIni: 'Data inicial de criação do link',
        dateCreateEnd: 'Data final de criação do link',
        desc_UNLIMITED_LINKS: {icons: ['mdi-link', 'mdi-all-inclusive'], description: "Não existe limites para a quantidade de links encurtados, você pode criar e encurtar quantos endereços desejar."},
        BIO: 'Bio migly',
        INFOPRODUCT: 'Página de vendas com captura de lead',
        clickDateRange: '',
        true: 'Sim',
        false: 'Não',
        SMS: 'sms (template para envio de SMS)',
        desc_BIO: {icons: ['mdi-bio', 'mdi-vector-union', 'mdi-text-account'], description: "Facilite o acesso a todas suas redes sociais, formas de contato e projetos online com sua página biográfica unificadora de links."},
        onboardingWelcomeTitle: 'Vamos te mostrar o que você já pode fazer',
        onboardingProgress: 'Passo {current} de {total}',
        onboardingBtnNext: 'Avançar',
        onboardingBtnFinish: 'Concluir',
        onboardingBtnDismiss: 'Encerrar',
        onboardingRelaunch: 'Rever o tour guiado',
        onboardingStepShortenTitle: 'Encurte seu primeiro link',
        onboardingStepShortenBody: 'Cole uma URL longa e gere um link curto e fácil de compartilhar em segundos.',
        onboardingStepPreviewTitle: 'Gere uma pré-visualização',
        onboardingStepPreviewBody: 'Personalize como seu link aparece quando compartilhado nas redes sociais, com imagem, título e descrição.',
        onboardingStepTagsTitle: 'Organize com tags',
        onboardingStepTagsBody: 'Crie tags para agrupar e filtrar seus links por campanha, projeto ou canal.',
        onboardingStepBannerTitle: 'Banner de divulgação',
        onboardingStepBannerBody: 'Exiba um banner e uma chamada para ação na tela de redirecionamento antes de levar seu visitante ao destino final.',
        onboardingStepConfigTitle: 'Configurações gerais',
        onboardingStepConfigBody: 'Ajuste o comportamento padrão da sua conta, como tempo de espera e banner de redirecionamento.',
        onboardingStepBioTitle: 'Crie sua página de bio',
        onboardingStepBioBody: 'Reúna todos os seus links importantes em uma única página personalizável para compartilhar nas redes sociais.',
        onboardingStepInfoproductTitle: 'Transforme um link em página de vendas',
        onboardingStepInfoproductBody: 'Capture o contato de quem clicar antes de enviá-lo ao checkout de outra plataforma, com um formulário de captura de lead na página de destino do link.',
        QR_CODE: 'QRCodes',
        desc_QR_CODE: {icons: ['mdi-data-matrix-scan'], description: "Facilite ainda mais o acesso a seus links com QRCodes. Com esse recurso seus clientes nem precisa digitar os endereços para suas páginas."},
        UNLIMITED_CLICKS: 'Links sem limite de clicks',
        desc_UNLIMITED_CLICKS: {icons: ['mdi-cursor-default-click', 'mdi-all-inclusive'], description: "Os endereços criados/encurtados sempre estarão disponíveis e nunca expiram, eles também não tem limite para clicks, ou seja, seus clientes ou seguidores sempre terão acesso aos seus links encurtados."},
        COUNT_CLICKS: 'Contagem de clicks',
        desc_COUNT_CLICKS: {icons: ['mdi-cursor-default-click', 'mdi-counter'], description: "Saiba quantas pessoas clicaram em seus links."},
        REPORT_COMPLETE: 'Relatório completo',
        desc_REPORT_COMPLETE: {icons: ['mdi-chart-arc', 'mdi-chart-donut-variant', 'mdi-chart-histogram'], description: "Relatório completo de acessos aos seus links por dispositivo, região e plataforma."},
        dashboardExampleBadge: 'Exemplo',
        dashboardExampleUnlock: 'Disponível no plano PRO',
        dashboardPeriodLockedTooltip: 'Disponível a partir do plano básico',
        LOGO_LOADING: 'Personalização completa',
        desc_LOGO_LOADING: {icons: ['mdi-link', 'mdi-office-building', 'mdi-cog'], description: "Exiba o nome da sua empresa em telas de carregamento e direcionamento para seus links gerados, personalização completa da url e customização da pré-visualização para redes sociais."},
        VERIFY_LINK: 'Verificar links que não funcionam',
        desc_VERIFY_LINK: {icons: ['mdi-link' , 'mdi-cube-scan'], description: "Verificamos links encurtados periodicamente e te avisamos quando um link não está funcinando, assim saberá quando está perdendo acessos."},
        UPDATE_LINK: 'Alterar o direcionamento dos links gerados',
        desc_UPDATE_LINK: {icons: ['mdi-link', 'mdi-circle-edit-outline'], description: "Você poderá editar todos os links encurtados após a criação deles, mudando direcionamento para outro site e até mesmo alterar o nome encurtado do link."},
        SEND_SMS: 'Envio de SMS',
        desc_SEND_SMS: {icons: ['mdi-message-processing' , 'mdi-clock-outline', 'mdi-message-badge-outline'], description: "Enviamos e agendamos envio de SMS para seus clientes. <br> É preciso comprar créditos para enviar mensagens.<br> O custo de cada SMS é de <i>R$ 0,30</i> e você ganha R$ 4,00 todos os meses ao assinar o plano profissional"},
        smsInfo: 'O custo de cada SMS é de <i>R$ 0,30</i>',
        API_ACCESS: 'Acesso a API para integração',
        API_ACCESS_LINK: 'Acesso a API de integração',
        CUSTOM_DOMAIN: 'Domínio personalizado',
        desc_CUSTOM_DOMAIN:  {icons: ['mdi-link', 'mdi-circle-edit-outline'], description: "Você poderá associar um domínio personalizado aos seus links gerados, algo como https://sua-empresa.com/{code}. Será preciso comprar ou configurar um domínio."},
        desc_API_ACCESS: {icons: ['mdi-dev-to', 'mdi-api'], description: "Você poderá encurtar seus links programaticamente utilizando nossa <a href='/api-doc' target='_blank'>API</a>"},
        desc_INFOPRODUCT: {icons: ['mdi-cart-outline', 'mdi-account-arrow-right-outline'], description: "Transforme qualquer link em uma página de vendas com formulário de captura, para não perder o contato de quem clicou mas não converteu no checkout de outra plataforma."},
        emptyLinksTitle: 'Você ainda não criou nenhum link',
        emptyLinksSubtitle: 'Enquanto isso, veja tudo o que o Migly pode fazer por você:',
        previewLink: 'Pré-visualização do link',
        getPlan: `Selecionar`,
        currentPlan: 'Seu plano atual',
        'url.rejected' : 'URL rejeitada',
        'url.rejected.missing.scheme' : 'URL inválida - adicione http:// ou https:// antes do endereço',
        'code.reserved' : 'Este código é reservado e não pode ser usado',
        'tag.derived.immutable' : 'Tags capturadas automaticamente não podem ser editadas ou removidas',
        derivedTagTooltip: 'Tag capturada automaticamente - não pode ser editada ou removida',
        updateAddressInfo: 'Altere o código do link encurtado ou o direcionamento',
        linkCodeChangeWarning: 'Ao alterar o código, o link atual deixará de funcionar imediatamente. Quem já tiver esse link salvo ou compartilhado não conseguirá mais acessá-lo.',
        linkUrlChangeWarning: 'Ao alterar o endereço de destino, a pré-visualização (preview) desse link para redes sociais será atualizada automaticamente.',
        assignPlan: `Assinar Plano {plan}`,
        assignPlanAuth: `Para assinar esse plano é preciso realizar o login`,
        closeCheckoutConfirmTitle: 'Sair sem finalizar?',
        closeCheckoutConfirmText: 'Os dados preenchidos serão perdidos se você sair agora.',
        closeCheckoutConfirmStay: 'Continuar preenchendo',
        closeCheckoutConfirmLeave: 'Sair mesmo assim',
        saved: 'Salvo',
        saveTagsError: 'Não foi possível salvar as tags. Tente novamente.',
        saveConfigError: 'Não foi possível salvar as configurações. Tente novamente.',
        default: 'Padrão',
        shootings: 'Disparos',
        payPerYearInfo: 'Economize até 30% ao pagar anualmente',
        payPerMonth: 'Pague por mês',
        month: 'mês',
        year: 'ano',
        montly: 'mensal',
        monthly: 'mensal',
        yearly: 'anual',
        payPerYear: 'Pague por ano',
        totalClicks: 'Total de clicks',
        totalClicksInBioPage: 'clicks nos links da sua página',

        optOut: 'opt-out',
        moreActions: 'Mais ações',
        filter: 'Filtrar',
        messageSendoptInRequired: 'Você paga o equivalente ao envio de 1 SMS para solicitar a permissão.',
        optIn: 'opt-in',
        optInRequired: 'Solicite permissão para envios de SMSs',
        optInRequiredSubtitle: 'Este contato atualmente faz parte da nossa lista de exclusão.',
        optInRequiredText: `Para que possamos enviar mensagens para ele, é necessário obter sua permissão. Você pode iniciar o processo enviando uma solicitação de permissão, e só poderemos enviar novas mensagens depois que o contato aceitar receber atualizações.
        `,
        today: 'Hoje',
        DAY: 'Dia',
        MONTH: 'Mês',
        YEAR: 'Ano',
        countries: 'Países',
        states: 'Estados',
        cities: 'Cidades',
        optInRequiredSend: 'Permissão para envios de SMSs solicitada',
        optInRequiredSendSubtitle: 'Este contato atualmente ainda faz parte da nossa lista de exclusão até que ele aceite receber suas comunicações.',
        viewsPerRegion: 'Visualizações por região',
        worldMap: 'Mapa mundial',
        viewMoreByStateCity: 'Ver por estado e cidade',
        selectCountryOnMap: 'Selecione um país no mapa ou no ranking para ver o detalhamento por estado e cidade.',
        optInRequiredSendAccept: 'Permissão para envios de SMSs aceita',
        optInRequiredSendAcceptSubtitle: 'Este contato atualmente faz parte da nossa lista de inclusão.',
        requireOptIn: 'Solicitar opt-in',
        optInAcceptTitle: 'Aceitar receber mensagens do(a) ',
        biopage: 'Página biográfica',
        report: 'Relatório',
        views: 'Visualizações',
        viewsPerDate: 'Visualizações por data',
        viewsPerState: 'Visualizações por estado',
        period: 'Período dos acessos',
        shortenFree: 'Entrar com conta google',
        onlineAddressId: 'Identificador do link',
        searchLinksDesc: 'Busque links por trechos da url, tags ou código identificador do link',
        viewsPerDateDisclaimer: '*Gráfico de Acessos Diários: Exibe apenas os dias com acessos registrados. Para ver mais detalhes, clique e expanda o gráfico.',
        countAllLinks: 'Contagem de acesso para todos os links',
        countLinksTo: 'Contagem para o link ',
        browserDefault: 'Navegador Padrão',
        dashboardInfoText: 'Exibição de Dados: O gráfico mostra dados filtrados pelo período de apuração e pela visualização dos links no painel.',

        clicks: 'Clicks',
        appView: 'Outros Apps',
        appViewDesc: 'Visualização dentro de outros aplicativos',

        startAt: 'a partir de',
        endAt: 'até',
        accessByDay: 'Clicks por dia',

        periodWithoutResult: 'Período sem resultado',

        clean: "Limpar",
        plan: "Plano",
        assignPlanCardInfo: "Não mantemos dados do cartão de crédito. Essa informação é utilizada somente na assinatura do plano e depois é excluída.",


        helpTitle: 'Entre em Contato Conosco',
        helpDescription: 'Tem alguma dúvida sobre o Migly, precisa relatar um problema ou quer saber mais sobre nossas funcionalidades? Estamos aqui para ajudar! Entre em contato com nossa equipe pelo e-mail <b>contato@exatamente-solucoes.com</b> e teremos o prazer de assisti-lo. Seu feedback é muito importante para nós!',
        helpAction: 'Envie um email',
        toAccessPanel: 'Acessar painel',
        assignPlanSuccessTitle: 'Assinatura do plano {plan} confirmada!',
        assignPlanSuccess: "Recebemos os dados do pagamento. Aguarde até que a cobrança seja realizada.",
        youAssignPlan: "Você assina o Plano ",
        'og:title': 'Título da página.',
        'og:type': 'Tipo de conteúdo, como website ou artigo.',
        'og:image': 'Imagem principal da página.',
        'og:url': 'URL da página.',
        'og:description': 'Breve descrição da página.',
        'og:site_name': 'Nome do site.',
        'og:locale': 'Idioma e região da página, como pt_BR.',
        'og:determiner': 'Palavra antes do título, como "a" ou "an".',
        'og:image:url': 'Imagem.',
        'og:image:secure_url': 'Imagem segura (HTTPS).',
        'og:image:type': 'Formato da imagem, como image/jpeg.',
        'og:image:width': 'Largura da imagem em pixels.',
        'og:image:height': 'Altura da imagem em pixels.',
        'og:video': 'Vídeo.',
        'og:video:secure_url': 'Video seguro (HTTPS).',
        'og:video:type': 'Formato do vídeo, como video/mp4.',
        'og:video:width': 'Largura do vídeo em pixels.',
        'og:video:height': 'Altura do vídeo em pixels.',
        'og:audio': 'Áudio.',
        'og:audio:secure_url': 'Áudio seguro (HTTPS).',
        'og:audio:type': 'Formato do áudio, como audio/mpeg.',
        'article:published_time': 'Data e hora de publicação do artigo.',
        'article:modified_time': 'Data e hora da última modificação do artigo.',
        'article:expiration_time': 'Data e hora de expiração do artigo.',
        'article:author': 'URL do autor do artigo.',
        'article:section': 'Seção do site onde o artigo está.',
        'article:tag': 'Palavras-chave do artigo.',
        'book:author': 'URL do autor do livro.',
        'book:isbn': 'Número ISBN do livro.',
        'book:release_date': 'Data de lançamento do livro.',
        'book:tag': 'Palavras-chave do livro.',
        'product:availability': 'Disponibilidade do produto, como "em estoque".',
        'product:price:amount': 'Preço do produto.',
        'product:price:currency': 'Moeda do preço, como BRL.',
        'product:retailer_item_id': 'ID do item no varejista.',
        'contact:already:opt:in:or:number:invalid' : 'Contato já optou por receber mensagens ou o número é inválido',


        'basics': 'Essenciais',
        'optionals': 'Opcionais',
        'images': 'Imagens',
        'videos': 'Vídeos',
        'audios': 'Áudios',
        'articles': 'Artigos',
        'books': 'Livros',
        'products': 'Produtos',

        'basicsDesc': 'Propriedades essenciais para qualquer página.',
        'optionalsDesc': 'Propriedades adicionais que podem ser incluídas.',
        'imagesDesc': 'Propriedades relacionadas a imagens da página.',
        'videosDesc': 'Propriedades relacionadas a vídeos da página.',
        'audiosDesc': 'Propriedades relacionadas a áudios da página.',
        'articlesDesc': 'Propriedades específicas para artigos.',
        'booksDesc': 'Propriedades específicas para livros.',
        'productsDesc': 'Propriedades específicas para produtos.',
        'allDesc': 'Todas as propriedades.',

        hostinger_ads: 'Solução completa para hospedar seu site',
        maxFileSizeOG: 'O tamanho da imagem deve ser inferior a 2 MB!',
        apiRefSwagger: 'Referência da API (Swagger)',
        website: 'Website',
        application: 'Aplicativo',
        audio: 'Audio', 
        image: 'Imagem', 
        delete: 'Excluir',
        deleteLink: 'Excluir Link',
        doUpgrade: 'Fazer upgrade',
        apiDoc: 'Documentação',
        toSendInfoproduct: 'Confira seu email',
        message: 'Mensagem', 
        multipart: 'Arquivo', 
        text: 'Texto',
        video: 'Vídeo',
        videoNotSupported: 'Seu navegador não suporta a tag de vídeo.',
        audioNotSupported: 'Seu navegador não suporta a tag de áudio.',
        domains: 'Domínios',
        domain: 'Domínio',
        sitesShortened: 'Sites encurtados',
        videoOther: 'Vídeos (Outros)',
        regular: 'Regular',
        irregular: 'Irregular',
        deleted: 'Excluído',
        URL_SHORTNER: 'Encurtador de links',
        updateTagsInfo: 'Definir tags para links encurtados pode te ajudar a encontrá-lo na busca com facilidade.',
        toCheck: 'Verificar',
        editLinkTags: 'Editar tags do Link',
        undefined: 'Indefinido',
        undefinedGeoLocation: "*Nem sempre é possível obter o estado e a cidade em que o link foi visualizado. Nesses casos, será exibido como 'Indefinido'.",
        copyYoutubeUrl: 'Use uma url de video do youtube. Exemplo https://www.youtube.com/watch?v=dxVaP0-aFIE ou https://www.youtube.com/embed/dxVaP0-aFIE',
        linksErrorVerify: 'Você tem {0} links encurtados cujo o endereço original podem ter deixado de funcionar',
        thisLinkError: 'Algumas pessoas podem ter dificuldade para acessar esse link. Última verificação em ',
        linksErrorTitle: 'Um ou mais links podem ter deixado de funcionar',
        linkErrorTitle: 'Este link pode ter deixado de funcionar. Verifique as possíveis causas.',
        linkErrorCauses: [
            "O usuário com o link precisa estar logado no site do link original. Obs. LinkedIn, Instagram e outras redes sociais necessitam que esteja logado na plataforma para visualizar certos perfis.",
            "Nem todos os usuários podem ter acesso ao link original.",
            "Link copiado em área logada dentro do site original.",
            "O endereço original pode ter sido alterado.", 
            "Link ou URL não existe mais.",
            "Serviço indisponível.",
        ],
        subdomainAlreadyInUSe: 'Esse suddomínio já está em uso',
        xs: 'Smartphone',
        sm: 'Tablet',
        md: 'Notebook',
        lg: 'Computador',
        xl: 'Televisor',
        notifications: 'Notificações',
        opengraphEditTitle: 'Personalize a Exibição do Link',
        opengraphEditDescription: 'Defina como seu link será exibido nas redes sociais com título, descrição e imagem customizados.',
        opengraphAdvanced: 'Personalizar campos avançados',
        opengraphBackToSimple: 'Voltar para o simples',
        opengraphRefetch: 'Buscar novamente os dados da página de destino e atualizar os campos que não foram personalizados por você',
        opengraphRefetching: 'Buscando dados atualizados na página de destino...',
        opengraphRefetchDone: 'Dados do link atualizados',
        opengraphRefetchPending: 'A atualização ainda está em andamento, tente novamente em instantes',
        opengraphRefetchError: 'Não foi possível iniciar a atualização',
        opengraphPreviewTitle: 'Pré-visualização',
        capturingPreview: 'Capturando pré-visualização...',
        capturingPreviewDone: 'Pré-visualização do link atualizada',
        possibleCauses: 'Possíveis causas:',
        next_billing_at: "Próxima cobrança em",
        start_at: "Iniciou em",
        interval: "Frequência",
        current_cycle_start_at: "Ciclo de cobrança de ",
        current_cycle_billing_at: "Pagamento em ",
        current_cycle_status: "Situação",
        current_cycle_cycle: "Ciclo",
        clearFilter: 'Limpar filtro',
        clearSelection: 'Limpar seleção',
        shortenAddressTitle: `Encurte seu link`,
        shortenAddressMoreTitle: `seu migly pode ser + que 1 encurtador de links`,
        shortenAddressBenefits: [
            {icon: 'md-'}
        ],
        subscriptions: 'Assinaturas',
        shortenAddressBenefit1: `URL personalizável`,
        shortenAddressBenefit2: 'métrica de acessos',
        shortenAddressBenefit3: 'Personalize a pré-visualização do link para redes sociais',
        shortenAddressBenefit4: 'integração com google analytics',
        billed: 'Faturado',
        viewsDesc: 'Clicks ou visualizações nos links gerados no período selecionado',
        withClicks: 'Links com acessos',
        withClicksDesc: 'Links com pelo menos um acesso. Você ainda pode filtrar por datas de início e fim links com ao menos um acesso.',
        withoutClicks: 'Links sem acessos',
        withoutClicksDesc: 'Links sem acesso. Você ainda pode filtrar por datas de início e fim links sem ao menos uma visualização.',
        unbilled: 'Não faturado',
        active: 'Ativo',
        cancel: 'Cancelar',
        canceled: 'Cancelado',
        updateAddress: 'Alterar link',
        access: 'Acessos',
        failed: 'Falhou',
        future: 'Teste',
        start_in: 'Inicia em',
        metrics: 'Métricas',
        cancelSubscrible: 'Cancelar assinatura',
        subsEmptyDesc: 'Assine um plano pago para desbloquear recursos avançados.',
        confirmCancelSubscrible: 'Confirmar',
        toConfirm: 'Confirmar',
        shorten: 'encurtar',
        status: 'Status',
        originalAddress: 'Endereço original',
        shortenAddressInfo: 'Encurte seu link em segundos e compartilhe de forma prática e elegante. Simples, rápido e gratuito!',
        shortenAddressInfoWitoutLogin: `
        <h3>Seu Link Está Pronto! 🚀</h3>
        <p>
Gostou da facilidade? Agora imagine todas as vantagens que você pode ter criando uma conta com a Migly:

Acompanhe suas métricas: Descubra quantas pessoas estão clicando nos seus links, de onde elas vêm e muito mais.
Personalização total: Crie URLs personalizadas que sejam fáceis de lembrar e compartilhe links com a sua marca.
Segurança e controle: Proteja seus links com senhas e defina datas de expiração.
Automatização inteligente: Encurte links automaticamente enquanto navega e gerencie todos os seus links em um único lugar.
Não perca tempo! Crie sua conta agora e desbloqueie o potencial completo da Migly!
        </p>
        `,
        titleCancel: 'Cancelamento de assinatura',
        textCancel: 'Ao cancelar sua assinatura nós não renovamos no mês subsequente. Os benefícios associados ao tipo de plano estarão disponíveis até o final do ciclo.',
        
        SAVED: 'Salvo',
        segments: 'Segmentos',
        geoChartLineInfo: 'Visualizações por estado',
        geoChartBarInfo: 'Visualizações por cidade',
        name: 'Nome',
        age: 'Idade',
        properties: 'Propriedades',
        OPT_IN_REQUIRED: 'Opt-In Solicitado',
        OPT_IN_SENDED: 'Opt-In Enviado',
        OPT_IN_REQUIRED_ERROR: 'Opt-In com falha',
        OPT_IN: 'Opt-In (Aceitaram suas comunicações)',
        OPT_OUT: 'Opt-Out (Recusaram suas comunicações)',
        viewsPerScreenSize: 'Visualizações por tamanho de tela',
        viewsPerScreenSizeDisclaimer: 'A separação é feita por tamanho de tela e não por dispositivo acessado. ',
        textOptOut: '. Click migly.in/o/xXx p/ sair.',
        displayToWindowSizeDescrition: 'Acesso por dispositivos com base no tamanho da tela',
        optOutTitle: 'Não deseja mais receber mensagens do(a) ',
        displays: [
            {id: 'xs', description: 'Telefone pequeno a grande', icon: 'mdi-cellphone', color: '#304FFE'},
            {id: 'sm', description: 'Tablet pequeno a médio', icon: 'mdi-tablet', color: '#3D5AFE'},
            {id: 'md', description: 'Tablet grande para notebook', icon: 'mdi-laptop', color: '#536DFE'},
            {id: 'lg', description: 'Monitor a TVs grandes', icon: 'mdi-monitor', color: '#2962FF'},
            {id: 'xl', description: 'Telas 4k e ultra-wide', icon: 'mdi-television', color: '#2979FF'}
        ],
        sharedOnViews: 'Visualizações por compartilhamento',
        sharedOnViewsDisclaimer: 'Para coletar essa métrica o link precisa ser compartilhado usando o recurso "Compartilhar no" acessado na lista de links ou na Bio migly.',
        configPageLoadInfo: 'Customize sua página de carregamento',
        'contact:already:opt:out:or:number:invalid' : 'Contato já está na lista de exclusão de comunicação ou número inválido',
        platformTitle: 'Plataforma',
        platformDescription: 'Acesso por plataforma',
        utmSourceDescription: 'Acessos por origem (utm_source)',
        referrerDescription: 'Acessos por site de origem (referrer)',
        utmHierarchyTitle: 'Origem do tráfego por campanha (UTM)',
        utmHierarchyDisclaimer: 'Navegue pela origem dos seus acessos: fonte (utm_source), depois mídia (utm_medium), campanha (utm_campaign) e conteúdo (utm_content). Clique em um item para ver o próximo nível.',
        utmHierarchyAllSources: 'Todas as origens',
        utmHierarchyExpandTree: 'Ver árvore completa',
        topLinksTitle: 'Links mais acessados',
        advanced: 'Avançado',
        noData: 'Não encontrado',
        toSendFor: 'Enviar para ',
        SCHEDULED: 'Agendado',
        SENT : 'Enviado',
        ProfitWithUs: 'Lucre conosco',
        PROCESSING: 'Processando',
        processingSmsSend: 'O disparo foi feito, aguarde até enviarmos todas as mensagens.',
        noDataDescription: 'Pesquise por tags, partes da URL ou opções do painel',
        textLimitSms: 'As mensagens tem o limite de 160 caracteres. Alguns mensagens estão superando esse limite. Revise seu template.',
        smsEncodeMessageDescInfo: 'Ao usar palavras acentuadas em suas mensagens o tamanho máximo dela poderá ser reduzido de 160 letras para 70, portanto, tente não utilizar palavras acentuadas.',

        platforms: [
            {id: 'android', color: 'deep-purple accent-4', name: 'Android', icon: 'mdi-android'},
            {id: 'macintosh', color: 'indigo darken-2', name: 'Macintosh (macOS)', icon: 'mdi-apple'},
            {id: 'windows', color: 'blue', name: 'Windows', icon: 'mdi-microsoft-windows'},
            {id: 'iphone', color: 'indigo darken-2', name: 'iPhone (iOS)', icon: 'mdi-apple'},
            {id: 'linux', color: 'primary', name: 'Linux', icon: 'mdi-linux'},
            {id: 'ipad', color: 'indigo darken-2', name: 'iPad (iOS)', icon: 'mdi-apple'},
            {id: 'others', color: 'indigo darken-2', name: 'Outros', icon: 'mdi-crosshairs-question'},



            {id: 'Linux aarch64', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'Win32', color: 'blue', name: '', icon: 'mdi-microsoft-windows'},
            {id: 'Linux armv8l', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'Linux armv7l', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'MacIntel', color: 'indigo darken-2', name: '', icon: 'mdi-apple'},
            {id: 'Linux x86_64', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'Linux i686', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'Linux armv81', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'X11; Linux x86_64', color: 'primary', name: '', icon: 'mdi-linux'},
            {id: 'Win64', color: 'blue', name: '', icon: 'mdi-microsoft-windows'},
            {id: 'PlayStation 4', color: 'red', name: 'PlayStation 4', icon: 'mdi-sony-playstation'},
            {id: 'Windows Phone', color: 'red', name: 'Windows Phone', icon: 'mdi-microsoft-windows'},
            

        ],
        region: 'Região',
        pricing: 'Preço',
        geoTitle: 'Região',
        geoDescription: 'Acesso por região',

        byCountries: 'Paises',
        byStates: 'Estados',
        byCities: 'Cidades',

        onlyIcon: 'apenas ícone',

        shareOn: 'Compartilhar no',
        sharedOn: 'Compartilhado nas redes sociais',
        downloadQrCode: 'Baixar QR Code',
        qrCode: 'QR Code',

        viewsPerRegionDisclaimer: 'Nem sempre é possível obter a região exata da visualização.',
        copyLink: 'Link copiado',
        viewsPerDomains: 'Visualizações por Domínios',
        withoutDomain: 'Sem domínio',
        shareOptions: [
            {icon: 'mdi-whatsapp', description : 'WhatsApp', url: 'https://api.whatsapp.com/send/?text=', color: '#004D40', value: 'w'},
            {icon: 'mdi-facebook', description : 'Facebook', url: 'https://www.facebook.com/sharer.php?u=' , color: '#3b5998', value: 'f'},
            {icon: 'mdi-twitter', description : 'Twitter', url: 'https://twitter.com/intent/tweet?text=', color: '#00acee', value: 't'},
            {icon: 'mdi-linkedin', description : 'LinkedIn', url: 'https://www.linkedin.com/sharing/share-offsite/?url=', color: '#0e76a8', value: 'l'},
            {icon: 'mdi-facebook-messenger', description : 'Messenger', url: 'https://www.messenger.com/login.php?next=', color: '#008ad3', value: 'm'},
            {icon: 'mdi-email', description : 'Email', url: 'mailto:?subject=&body=', color: 'dark', value: 'e'},
            {icon: 'mdi-qrcode-scan', description : 'QRCode', url: null, color: 'dark', value: 'q'},
        ],
        socialOptions: [
            {icon: 'mdi-instagram', name: 'Instagram', url: 'https://instagram.com/'},
            {icon: 'mdi-whatsapp', name: 'WhatsApp', url: 'https://api.whatsapp.com/send/?phone='},
            {icon: 'mdi-facebook', name: 'Facebook', url: 'https://facebook.com/'},
            {icon: 'mdi-twitter', name: 'Twitter', url: 'https://twitter.com/'},
            {icon: 'mdi-linkedin', name: 'LinkedIn', url: 'https://linkedin.com/in/'},
            {icon: 'mdi-youtube', name: 'YouTube', url: 'https://youtube.com/user/'},
            {icon: 'mdi-pinterest', name: 'Pinterest', url: 'https://pinterest.com/'},
            {icon: 'mdi-music-note', name: 'TikTok', url: 'https://tiktok.com/@'},
            {icon: 'mdi-snapchat', name: 'Snapchat', url: 'https://snapchat.com/add/'},
            {icon: 'mdi-reddit', name: 'Reddit', url: 'https://reddit.com/user/'},
            {icon: 'mdi-github', name: 'GitHub', url: 'https://github.com/'},
            {icon: 'mdi-twitch', name: 'Twitch', url: 'https://twitch.tv/'},
            {icon: 'mdi-controller', name: 'Discord', url: 'https://discord.com/users/'},
            {icon: 'mdi-alpha-t', name: 'Telegram', url: 'https://t.me/'}
        ],
        placement: 'Colocação',
        or: 'ou',
        icon: 'Ícone',
        withoutIcon: 'Sem Ícone',
        topOfPage: 'Topo da página',
        bottomOfPage: 'Fim da página',
        sections: 'Seções',
        socialIconsColor: 'Cor dos ícones sociais',
        last7Days: 'Últimos 7 dias',
        last30Days: 'Últimos 30 dias',
        last90Days: 'Últimos 90 dias',
        lastYear: 'Último ano',
        allPeriod: 'Todo período',
        config : "Configurações",
        errorIn: 'Situação',
        verificationOptions: {1: 'Irregular', 0: 'Regular', 3: 'Não verificado'},
        typeIn: 'Método de encurtamento',
        CHROME_EXTENSION: 'Extensão do Google Chrome',
        API: 'Application Programming Interface (API)',
        STANDARD: 'Padrão (painel migly)',
        others: 'Outros',
        yourCompanyOrProductHere: 'Descontos de até 30% na loja e frete grátis! 🐰 ',
        yourCompanyOrProductHereText: `De acessórios a presentes especiais, encontre tudo que precisa!`,
        callToAction: `🛒 Veja mais.`,
        screenLoading: "Tela de Carregamento",
        screenLoadingDescription: "Customize a tela de carregamento definindo a marca e nome da sua empresa ou do seu produto.",
        logoPicture: "A imagem da sua marca",
        siteName: "Nome do site",
        loaderTimeTitle: "Tempo de espera",
        loaderTimeSubtitle: 'Defina o tempo de espera antes de redirecionar para o destino final.',
        loaderTime: "Tempo de exibição até redirecionamento será de ",
        linkInterstitialTitle: "Divulgação neste link",
        linkInterstitialSubtitle: "Personalize o banner e o tempo de espera exibidos só para este link, substituindo a configuração geral da conta.",
        linkInterstitialInactiveInfo: "Ative o switch acima para configurar o banner e o tempo de espera exibidos antes de redirecionar este link.",
        ctaText: "Texto do banner",
        remove: "Remover",
        resourceOnlyPlan: "Recurso disponível somente no plano",
        previewSCreenLoader: "Pré-visualização",
        previewOpenGraph: "Pré-visualização",
        preview: "Pré-visualização",
        editLink: 'Editar link',
        domainAndSubdomain: 'Domínio e subdomínio',
        setDomainAndSubdomain: 'Personalize suas URLs, definindo seu próprio domínio e subdomínio. Esta funcionalidade permite que você utilize sua marca ou identidade visual em cada link encurtado, aumentando a confiança e o reconhecimento da sua marca. Com a possibilidade de usar domínios e subdomínios personalizados, suas URLs podem não ficar mais curtas, mas também mais profissionais e consistentes.',
        setDomainAndSubdomainSuport: 'Para definir um domínio e subdomínio, entre em contato com nosso suporte pelo email contato@exatamente-solucoes.com após assinar o plano empresarial.',
        domainPreviewCode: 'código',
        subdomain: 'Subdomínio',
        editAparenceLink: 'Editar pré-visualização do link',
        editAparenceLinkInfo: 'Esse recurso permite exibir uma pequena pré-visualização para mostrar o conteúdo do link. Aplicativos como facebook, whatsapp e telegram tiram proveito desse recurso.',
        editCodeAndDirectionLink: 'Editar código e direcionamento',
        openGraph: "Personalizar uma visualização de link (Open Graph)",
        openGraphDescription: "Open Graph é uma tecnologia que te permite ter controle sobre como sua página web será compartilhada nas redes sociais.",
        openGraphDescriptionInfo: `Quando o usuário do Facebook curte uma URL com o Open Graph implementado, é criado um vínculo entre o usuário e essa URL.

        Através desse vínculo, será possível interagir com os usuários que a curtiram, da mesma forma que ocorrem as interações com uma página do Facebook.
        
        Por exemplo: publicar atualizações ao usuário, direcionar anúncios e aparecer na seção “Atividades e Interesses” no perfil de quem a curtiu.
        
        Páginas com a implementação enriquecem a experiência do usuário em suas ações de curtir e compartilhar informações.
        
        Além de definir como a página web será representada no feed das redes sociais.`,

        googleAnalitcs: 'Google Analytics',
        googleAnalitcsDescription: 'Você pode integrar seus links encurtados e página biográfica ao google analytics. Veja como obter seu id de medição',
        googleAnalitcsId: 'ID DE MEDIÇÃO',
        googleAnalitcsExample: 'UA-XXXXXX-X ou G-XXXXXXX',
        search: 'Procurar',
        searchNav: 'Buscar links, biopage ou navegar pelo painel',
        goTo: 'Ir para',
        upgradeToPlus: 'Upgrade',
        help: 'Ajuda',
        myAccount: 'Minha Conta',
        settings: 'Configurações',
        links: 'Links',
        link: 'Link',
        newLink: 'Adicionar link',
        newLinkWhatsapp: 'Gere o seu Link do WhatsApp',
        page: 'página',
        tags: 'Tags',
        viewsComparePreviusPeriod: 'Em comparação com o período anterior.',
        orCreateAccount: 'Ou crie sua conta',
        lPMarketingAfiliadosLinks: {
            "header": {
                "title": "Migly - Encurtador de URLs e Ferramentas de Marketing",
                "navigation": ["Benefícios", "Recursos", "Preços", "Depoimentos"],
                "ctaButton": "Comece Agora"
            },
            "hero": {
                "headline": "Potencialize seu Marketing de Afiliados",
                "subheadline": "Encurte URLs, vincule links de afiliados e colete métricas com personalização completa.",
                "ctaButton": "Comece Gratuitamente",
                "imageAlt": "Encurtador de URL"
            },
            "benefits": {
                "title": "Benefícios",
                "items": [
                    {
                        "title": "Encurtamento Fácil",
                        "description": "Transforme seus links longos em URLs curtas e elegantes com facilidade."
                    },
                    {
                        "title": "Rastreio de Cliques",
                        "description": "Monitore o desempenho dos seus links com métricas detalhadas."
                    }
                ]
            },
            "features": {
                "title": "Recursos",
                "items": [
                    {
                        "title": "Personalização de Links",
                        "description": "Customize a tela de carregamento e a aparência dos seus links."
                    },
                    {
                        "title": "Integração Fácil",
                        "description": "Integrate seamlessly with your marketing tools."
                    }
                ]
            },
            "pricing": {
                "title": "Planos e Preços",
                "options": [
                    {
                        "name": "Gratuito",
                        "price": "$0 / mês",
                        "features": ["Encurtamento de URLs", "Rastreio básico de cliques"],
                        "ctaButton": "Assine Agora"
                    },
                    {
                        "name": "Premium",
                        "price": "$10 / mês",
                        "features": ["Todos os recursos gratuitos", "Métricas avançadas", "Suporte prioritário"],
                        "ctaButton": "Assine Agora"
                    }
                ]
            },
            "testimonials": {
                "title": "Depoimentos",
                "items": [
                    {
                        "quote": "O Migly transformou a maneira como eu gerencio meus links de afiliados.",
                        "author": "João Silva, Afiliado Profissional"
                    },
                    {
                        "quote": "Ferramenta indispensável para qualquer estratégia de marketing.",
                        "author": "Maria Fernandes, Especialista em Marketing"
                    }
                ]
            },
            "ctaFinal": {
                "headline": "Pronto para Começar?",
                "subheadline": "Junte-se aos milhares de profissionais que já estão aproveitando o Migly.",
                "ctaButton": "Cadastre-se Gratuitamente"
            },
            "footer": {
                "text": "&copy; 2024 Migly. Todos os direitos reservados.",
                "links": ["Política de Privacidade", "Termos de Uso", "Contato"]
            }
        },
        enterYourWhatsappNumber: 'Digite seu número de telefone do WhatsApp',
        ddiDescrition: "Código do país",
        phoneNumber: "Número de telefone",
        whatspaMessage: "Mensagem do WhatsApp",
        whatspaMessageFormated: "Mensagem do WhatsApp formatada",
        invalidPhone: "Número de telefone inválido",
        addEmoji: "Adicionar Emoji ",
        test: "Testar",
        sellInfoproducts: 'Venda infoprodutos',
        generateAuthorization: 'Gerar token de acesso',
        authorization : 'Autorização',
        templateSMS: 'Modelo da mensagem (Texto do SMS)',
        clickToCopy: 'Clique para copiar',
        swaggerUi: 'Veja nossa api doc',
        expiredAt: 'Expira em',
        advancedConfiguration: 'Configurações avançadas',
        moveForward: 'Avançar',
        sms: 'SMS',
        sendSms: 'disparo de SMS',
        sendSmsTextInfo: 'Alcance seu público com facilidade e segurança. Personalize mensagens, agende disparos e não precisa de assinatura. Assinantes Pro ganham R$4 em créditos para testar. Potencialize seu marketing agora!',
        sendSmsBtn: 'Envie Mensagens',
        comingSoon: 'Em breve',
        sendSMSLeedBtn: 'Entre em contato',
        tryPlan: 'teste 7 dias grátis',
        tryMigly: 'Teste o migly',
        register: 'cadastrar-se',
        analytcsTitle: `desempenho do seu migly`,
        analytcsSubTitle: `acompanhe as estastisticas do seus links`,
        analytcsDescription: `Analytics em encurtadores de links oferecem insights vitais para otimizar estratégias. Medindo cliques, origens e comportamento dos usuários, você maximiza engajamento e ROI. Essencial para tomadas de decisão informadas e sucesso online.`,
        smsCarrosel: [
            {title: 'Saiba quem clicou nos links enviados', icon: 'mdi-link'},
            {title: 'Envie boletos e lembretes de pagamento', icon: 'mdi-cash-sync'},
            {title: 'Divulgue promoções, ofertas e produtos', icon: 'mdi-storefront'},
            {title: 'Compartilhe notícias e informações', icon: 'mdi-share-variant'},
            {title: 'Comunique agendamentos e lembretes', icon: 'mdi-clock-outline'},
            {title: 'Faça pesquisas de mercado', icon: 'mdi-tag-search'},
            {title: 'API de desenvolvedor disponível', icon: 'mdi-api', comingSoon: true}
        ],
        shootingSendMessages: '',
        sendNew: 'Novo disparo',
        buyCreditsAutomatic: 'Comprar créditos automaticamente quando esgotar.',
        alertChangeBusinessName: 'Ao alterar o nome do negócio, serviço ou programa toda sua base de contatos vai automaticamente para o OPT-OUT e só receberão suas mensagens após concordarem em receber atualizações novamente.',
        cashRefund: 'Adicionar créditos',
        simple: 'Simples',
        dynamics: 'Dinâmica',
        dynamicsYourVariables: 'Com as variáveis que você definiu',
        typeOfMessage_simple_desc:'A Mensagem será idêntica para todos os remetentes',
        typeOfMessage_dynamics_desc: 'A Dinâmica apresenta mudança de valor em parte do texto para cada destinatário.',
        typeOfMessage: 'Tipo de mensagem',
        addVariable: 'Adicionar variável',
        addRecipients: 'Adicionar Destinatários',
        addAll: 'Adicionar todos',
        inclusiveAndExclusiveFilter: 'Use o switch a esquerda dos filtros para alternar entre um filtro inclusivo ou exclusivo.',
        inclusiveFilter: 'Contém ao menos uma das opções selecionadas',
        exclusiveFilter: 'Contém todas as opções selecionadas',
        segmentsTypeFilter_false: 'Filtrando por contatos que tenha pelo menos um dos segmentos selecionados',
        segmentsTypeFilter_true: 'Filtrando por contatos que tenha todos segmentos selecionados',
        findNumber: 'Encontrar número',
        required: 'Obrigatório',
        recipients: 'Destinatários',
        recipients_a: 'Destinatário(s)',
        shortenLinks: 'Encurtar links',
        shortenALink: 'Encurtar links',
        toSend: 'Enviar',
        shootingEdit: 'Editar Disparo',
        variableDefinedUnsed: 'Alguma Variável foi definida, mas não é utilizada',
        scheduledShooting: 'Disparo agendado',
        variables: 'Variáveis',
        unusedLinkInMessage: 'Link não utilizado na mensagem',
        campaign: 'Campanha',
        repeatNumber: 'Número repetido',
        exitsRepeatNumber: 'Existem números repetidos em seus destinátarios.',
        excludeRepeatNumber: 'Excluir números repetidos',
        exitsIvalidNumber: 'Existem números inválidos em seus destinátarios.',
        campaignDesc: 'Descreva a sua campanha com um título e uma breve descrição. Essa informação só é visível nesse painel.',
        shooting: 'Disparo de SMS',
        shootingDesc: 'Defina um texto para o SMS, destinatários e quando as mensagens serão enviadas.',
        toScheduledShootingForSend: 'Disparo agendado para ',
        timeZone: 'Fuso horário',
        close: 'Fechar',
        checkDiscount: 'Conferir',
        hidePromotion: 'Clique aqui para não exibir mais essa promoção',
        isAProductOf: 'é um produto',
        new: 'Novo',
        invalidSize: 'Tamanho inválido',
        number: 'Número',
        whattsappNumber: 'Número de celular do WhatsApp',
        invalidNumber: 'Número inválido',
        username: 'Nome de usuário', 
        profileDesc: 'Defina sua imagem de perfil e foto de capa.',
        about: 'Sobre',
        aboutDesc: 'Defina um nome de usuário, nome e descrição para sua página.',
        bioHeadline: 'Frase de destaque',
        bioHeadlinePlaceholder: 'ex. Product designer',
        bioLocationStatus: 'Status atual',
        bioLocationStatusPlaceholder: 'ex. In the feedback loop.',
        primaryLink: 'Link principal',
        setPrimaryLink: 'Definir como link principal',
        online: 'Online',
        seeAllSocialLinks: 'Ver todas as redes sociais',
        socialLinks: 'Redes sociais',
        generalAparence: 'Aparência geral',
        generalAparenceDesc: 'Defina as cores e o texto da página',
        background: 'Fundo',
        backgroundColor: 'Cor de fundo',
        headerColor: 'Cor do cabeçalho',
        color: 'Cor',
        textColor: 'Cor do texto',
        socials: 'Redes Sociais',
        selectYourSocialNetworks: 'Inclua links para suas redes sociais',
        follow: 'Seguir',
        instagramFollowers: 'seguidores',
        watchOnYoutube: 'Assista no YouTube',
        instagramFollowing: 'seguindo',
        addRecipientByFile: 'Usar CSV',
        shape: 'Forma',
        font: 'Fonte',
        roboto: 'Roboto',
        'open-sans': 'Open Sans',
        lora: 'Lora',
        montserrat: 'Montserrat',
        merriweather: 'Merriweather',
        raleway: 'Raleway',
        'noto-serif-oriya' : 'Noto Serif Oriya',
        'architects-daughter' : 'Architects Daughter',
        'permanent-marker-regular' : 'Permanent Marker',
        shapeDesc: 'Forma da seção com suavidade das bordas, preenchimento ou sombra',
        shadow: 'Sombra',
        sectionsAndlinks: 'Links e seções',
        content: 'Conteúdo',
        sectionColor: 'Cor das seções',
        sectionTextColor: 'Cor dos textos das seções',
        problens: 'Problemas',
        loadCsv: 'Carregar CSV',
        FAILURE: 'Falhou no envio',
        accept: 'Aceitar',
        refused: 'Recusar',
        termsOfUse: 'Termos de uso',
        privacyPolicy: 'Política de privacidade',
        sendFailedShooting: 'Sua conta precisa ter créditos os suficiente no momento do disparo das mensagens. Verifique seu saldo.',
        smsTemplateExemples: [
            {title: 'Exemplo de arquivo simples preenchido somente com número do contato', img: '/sms/templates/template-1.png', description: 'obs.: Os campos segmentos e tags não obrigatórios.'},
            {title: 'Exemplo de arquivo preenchido com número, segmentos e tags', img: '/sms/templates/template-2.png', description: 'obs.: Os segmentos e tags são separados por vírgulas.'},
            {title: 'Exemplo de arquivo preenchido com número, segmentos, tags e propriedades do contato', img: '/sms/templates/template-3.png', description: 'obs.: Você pode definir qualquer nome para as respectivas colunas após a coluna Tags, pois essas são colunas referentes as propriedades do contato. nome e idade são somente exemplos, você pode definir quantas propriedades quiser, só tenha em mente que o texto do SMS tem limitação de caracters no caso de usar alguma propriedade na mensagem dinâmica.'}
        ],
        userSignTermsAndPrivacyPolicy: 'Termos de uso e política de privacidade',
        optInAndOptOutInfo: 'Seus contatos cadastrados devem optar por receber suas mensagens.',
        infoSegmentsAndTags: 'Definir Segmentos, tags e propriedades pode te ajudar a agrupar seus contatos para configurar seus disparos de SMS.',
        contacts: 'Contatos',
        downloadFileTemplate: 'Baixar arquivo de template',
        addRecipientByFileDesc: 'Carregue uma lista de contatos a partir de um arquivo CSV. Caso precise, use o modelo abaixo como exemplo.',
        timeZoneDiferneteForThisClient: 'Fuso horário diferente para esse contato',


        youWillBeRedirectedTo: 'Você será redirecionado para',
        cencelRedirected: 'Cancelar direcionamento',
        sponsoredAdMaxDiscountTag: 'Até -80%',
        sponsoredAdGenericDescription: 'Oferta especial por tempo limitado.',
        sponsoredAdCta: 'Ver oferta',
        sponsoredAdLabel: 'Anúncio',
        continueToDestination: 'Continuar',
        redirectOwnerUpsellText: 'Esse anúncio aparece porque este link está no plano gratuito. No PRO, você decide: coloca sua própria divulgação aqui ou remove os anúncios.',
        adCategoryAccessories: 'Acessórios',
        adCategoryFood: 'Alimentos',
        adCategoryBeauty: 'Beleza',
        adCategoryShoes: 'Calçados',
        adCategoryHome: 'Casa',
        adCategoryElectronics: 'Eletrônicos',
        adCategoryGeneral: 'Ofertas',
        adCategoryKids: 'Infantil',
        adCategoryWomensFashion: 'Moda Feminina',
        adCategoryMensFashion: 'Moda Masculina',
        adCategoryStationeryArt: 'Papelaria & Arte',
        adCategoryPet: 'Pet',
        adCategoryHealth: 'Saúde',
        infoprodutosAndLeeds: 'página de vendas e leads',
        infoprodutosAndLeedsTextInfo: `Acelere o processo de criação de páginas de vendas com captura de leads, mesmo sem experiência técnica. Utilize modelos otimizados para aumentar suas conversões e expandir sua base de leads. Automatize a geração de leads para impulsionar o marketing. Experimente nosso sistema e transforme visitantes em leads qualificados instantaneamente.`,
        pageType: 'Tipo de Página',
        leedsPage: 'Página para coleta de leads',
        orIn: 'ou em',
        infoproductResourceResponsability: 'Responsabilidade de Uso de PDFs e Imagens',
        infoproductResourceResponsabilityDesc: `<i><p>Ao utilizar PDFs e imagens em nosso sistema, você concorda em assumir total responsabilidade pelo conteúdo e direitos autorais associados a esses arquivos. Certifique-se de possuir os direitos autorais necessários para compartilhá-los e de que seu conteúdo seja adequado e respeite nossos termos de serviço.</p>
        <p>Você é responsável por garantir que nenhum material ilegal, difamatório, obsceno ou ofensivo seja compartilhado. Além disso, certifique-se de não incluir informações confidenciais ou pessoais sem a devida autorização.</p>
        <p>Por favor, esteja ciente de que qualquer violação de direitos autorais, privacidade ou outros direitos legais decorrentes do uso inadequado de PDFs e imagens em nosso sistema será de sua responsabilidade.</p></i>`,
        createYourLeedPage: 'Crie sua página para coleta de leads',
        leedsDescription: 'Captura os dados de quem se interessou pelo seu produto antes de liberar o acesso ou download — você fica com o contato de cada lead, mesmo que ele não converta na hora.',
        title: 'Titulo',
        description: 'Descrição',
        disclosure: 'Divulgação',
        disclosureDescription: 'Aproveite a tela de carregamento para promover seus sites, produtos ou serviços de forma eficaz. Maximize a visibilidade e alcance do seu negócio enquanto seus usuários aguardam o direcionamento!',
        smsInfoLinks: 'Ao incluir uma url no texto da mensagem a ferramenta vai encurta-ló automáticamente e vinculará ao destinatário do SMS, assim você saberá quais clientes acessaram os links',
        whatssInfoShortenLinks: 'Ao incluir links na mensagem o mesmo será encurtado automáticamente.',
        autoWhatssShortenLinks: "Encurtar links na mensagem",
        leeds: 'Leads',
        update: 'Atualizar',
        exportCsv: 'Exportar CSV',
        exportingCsv: 'Exportando CSV',
        imageBanner: 'Banner',
        siteHeader: 'Topo do Site',
        colorSiteHeader: 'Cor do topo do site',
        titleColor: 'Cor do título',
        subtitleColor: 'Cor do subtitulo',
        shortDescriptionColor: 'Cor da breve descrição',
        btnActionColor: 'Cor do botão de ação',
        btnActionTextColor: 'Cor do texto dp botao de ação',
        itensTitleColor: 'Cor do texto to título dos itens',
        itensColor: 'Cor dos itens',
        descriptionBackgroundColor: 'Cor de fundo da descrição',
        descriptionColor: 'Cor da descrição',
        formColor: 'Cor do formulário',
        footerBackgroundColor: 'Cor do fundo do rodapé',
        footerTextColor: 'Cor do texto do rodapé',

        infoproductCreateBy: 'Página criada por',
        infoproductContactTitle: 'Formulário de contato',
        colorInfoproductMore: 'Cor de fundo da descrição',
        novelty: 'Novidade',
        withGoogle: 'Com o Google',
        profile: 'Perfil',
        music: 'Música',
        article: 'Artigo',
        game: 'Game',
        siteType: 'Página web',
        setAllPeriod: 'Informe o período completo',
        setStartPeriod: 'Informe o ínicio do período',
        setEndPeriod: 'Informe o fim do período',
        filterDashBoardTitle: 'Filtro',
        timeUnit: 'Dados agregados por',
        selectEndDate: '--',
        siteTypeSubtitle: 'Confirme que esta é uma página de captura de leads e aceite a responsabilidade pelo conteúdo que você vai enviar.',
        infoproductContactEmailInfo: 'O email sempre fará parte do formulário de contato',
        textField: 'Campo de Texto',
        selecField: 'Seletor',
        textFieldDescription: 'Os componentes dos campos de texto são usados ​​para coletar informações fornecidas pelo usuário.',
        selectFieldDescription: 'Os componentes de campos selecionados são usados ​​para coletar informações fornecidas pelo usuário em uma lista de opções.',
        infoproductFormFieldType: 'Tipo',
        infoproductFormFieldName: 'Nome do campo',
        infoproductFormSelectFildValues: 'Opções disponíveis no seletor',
        infoproductFormFieldValue: 'Valor',
        infoproductFormInputFieldType: `Tipo de entrada`,
        colorfooterBackgroundColor: 'Cor de fundo do radapé',
        alphanumeric: 'Alfanumérico',
        numeric: 'Numérico',
        onlineAddress: 'Endereço online',
        textFieldAlphanumericDescription: 'Uma combinação de caracteres alfabéticos e numéricos',
        selectFieldNumericDescription: 'Uma combinação de caracteres numéricos',
        formField: 'Campo do formulário',
        footerTitle: 'Rodapé do site',
        footerSubtitle: 'Inclua dados da sua empresa, contato e links extras no rodapé da página.',
        infoproductContactSubtitle: 'Monte o formulário que vai capturar os dados do lead antes da entrega. Escolha exatamente quais campos coletar.',
        infoproductProgressLabel: 'Progresso da página',
        infoproductStepLabel: 'Etapa',
        infoproductTitleHint: 'Título principal exibido no topo da sua página de vendas. Seja direto para despertar interesse.',
        infoproductSubtitleHint: 'Texto de destaque exibido acima do título, como um selo ou chamada rápida.',
        infoproductShortDescriptionHint: 'Resumo curto da oferta, exibido logo abaixo do título.',
        infoproductActionHint: 'Texto do botão principal que leva o visitante a agir, como baixar o material ou acessar o conteúdo.',
        infoproductProductImageHint: 'Imagem de destaque do produto, exibida em posição de evidência na página.',
        infoproductItensTitleHint: 'Título da lista de tópicos, temas ou benefícios do seu produto.',
        infoproductDescriptionHint: 'Texto completo sobre o produto, exibido em uma seção dedicada mais abaixo na página.',
        infoproductResourceHint: 'Arquivo em PDF entregue ao visitante após o preenchimento do formulário.',
        infoproductFormFieldNameHint: 'Nome exibido acima do campo no formulário de captura, como "Nome completo" ou "WhatsApp".',
        infoproductFooterTextHint: 'Informações institucionais exibidas no rodapé da página, como dados da empresa ou aviso legal.',
        infoproductPreviewDevicesTitle: 'Veja como sua página vai aparecer no celular do seu lead.',
        infoproductPanelSubtitle: 'Crie páginas de vendas com formulário de captura de lead a partir dos seus links.',
        infoproductNavBenefits: 'Benefícios',
        infoproductNavAbout: 'Sobre',
        infoproductNavContact: 'Contato',
        emptyInfoproductsTitle: 'Você ainda não criou nenhuma página de vendas',
        emptyInfoproductsSubtitle: 'Crie sua primeira página de vendas com captura de lead a partir de um link.',
        emptyLeadsTitle: 'Nenhum lead capturado ainda',
        emptyLeadsSubtitle: 'Os leads que preencherem o formulário desta página vão aparecer aqui.',
        everyoneThat: 'Todos que',
        allInFilter: 'Correspondam ao seguinte filtro',
        document: 'Documento',
        contact: 'Contato',
        cpfCnpj: 'CPF/CNPJ',
        purchase: 'Comprar',
        newContacts: 'Pendente inclusão',
        maxSize: 'Tamanho máximo do arquivo deve ser de {0} e o arquivo atual tem {1}.',

        creditCardNumber: 'Número do cartão de crédito',
        cvv: 'CVV',
        creditCardNamePrinted: 'Nome (como escrito no cartão)',
        expiration: 'Expiração',
        billingAddress: 'Endereço de cobrança',
        publicStreet: 'Rua/Logradouro',
        complement: 'Complemento',
        cep: 'CEP',
        city: 'Cidade',
        state: 'Estado',
        creditCard: 'Cartão de crédito',
        ddi: 'DDI',
        ddd: 'DDD',
        advance: 'Avançar',
        toGoBack: 'Voltar',
        invalidCard: 'Cartão inválido',
        all: 'Todos',
        totalCostWillBe: 'O custo total será de <b>_</b>',
        totalCost: 'O custo total: ',
        cards: 'Cartões',
        cardSelection: 'Selecione o cartão',
        addNewCard: 'Adcionar um novo cartão',
        'invalid.dateTimeScheduled' : 'Data e hora do agendamento inválido',

        'brazil.number.only' : 'Apenas números brasileiros são permitidos',
        'number.invalid.value': 'Número inválido',
        cleanInvalidContacts: 'Remover inválidos',
        'insufient.credits' : 'Crédito insuficiente',
        example: 'Exemplo',
        cookiesRequiredInfo: 'Este site usa cookies para melhorar a experiência de navegação, analisar dados, fazer pesquisas e direcionar propagandas. Para alterar as preferências, clique em "Gerenciar preferências". Ao clicar em "Aceitar todos os cookies", você concorda com o uso de cookies no seu dispositivo. <span id="onetrust-reject-all-banner-desc">Clicar em "Rejeitar todos os cookies" indica que você não concorda com o uso de cookies que não sejam estritamente necessários no seu dispositivo</span>.<a class="link" href="/privacy-policy" aria-label="Mais informações sobre a sua privacidade, abre em uma nova guia" rel="noopener" target="_blank"> Aviso de cookies e rastreamento do migly</a>.',
        metricsAndTimeLine: 'Métricas e linha do tempo',
        'large.sms.text' : 'Algumas mensagens ultrapassam o limite de 160 caracters. Revise seu texto.',
        sendRequireOptInAllSavedInfo: 'Existem _ contatos na lista de exclusão. Para podermos enviar mensagens para eles, é necessário obter permissão. Você pode iniciar o processo enviando uma solicitação de permissão para todos eles, e só poderemos enviar novas mensagens após o contato aceitar receber atualizações. Para solicitar a permissão, é necessário pagar o valor equivalente ao envio de 1 SMS por contato.',
        sendRequireOptInAllSaved: 'Enviar OPT-IN para todos os ',
        last4NumberDigits: 'Informe os 4 últimos dígitos do seu celular',
        smsHelp: 'Dificuldade em utilizar o recurso de envio de SMS em massa? Entre em contato <a class="link" href="emailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>',
        confirmOptInMessage: '<p>Você optou por receber as mensagens do(a) _.</p><p>A cada mensagem recebida você pode optar por não receber mais simplesmente clicando no link dos SMSs recebidos.</p>',
        confirmOptOutMessage: '<p>Você optou por não receber as mensagens do(a) _.</p>',
        emailUnsubscribeTitle: 'Cancelar inscrição nos e-mails do migly?',
        emailUnsubscribeSubtitle: 'Você não vai mais receber nossos e-mails de novidades e dicas.',
        emailUnsubscribeConfirmButton: 'Cancelar inscrição',
        confirmEmailUnsubscribeMessage: '<p>Você não receberá mais e-mails de novidades e dicas do migly.</p>',
        dynamicMessageAlert: 'O SMS não pode ultrapassar o limite de 160 caracters. Ao definir a mensagem como dinâmica a variável no corpo do texto não pode fazer com que o SMS ultrapasse esse limite.',
        scheduleShootingFor: 'Agendar disparo para',
        contactClickedLinks: 'Contatos clicaram neste link',
        googleChromeWebStoreMiglyTitleXS: 'Encurte links',
        manageCookiesPreferencies: 'Gerenciar preferências',
        rejectCookiesPreferencies: 'Rejeitar todos os cookiess',
        acceptAllCookiesPreferencies: 'Aceitar todos os cookies',
        manageCookiesTitle: 'Centro de preferências de privacidade',
        manageCookiesDescription: `<div id="ot-pc-desc">Quando você visita um site, ele pode armazenar ou coletar informações no seu navegador, principalmente na forma de cookies. Essas informações podem ser sobre você, suas preferências ou seu dispositivo e são usadas principalmente para fazer o site funcionar como você espera. As informações normalmente não o identificam diretamente, mas podem oferecer uma experiência na web mais personalizada. Como respeitamos seu direito à privacidade, você pode optar por não permitir alguns tipos de cookies. Clique nos títulos das diferentes categorias para saber mais e alterar nossas configurações padrão. No entanto, o bloqueio de alguns tipos de cookies pode afetar sua experiência no website e os serviços que podemos oferecer.
            <br><a href="/privacy-policy" class="link" rel="noopener" target="_blank" aria-label="Mais informações sobre a sua privacidade, abre em uma nova guia" tabindex="0"> Mais informações</a></div>`,



        cookie_necessary : 'Cookies estritamente necessários',    
        cookie_analytics : 'Cookies de desempenho',
        cookie_advertising : 'Cookies de publicidade',
        cookie_research : 'Cookies de funcionalidade',
        cookie_necessary_desc : 'Estes cookies são necessários para que o website funcione e não podem ser desligados nos nossos sistemas. Normalmente, eles só são configurados em resposta a ações levadas a cabo por si e que correspondem a uma solicitação de serviços, tais como definir as suas preferências de privacidade, iniciar sessão ou preencher formulários. Pode configurar o seu navegador para bloquear ou alertá-lo(a) sobre esses cookies, mas algumas partes do website não funcionarão. Estes cookies não armazenam qualquer informação pessoal identificável.',    
        cookie_analytics_desc : 'Estes cookies permitem-nos contar visitas e fontes de tráfego, para que possamos medir e melhorar o desempenho do nosso website. Eles ajudam-nos a saber quais são as páginas mais e menos populares e a ver como os visitantes se movimentam pelo website. Todas as informações recolhidas por estes cookies são agregadas e, por conseguinte, anónimas. Se não permitir estes cookies, não saberemos quando visitou o nosso site.',
        cookie_advertising_desc : 'Estes cookies podem ser estabelecidos através do nosso site pelos nossos parceiros de publicidade. Podem ser usados por essas empresas para construir um perfil sobre os seus interesses e mostrar-lhe anúncios relevantes em outros websites. Eles não armazenam diretamente informações pessoais, mas são baseados na identificação exclusiva do seu navegador e dispositivo de internet. Se não permitir estes cookies, terá menos publicidade direcionada.',
        cookie_research_desc : 'Estes cookies permitem que o site forneça uma funcionalidade e personalização melhoradas. Podem ser estabelecidos por nós ou por fornecedores externos cujos serviços adicionámos às nossas páginas. Se não permitir estes cookies algumas destas funcionalidades, ou mesmo todas, podem não atuar corretamente.',

        googleChromeWebStoreMiglyTitle: 'melhore sua experiência online com nossa extensão!',
        googleChromeWebStoreMiglySubTitle: 'descubra recursos incríveis e navegue de forma mais eficiente. nossa extensão é rápida, segura e fácil de usar!',
        googleChromeWebStoreMiglyAction: 'instale agora!',
        reportLink: 'Reportar Link',
        termsOfUseHtml : {
            '1.0.0' : `
                <h1>TERMOS DE USO</h1>
                <p style="margin-top: 15px"><i><strong>Última atualização: DATEUPDATE</strong></i></p>
                <p>Bem-vindo ao <strong>Migly</strong>. Estes Termos de Uso regem o uso do Sistema e constituem um acordo legalmente vinculativo entre você e a <strong>Exatamente Soluções Educacionais</strong>.</p>
               
               
                <h2><p>1. Aceitação dos Termos</p></h2>
                <p>Ao acessar ou utilizar o Sistema, você concorda com estes Termos e concorda em cumprir todas as leis e regulamentos aplicáveis. Se você não concorda com estes Termos, não utilize o Sistema.</p>
            
                <h2><p>2. Uso do Sistema</p></h2>
                <h3>2.1. Encurtamento de URLs</h3>
                <p>O Sistema permite que você encurte URLs. Você concorda em usar essa funcionalidade de maneira ética e legal, sem disseminar links maliciosos ou conteúdo ilegal.</p>
            
                <h3>2.2. Disparo de SMS em Massa</h3>
                <p>Se Você utilizar a funcionalidade de disparo de SMS em massa, é responsável por cumprir todas as leis de proteção de dados e regulamentos aplicáveis, incluindo obter o consentimento adequado dos destinatários.</p>
            
                <h2><p>3. Conta do Usuário</p></h2>
                <h3>3.1. Criação de Conta</h3>
                <p>Você pode ser solicitado a criar uma conta para acessar determinadas funcionalidades do Sistema. Você é responsável por manter a confidencialidade de suas informações de conta e por todas as atividades que ocorram sob sua conta.</p>
            
                <h3>3.2. Exclusão de Conta</h3>
                <p>Reservamo-nos o direito de encerrar ou suspender sua conta a nosso critério, se suspeitarmos de atividades fraudulentas, ilegais ou violações destes Termos.</p>
            
                <h2><p>4. Privacidade</p></h2>
                <p>Suas informações pessoais estão sujeitas à nossa Política de Privacidade.</p>
            
                <h2><p>5. Propriedade Intelectual</p></h2>
                <h3>5.1. Propriedade</h3>
                <p>A Exatamente Soluções Educacionais detém todos os direitos de propriedade intelectual relacionados ao Sistema.</p>
            
                <h3>5.2. Abstenção</h3>
                <p>Você concorda em não copiar, reproduzir, distribuir ou criar trabalhos derivados com base no Sistema sem permissão expressa da Exatamente Soluções Educacionais.</p>
            
                <h2><p>6. Limitação de Responsabilidade</p></h2>
                <h3>6.1. Garantias</h3>
                <p>O Sistema é fornecido "como está", sem garantias de qualquer tipo, expressas ou implícitas.</p>
            
                <h3>6.2. Responsabilidade</h3>
                <p>A Exatamente Soluções Educacionais não se responsabiliza por quaisquer danos diretos, indiretos, incidentais, especiais, consequentes ou punitivos decorrentes do uso do Sistema.</p>
            
                <h2><p>7. Disposições Gerais</p></h2>
                <h3>7.1. Termos de uso anteriores</h3>
                <p>Estes Termos representam o acordo integral entre Você e a Exatamente Soluções Educacionais e substituem todos os acordos anteriores.</p>
            
                <h3>7.2. Atualizações</h3>
                <p>Estes Termos podem ser alterados pela Exatamente Soluções Educacionais a qualquer momento, mediante aviso prévio.</p>
            
                <h3>7.3. Jurisdição</h3>
                <p>Estes Termos serão regidos pelas leis do Brasil, Guarapuava - PR e qualquer litígio será submetido à jurisdição exclusiva dos tribunais desta jurisdição.</p>
            
                <p>Ao utilizar o Sistema, Você concorda com estes Termos e está ciente de que o não cumprimento deles pode resultar na suspensão ou encerramento de sua conta. Se tiver alguma dúvida ou preocupação, entre em contato conosco em contato@exatamente-solucoes.com.</p>
            `,
            '1.0.1' : `
    <h1>Termos de Uso</h1>
<p style="margin-top: 15px"><i><strong>Última atualização: DATEUPDATE</strong></i></p>
    <h2>1. Descrição do Serviço</h2>
    <p>O Migly é um encurtador de URLs que possibilita a criação de um agregador de links (link biográfico) e coleta métricas de acesso. Também permite a personalização de URLs e o aproveitamento do tempo de direcionamento para divulgação ou publicidade.</p>

    <h2>2. Condições de Uso</h2>
    <p>Para usar o serviço, o usuário deve:</p>
    <ul>
        <li>Ter no mínimo 18 anos</li>
        <li>Estar em conformidade com as leis locais</li>
    </ul>

    <h2>3. Restrições de Uso</h2>
    <p>Os usuários estão proibidos de:</p>
    <ul>
        <li>Usar o serviço para fins ilegais</li>
        <li>Enviar spam</li>
        <li>Violar direitos de terceiros</li>
        <li>Direcionar para jogos de apostas, pornografia e qualquer ato considerado crime internacional e em território nacional (Brasil)</li>
    </ul>

    <h2>4. Propriedade Intelectual</h2>
    <p>Todo o conteúdo e funcionalidade da aplicação Migly, incluindo, mas não se limitando a textos, gráficos, logotipos e imagens, são de propriedade exclusiva da Exatamente Soluções ou de seus licenciadores e são protegidos pelas leis de propriedade intelectual.</p>

    <h2>5. Limitação de Responsabilidade</h2>
    <p>Nem Migly nem a Exatamente Soluções se responsabilizam pelo endereço final do link encurtado ou por danos causados pelos direcionamentos.</p>

    <h2>6. Modificações no Serviço</h2>
    <p>As políticas serão atualizadas e sempre informadas ao usuário caso alguma regra ou recurso do sistema mude. Os usuários serão notificados após login no painel.</p>

    <h2>7. Rescisão</h2>
    <p>O contrato pode ser rescindido a qualquer momento. No entanto, como o pagamento é pré-pago, após o período de avaliação (sete dias) não será feito o reembolso. O cliente deve ficar atento aos ciclos de pagamento.</p>

    <h2>8. Contato</h2>
    <p>Para suporte e questões relacionadas ao uso da aplicação, entre em contato pelo email: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

    <h2>Extras</h2>
    <p><strong>Jurisdicional e Legislação Aplicável:</strong> Os presentes Termos de Uso são regidos pelas leis do Brasil. Quaisquer disputas serão resolvidas na jurisdição brasileira.</p>
    <p><strong>Atualizações:</strong> Os usuários serão informados sobre atualizações neste documento através de notificação após login no painel.</p>
            `,
            '1.0.2' : `
            <h1>Termos de Uso</h1>
<p style="margin-top: 15px"><i><strong>Última atualização: DATEUPDATE</strong></i></p>

<h2>1. Descrição do Serviço</h2>
<p>O Migly é um encurtador de URLs que possibilita a criação de um agregador de links (link biográfico) e coleta métricas de acesso. Também permite a personalização de URLs e o aproveitamento do tempo de direcionamento para divulgação ou publicidade.</p>

<h2>2. Condições de Uso</h2>
<p>Para usar o serviço, o usuário deve:</p>
<ul>
    <li>Ter no mínimo 18 anos</li>
    <li>Estar em conformidade com as leis locais</li>
</ul>

<h2>3. Restrições de Uso</h2>
<p>Os usuários estão proibidos de:</p>
<ul>
    <li>Usar o serviço para fins ilegais</li>
    <li>Enviar spam</li>
    <li>Violar direitos de terceiros</li>
    <li>Direcionar para jogos de apostas, phishing, pornografia e qualquer ato considerado crime internacional e em território nacional (Brasil)</li>
</ul>
<p>Contas que violarem essas regras poderão ser desativadas sem aviso prévio.</p>

<h2>4. Propriedade Intelectual</h2>
<p>Todo o conteúdo e funcionalidade da aplicação Migly, incluindo, mas não se limitando a textos, gráficos, logotipos e imagens, são de propriedade exclusiva da Exatamente Soluções ou de seus licenciadores e são protegidos pelas leis de propriedade intelectual.</p>

<h2>5. Limitação de Responsabilidade</h2>
<p>Nem Migly nem a Exatamente Soluções se responsabilizam pelo endereço final do link encurtado ou por danos causados pelos direcionamentos.</p>

<h2>6. Modificações no Serviço</h2>
<p>As políticas serão atualizadas e sempre informadas ao usuário caso alguma regra ou recurso do sistema mude. Os usuários serão notificados após login no painel.</p>

<h2>7. Rescisão</h2>
<p>O contrato pode ser rescindido a qualquer momento. No entanto, como o pagamento é pré-pago, após o período de avaliação (sete dias) não será feito o reembolso. O cliente deve ficar atento aos ciclos de pagamento.</p>

<h2>8. Contato</h2>
<p>Para suporte e questões relacionadas ao uso da aplicação, entre em contato pelo email: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

<h2>Extras</h2>
<p><strong>Jurisdicional e Legislação Aplicável:</strong> Os presentes Termos de Uso são regidos pelas leis do Brasil. Quaisquer disputas serão resolvidas na jurisdição brasileira.</p>
<p><strong>Atualizações:</strong> Os usuários serão informados sobre atualizações neste documento através de notificação após login no painel.</p>
            `
        },
        privacyPolicyHtml : {
            '1.0.0' : `
                <h1>POLÍTICA DE PRIVACIDADE</h1>
                <p style="margin-top: 15px"><strong>Última atualização: DATEUPDATE</strong></p>
                
                <p>A sua privacidade é importante para nós. Esta Política de Privacidade descreve como a Exatamente Soluções Educacionais coleta, utiliza, compartilha e protege as informações pessoais dos usuários ao utilizar o sistema Migly.</p>
            
                <h2><p>1. Informações Coletadas</p></h2>
                <h3>1.1. Informações de Registro</h3>
                <p>Quando você cria uma conta no Sistema, podemos coletar informações pessoais, como nome, endereço de e-mail e senha.</p>
            
                <h3>1.2. Informações de Uso</h3>
                <p>Podemos coletar informações sobre como você utiliza o Sistema, incluindo os URLs encurtados e as mensagens SMS enviadas.</p>
            
                <h3>1.3. Informações de Pagamento</h3>
                <p>Podemos coletar informações de pagamento, como dados de cartão de crédito, endereço de cobrança e CPF.</p>
            
                <h2><p>2. Uso das Informações</p></h2>
                <h3>2.1. Fornecimento e Melhoria do Serviço</h3>
                <p>Utilizamos suas informações para fornecer e melhorar o Sistema, incluindo o encurtamento de URLs e o disparo de SMS.</p>
            
                <h3>2.2. Comunicações</h3>
                <p>Podemos usar seu endereço de e-mail para enviar informações sobre o Sistema, atualizações e notícias relevantes.</p>
            
                <h2><p>3. Compartilhamento de Informações</p></h2>
                <p>Não compartilhamos suas informações pessoais com terceiros, a menos que seja necessário para fornecer os serviços solicitados por você ou conforme exigido por lei.</p>
            
                <h2><p>4. Segurança das Informações</p></h2>
                <p>Tomamos medidas razoáveis para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.</p>
            
                <h2><p>5. Acesso e Controle das Suas Informações</p></h2>
                <p>Você pode acessar, corrigir ou excluir suas informações pessoais a qualquer momento, entrando em contato conosco através das informações fornecidas no final desta Política de Privacidade.</p>
            
                <h2><p>6. Cookies e Tecnologias Semelhantes</p></h2>
                <p>O Sistema pode usar cookies e tecnologias semelhantes para melhorar a experiência do usuário. Você pode controlar o uso de cookies nas configurações do seu navegador.</p>
            
                <h2><p>7. Alterações na Política de Privacidade</p></h2>
                <p>Reservamo-nos o direito de atualizar esta Política de Privacidade a qualquer momento. A data da última atualização será indicada no início deste documento.</p>
            
                <h2><p>8. Contato</p></h2>
                <p>Se tiver dúvidas sobre esta Política de Privacidade ou desejar exercer seus direitos de privacidade, entre em contato conosco em:</p>
                <address>
                    <p>AL. ELIO ANTONIO DALLA VECCHIA, 838 Sala 5, 85.040-167, CASCAVEL, GUARAPUAVA - PR
                    <br>
                    contato@exatamente-solucoes.com</p>
                </address>
            `,
            '1.0.1' : `
    <h1>Política de Privacidade</h1>
<p style="margin-top: 15px"><i><strong>Última atualização: DATEUPDATE</strong></i></p>
    <h2>1. Informações Coletadas</h2>
    <p><strong>Dados Pessoais:</strong></p>
    <ul>
        <li>Nome</li>
        <li>Email</li>
        <li>Foto de perfil</li>
        <li>Para assinantes: CIF, nome completo, dados do cartão de crédito (intermediados pelo sistema de pagamento Pagar.me)</li>
    </ul>
    <p><strong>Dados de Navegação:</strong></p>
    <ul>
        <li>URLs acessadas e abas abertas no navegador para usuários da extensão para Google Chrome</li>
    </ul>

    <h2>2. Uso das Informações</h2>
    <p>As informações coletadas são utilizadas para:</p>
    <ul>
        <li>Personalização de serviços</li>
        <li>Melhoria da aplicação</li>
        <li>Análises estatísticas</li>
        <li>Coleta e publicidade direcionada para usuários do Migly que clicam no link encurtado</li>
    </ul>
    <p>Não compartilhamos essas informações com terceiros.</p>

    <h2>3. Armazenamento e Segurança</h2>
    <p>As informações são armazenadas em bancos de dados seguros e servidores protegidos. Os dados de pagamento são mantidos pela Pagar.me. Para mais informações sobre a política de privacidade da Pagar.me, consulte <a href="https://migly.in/xC61">aqui</a>.</p>

    <h2>4. Direitos dos Usuários</h2>
    <p>Os usuários têm direito a:</p>
    <ul>
        <li>Acesso aos seus dados</li>
        <li>Correção de dados incorretos</li>
        <li>Exclusão dos seus dados</li>
    </ul>
    <p>Os usuários podem exercer esses direitos enviando um email para: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

    <h2>5. Cookies e Tecnologias Semelhantes</h2>
    <p>Utilizamos cookies para:</p>
    <ul>
        <li>Direcionar publicidade aos usuários dos links encurtados</li>
        <li>Coletar preferências de consumo</li>
    </ul>
    <p>Os dados coletados não são correlacionados a um usuário especificamente.</p>

    <h2>6. Contato</h2>
    <p>Para questões relacionadas à privacidade, entre em contato com Exatamente Soluções pelo email: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

    <h2>Extras</h2>
    <p><strong>Jurisdicional e Legislação Aplicável:</strong> A presente Política de Privacidade é regida pelas leis do Brasil. Quaisquer disputas serão resolvidas na jurisdição brasileira.</p>
    <p><strong>Atualizações:</strong> Os usuários serão informados sobre atualizações neste documento através de notificação após login no painel.</p>            
            `,
            '1.0.2' : `
            <h1>Política de Privacidade</h1>
<p style="margin-top: 15px"><i><strong>Última atualização: DATEUPDATE</strong></i></p>

<h2>1. Informações Coletadas</h2>
<p><strong>Dados Pessoais:</strong></p>
<ul>
    <li>Nome</li>
    <li>Email</li>
    <li>Foto de perfil</li>
    <li>Para assinantes: CIF, nome completo, dados do cartão de crédito (intermediados pelo sistema de pagamento Pagar.me)</li>
</ul>
<p><strong>Dados de Navegação:</strong></p>
<ul>
    <li>URLs acessadas e abas abertas no navegador para usuários da extensão para Google Chrome</li>
</ul>

<h2>2. Uso das Informações</h2>
<p>As informações coletadas são utilizadas para:</p>
<ul>
    <li>Personalização de serviços</li>
    <li>Melhoria da aplicação</li>
    <li>Análises estatísticas</li>
    <li>Coleta e publicidade direcionada para usuários do Migly que clicam no link encurtado</li>
</ul>
<p>Não compartilhamos essas informações com terceiros.</p>

<h2>3. Armazenamento e Segurança</h2>
<p>As informações são armazenadas em bancos de dados seguros e servidores protegidos. Os dados de pagamento são mantidos pela Pagar.me. Para mais informações sobre a política de privacidade da Pagar.me, consulte <a href="https://migly.in/xC61">aqui</a>.</p>

<h2>4. Direitos dos Usuários</h2>
<p>Os usuários têm direito a:</p>
<ul>
    <li>Acesso aos seus dados</li>
    <li>Correção de dados incorretos</li>
    <li>Exclusão dos seus dados</li>
</ul>
<p>Os usuários podem exercer esses direitos enviando um email para: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

<h2>5. Cookies e Tecnologias Semelhantes</h2>
<p>Utilizamos cookies para:</p>
<ul>
    <li>Direcionar publicidade aos usuários dos links encurtados</li>
    <li>Coletar preferências de consumo</li>
</ul>
<p>Os dados coletados não são correlacionados a um usuário especificamente.</p>

<h2>6. Contato</h2>
<p>Para questões relacionadas à privacidade, entre em contato com Exatamente Soluções pelo email: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

<h2>Extras</h2>
<p><strong>Jurisdicional e Legislação Aplicável:</strong> A presente Política de Privacidade é regida pelas leis do Brasil. Quaisquer disputas serão resolvidas na jurisdição brasileira.</p>
<p><strong>Atualizações:</strong> Os usuários serão informados sobre atualizações neste documento através de notificação após login no painel.</p>

            `
        },
        creationDate: 'Criação do link',
        filters: 'Filtros',
        addressType: 'Método de encurtamento',
        addressTypeDesc: 'É a fonte que gerou o link curto.',

        addressType_ALL: 'Todos os tipos',
        addressType_API: 'API',
        addressType_CHROME_EXTENSION: 'Extensão do Google Chrome',
        addressType_STANDARD: 'Este Painel (site)',
        addressType_BIO: 'Biolink (meu migly)',
        addressType_SMS: 'SMSs',
        addressType_INFOPRODUCT: 'Infoprodutos',
        addressTypeDesc_API: 'Links encurtados pela API de desenvolvedor',
        addressTypeDesc_CHROME_EXTENSION: 'Links encurtados a partir d extensão do Google Chrome',
        addressTypeDesc_STANDARD: 'Links ecurtados por este Painel',
        addressTypeDesc_BIO: 'Links associados ao seu biolink (meu migly)',
        addressTypeDesc_SMS: 'Links encurtados associados ao disparo e agendamento de SMSs',
        addressTypeDesc_INFOPRODUCT: 'Links para seus Infoprodutos',
        orderBy: 'Ordenar',
        draggableLinksInfo: 'Arraste e solte para Ordenar os links',
        dateCreateOrderByASC: 'Mais antigos',
        dateCreateOrderByDESC: 'Mais recentes',
        clicksOrderByASC: 'Menos acessados',
        clicksOrderByDESC: 'Mais acessados',
        toSee: 'Ver',
        'invalid.subscription' : 'Assinatura inválida',
        share: 'Compartilhar',
        situation: 'Situação',
        situationDesc: 'Todos os dias é feita uma verificação dos endereços dos links encurtados, quando um link falha na verificação a situação passa a ser irregular.',
        tagsFilterLabel: 'Tags dos links/campanhas',
        tagsFilterDesc: 'Filtre pela tag que você usa para organizar seus links por campanha.',
        tagsFilterPlaceholder: 'Buscar tag...',
        clear: 'Limpar',
        clearFilters: 'Limpar filtros',
        apply: 'Aplicar',
        creationDateDesc: 'Datas de quando o link foi gerado. Você pode limitar por datas início e fim.',
        results: 'resultados',
        notVerified: 'Não verificado',
        withoutNotifications: 'Sem notificações',
        createYoutMiglyPage: `Crie seu migly`,
        bioBrandCtaTitle: 'Crie seu perfil no migly',
        bioBrandHome: 'Início',
        bioBrandPrivacyPolicy: 'Política de privacidade',
        bioBrandPlans: 'Planos e preços',
        infoYouMiglyPage: `O meu migly conecta todas suas páginas, post nas redes sociais, videos no youtube, qualquer conteúdo ou projeto que você tenha online em uma única página biográfica.
               Além de um link curto você terá um QRCode associado a sua bio. Imprima e facilite o acesso ao seus projetos.`,
        shortenWithMigly: 'Encurte com o migly',
        notifyNoLinksTitle: 'Encurte seu primeiro link',
        notifyNoLinksSubtitle: 'Transforme uma URL grande em um link curto, acompanhe cliques e métricas em tempo real e personalize a aparência para o WhatsApp, Instagram e outras redes.',
        notifyNoOpenGraphTitle: 'Personalize a aparência dos seus links',
        notifyNoOpenGraphSubtitle: 'Adicione imagem, título e descrição para que seus links fiquem assim ao serem compartilhados:',
        notifyOpenGraphExampleDomain: 'seudominio.com/promo',
        notifyOpenGraphExampleTitle: 'Título do seu link',
        notifyOpenGraphExampleDescription: 'Uma breve descrição chamativa para redes sociais',
        notifyNoConfigSubtitle: 'Defina a marca e o tempo de espera exibidos entre o clique e o redirecionamento dos seus links.',
        notifyCarouselTitle: 'O que você pode fazer com o migly',
        notifyCarouselLoadingPage: 'Tela de carregamento',
        personalizeCta: 'Personalizar',
        newsMiglyTitle: 'Novidades do migly',
        newsMiglySubtitle: 'Encurtamento, personalização e coleta de métricas',
        SHORTEN_LINKS: 'Encurtador',
        seoPillarUtm: {
            h1: 'Gerador de UTM com painel de origem de tráfego',
            intro: 'Crie links com parâmetros UTM, encurte no mesmo passo e veja exatamente de onde vêm seus cliques — por fonte, mídia, campanha e conteúdo — direto no painel do Migly.',
            problem: {
                title: 'Sem UTM, você sabe quantos cliques teve — mas não de onde vieram',
                body: 'A contagem de cliques sozinha não diz se o resultado veio do story do Instagram, de um e-mail ou de um anúncio pago. Sem esse dado, fica difícil saber onde investir mais tempo ou dinheiro na próxima campanha.',
            },
            solution: {
                title: 'Uma UTM por campanha, um painel para todas',
                body: 'O Migly gera o link já com os parâmetros UTM aplicados e organiza automaticamente os cliques por fonte, mídia, campanha e conteúdo — sem planilha, sem processo manual.',
            },
            benefitsTitle: 'Por que rastrear com UTM',
            benefits: [
                { icon: 'mdi-target', title: 'Saiba o que funciona', description: 'Compare o desempenho de cada rede, campanha ou anúncio lado a lado, sem depender de estimativa.' },
                { icon: 'mdi-link-variant', title: 'Um único link para tudo', description: 'O link com UTM já sai encurtado — não é preciso gerar a UTM em um lugar e encurtar em outro.' },
                { icon: 'mdi-chart-timeline-variant', title: 'Decisão baseada em dado', description: 'Direcione orçamento e tempo para os canais que realmente geram clique e conversão.' },
            ],
            howItWorksTitle: 'Como funciona',
            steps: [
                { title: 'Cole a URL de destino', description: 'Adicione os parâmetros UTM (source, medium, campaign) na própria URL de destino ao criar o link.' },
                { title: 'O Migly encurta e rastreia', description: 'O link curto gerado já carrega a UTM internamente — nenhum passo extra.' },
                { title: 'Compartilhe em cada canal', description: 'Use uma UTM diferente para cada rede, campanha ou anúncio que quiser comparar.' },
                { title: 'Acompanhe no painel', description: 'Veja a origem de cada clique detalhada por fonte, mídia, campanha e conteúdo, com opção de detalhar cada nível.' },
            ],
            featuresTitle: 'O que o painel de UTM do Migly mostra',
            features: [
                { icon: 'mdi-source-branch', title: 'Drill-down por camada', description: 'Comece pela fonte (utm_source) e desça até campanha e conteúdo sem sair da mesma tela.' },
                { icon: 'mdi-cursor-default-click', title: 'Cliques em tempo real', description: 'Cada clique aparece no painel assim que acontece, sem atraso de processamento.' },
                { icon: 'mdi-crown-outline', title: 'Disponível no PRO e Business', description: 'O drill-down completo (fonte → mídia → campanha → conteúdo) faz parte dos planos PRO e Business.' },
            ],
            useCasesTitle: 'Para quem serve',
            useCases: [
                { title: 'Afiliados', description: 'Compare o desempenho de cada rede social ou grupo de WhatsApp onde você divulga um mesmo produto.' },
                { title: 'Lançamentos', description: 'Meça se o tráfego de um lançamento veio mais de e-mail, anúncio pago ou bio do Instagram.' },
                { title: 'Times de marketing', description: 'Padronize a nomenclatura de campanhas entre vários responsáveis, com um painel único para todos os links.' },
            ],
            faqTitle: 'Perguntas frequentes sobre UTM',
            crossPillar: {
                text: 'Se você trabalha com links de afiliado, uma UTM sozinha só mostra a origem do clique — combine com um',
                label: 'encurtador de link feito para afiliados',
                href: '/encurtador-de-link-para-afiliados',
            },
            internalLinksTitle: 'Aprenda mais sobre UTM',
            internalLinks: [
                { label: 'O que é UTM?', href: '/blog/o-que-e-utm' },
                { label: 'O que é UTM Source', href: '/blog/o-que-e-utm-source' },
                { label: 'O que é UTM Medium', href: '/blog/o-que-e-utm-medium' },
                { label: 'O que é UTM Campaign', href: '/blog/o-que-e-utm-campaign' },
                { label: 'O que é UTM Content', href: '/blog/o-que-e-utm-content' },
                { label: 'Como criar uma UTM', href: '/blog/como-criar-utm' },
            ],
            ctaPrimaryLabel: 'Começar gratuitamente',
            ctaSecondaryLabel: 'Conhecer o Migly',
        },
        seoPillarAfiliados: {
            h1: 'Encurtador de link para afiliados com rastreio de cliques',
            intro: 'Encurte seus links de afiliado, adicione UTM e veja quantos cliques cada campanha, rede ou conteúdo gerou — tudo no mesmo painel, sem depender do relatório de cada plataforma.',
            problem: {
                title: 'Cada plataforma de afiliado mostra um pedaço da história',
                body: 'Hotmart, Eduzz e Kiwify mostram vendas, mas raramente mostram de onde veio o clique que não converteu. Sem esse dado, fica difícil saber se o problema foi tráfego fraco ou oferta fraca.',
            },
            solution: {
                title: 'Um link encurtado, rastreado do clique à campanha',
                body: 'O Migly encurta o link de afiliado e registra cada clique com origem, dispositivo e região — e, quando o link usa UTM, também por fonte, mídia e campanha.',
            },
            benefitsTitle: 'Por que usar o Migly para links de afiliado',
            benefits: [
                { icon: 'mdi-cursor-default-click', title: 'Veja cada clique, não só a venda', description: 'Saiba quantas pessoas clicaram antes mesmo de qualquer conversão acontecer na plataforma do produto.' },
                { icon: 'mdi-infinity', title: 'Sem limite e sem expiração', description: 'Links criados no Migly não expiram e não têm limite de cliques em nenhum plano.' },
                { icon: 'mdi-share-variant-outline', title: 'Pronto para qualquer rede', description: 'Use o mesmo link curto na bio, em grupos, no WhatsApp ou em anúncios pagos.' },
            ],
            howItWorksTitle: 'Como funciona',
            steps: [
                { title: 'Cole o link de afiliado', description: 'Cole a URL de afiliado da Hotmart, Eduzz, Kiwify ou de qualquer outra plataforma.' },
                { title: 'Adicione UTM (opcional)', description: 'Inclua parâmetros UTM na URL para saber depois de onde veio cada clique.' },
                { title: 'Compartilhe o link curto', description: 'Use o link gerado em bio, redes sociais, grupos ou anúncios.' },
                { title: 'Acompanhe os cliques', description: 'Veja no painel quantos cliques, de onde e em qual dispositivo, por link ou por campanha.' },
            ],
            featuresTitle: 'O que você tem em cada link',
            features: [
                { icon: 'mdi-chart-arc', title: 'Relatório completo', description: 'Cliques por dispositivo, região e plataforma para cada link criado.' },
                { icon: 'mdi-qrcode', title: 'QR Code incluso', description: 'Gere um QR Code para o mesmo link, útil para materiais impressos ou stories.' },
                { icon: 'mdi-bio', title: 'Vira página de bio', description: 'O mesmo link pode se tornar uma página de bio reunindo vários dos seus links de afiliado.' },
            ],
            useCasesTitle: 'Para quem serve',
            useCases: [
                { title: 'Afiliados iniciantes', description: 'Comece a entender de onde vem seu tráfego antes mesmo da primeira venda.' },
                { title: 'Produtores com equipe de afiliados', description: 'Compartilhe um padrão de link rastreável para toda a equipe usar.' },
                { title: 'Quem divulga em vários canais', description: 'Compare bio do Instagram, grupo de WhatsApp e e-mail lado a lado.' },
            ],
            faqTitle: 'Perguntas frequentes sobre encurtador para afiliados',
            crossPillar: {
                text: 'Quer comparar o desempenho de cada campanha ou rede social? Combine seus links de afiliado com um',
                label: 'gerador de UTM',
                href: '/gerador-de-utm',
            },
            internalLinksTitle: 'Conteúdo relacionado',
            internalLinks: [
                { label: 'Como rastrear cliques em links', href: '/blog/como-rastrear-cliques-em-links' },
                { label: 'O que é UTM?', href: '/blog/o-que-e-utm' },
                { label: 'Página de vendas para afiliados', href: '/pagina-de-vendas-para-afiliados' },
            ],
            ctaPrimaryLabel: 'Começar gratuitamente',
            ctaSecondaryLabel: 'Conhecer o Migly',
        },
        seoPillarPaginaDeVendas: {
            h1: 'Página de vendas para afiliados com captura de lead',
            intro: 'Transforme o link que você já usa em uma página de vendas com formulário de captura — para não perder o contato de quem clicou mas não comprou no checkout de outra plataforma.',
            problem: {
                title: 'O checkout de outra plataforma não devolve o contato de quem não comprou',
                body: 'Você manda tráfego pago ou orgânico para o checkout da Hotmart, Eduzz ou Kiwify, mas quem clica e não compra na hora simplesmente desaparece — sem e-mail, sem WhatsApp, sem segunda chance de venda.',
            },
            solution: {
                title: 'Um link, uma página de vendas, um formulário de captura',
                body: 'O Migly transforma o destino do seu link em uma página de vendas com título, descrição, imagem da marca e um formulário de captura — o contato de quem clicar fica registrado no seu painel, mesmo que a venda não aconteça na hora.',
            },
            benefitsTitle: 'Por que criar uma página de vendas no Migly',
            benefits: [
                { icon: 'mdi-account-arrow-right-outline', title: 'Nunca perca um lead', description: 'Cada contato capturado fica salvo no seu painel, pronto para você entrar em contato depois.' },
                { icon: 'mdi-palette-swatch-outline', title: 'Sua marca, sua cara', description: 'Personalize cores, imagem e descrição da página para combinar com o seu produto ou oferta.' },
                { icon: 'mdi-link-variant', title: 'Mesmo link que você já usa', description: 'Não precisa de outra ferramenta — o link encurtado que você já divulga se torna a página de vendas.' },
            ],
            howItWorksTitle: 'Como funciona',
            steps: [
                { title: 'Configure sua página', description: 'Defina título, descrição, imagem e o formulário de captura que quer usar.' },
                { title: 'Associe ao seu link', description: 'Escolha esse destino para o link encurtado que você já divulga ou crie um novo.' },
                { title: 'Compartilhe normalmente', description: 'Use o link nas redes sociais, bio, anúncios ou onde já divulga hoje.' },
                { title: 'Acompanhe os leads capturados', description: 'Veja no painel cada contato que preencheu o formulário, mesmo quem não comprou na hora.' },
            ],
            featuresTitle: 'O que vem na sua página de vendas',
            features: [
                { icon: 'mdi-form-select', title: 'Formulário de captura personalizado', description: 'Escolha os campos do formulário para capturar exatamente o que precisa de cada visitante.' },
                { icon: 'mdi-image-multiple-outline', title: 'Imagem e descrição do produto', description: 'Apresente a oferta com imagem de marca, título, subtítulo e descrição completa.' },
                { icon: 'mdi-inbox-outline', title: 'Caixa de leads no painel', description: 'Veja todas as respostas do formulário organizadas em um só lugar, sem precisar de outra ferramenta.' },
            ],
            useCasesTitle: 'Para quem serve',
            useCases: [
                { title: 'Afiliados que vendem infoprodutos', description: 'Capture o contato de quem clicou no seu link de afiliado antes de ir para o checkout da plataforma do produtor.' },
                { title: 'Produtores lançando um infoproduto', description: 'Use uma página de pré-venda para capturar interesse antes mesmo do checkout estar pronto.' },
                { title: 'Quem oferece um material gratuito', description: 'Troque um e-book, aula ou material gratuito pelo contato do visitante.' },
            ],
            faqTitle: 'Perguntas frequentes sobre página de vendas para afiliados',
            crossPillar: {
                text: 'Quer rastrear de onde vem cada clique antes de alguém preencher o formulário? Combine sua página de vendas com um',
                label: 'encurtador de link para afiliados',
                href: '/encurtador-de-link-para-afiliados',
            },
            internalLinksTitle: 'Conteúdo relacionado',
            internalLinks: [
                { label: 'Encurtador de link para afiliados', href: '/encurtador-de-link-para-afiliados' },
                { label: 'Como rastrear cliques em links', href: '/blog/como-rastrear-cliques-em-links' },
            ],
            ctaPrimaryLabel: 'Começar gratuitamente',
            ctaSecondaryLabel: 'Conhecer o Migly',
        },
        seoArticleOQueEUtm: {
            h1: 'O que é UTM?',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'UTM é a forma mais simples de saber de onde veio cada clique no seu link — sem UTM, você só sabe que alguém clicou; com UTM, sabe também onde ele viu o link.',
            sections: [
                { heading: 'Definição', body: 'UTM (Urchin Tracking Module) é um conjunto de parâmetros adicionado ao final de uma URL para identificar a origem do tráfego. Quando alguém clica em um link com UTM, esses parâmetros são registrados junto com o clique, permitindo saber depois de onde ele veio.' },
                { heading: 'Os 5 parâmetros de UTM', body: 'Existem cinco parâmetros: <strong>utm_source</strong> (a origem, como Instagram ou Google), <strong>utm_medium</strong> (o canal, como story ou e-mail), <strong>utm_campaign</strong> (o nome da campanha), <strong>utm_content</strong> (a variação do anúncio ou link) e utm_term (a palavra-chave, mais usado em buscas pagas). Veja o detalhe de cada um: <a href="/blog/o-que-e-utm-source">utm_source</a>, <a href="/blog/o-que-e-utm-medium">utm_medium</a>, <a href="/blog/o-que-e-utm-campaign">utm_campaign</a> e <a href="/blog/o-que-e-utm-content">utm_content</a>.' },
                { heading: 'Um exemplo prático', body: 'Uma URL com UTM se parece com: <code>https://seusite.com/produto?utm_source=instagram&utm_medium=story&utm_campaign=lancamento</code>. Isso diz: o clique veio do Instagram, por um story, dentro da campanha de lançamento.' },
                { heading: 'Por que isso importa', body: 'Sem UTM, duas campanhas diferentes no mesmo canal parecem uma coisa só. Com UTM, é possível comparar o resultado de cada campanha e decidir onde investir mais tempo ou orçamento. Veja o <a href="/blog/como-criar-utm">passo a passo para criar uma UTM</a>.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM Source', href: '/blog/o-que-e-utm-source' },
                { label: 'Como criar uma UTM', href: '/blog/como-criar-utm' },
            ],
            pillarLink: { label: 'Ver o gerador de UTM do Migly', href: '/gerador-de-utm' },
        },
        seoArticleOQueEUtmSource: {
            h1: 'O que é UTM Source (utm_source)?',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'utm_source é o parâmetro que identifica de onde veio o clique — a plataforma ou site de origem.',
            sections: [
                { heading: 'Definição', body: 'utm_source identifica a origem do tráfego: o site, app ou rede social de onde o clique partiu. É o parâmetro mais básico de uma UTM e normalmente o primeiro a ser definido.' },
                { heading: 'Exemplos comuns', body: 'Alguns valores comuns de utm_source: <code>instagram</code>, <code>google</code>, <code>facebook</code>, <code>newsletter</code>, <code>whatsapp</code>. O valor deve ser curto, em minúsculas e sem espaços.' },
                { heading: 'utm_source não é o mesmo que utm_medium', body: 'utm_source diz <em>onde</em>; utm_medium diz <em>como</em>. Por exemplo, <code>utm_source=instagram</code> com <code>utm_medium=story</code> significa: veio do Instagram, por um story. Veja mais em <a href="/blog/o-que-e-utm-medium">o que é UTM Medium</a>.' },
                { heading: 'Como usar no Migly', body: 'Ao criar um link no Migly, adicione <code>?utm_source=</code> na URL de destino antes de encurtar. O link curto gerado já carrega esse parâmetro. Veja o guia completo em <a href="/blog/como-criar-utm">como criar uma UTM</a>.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM?', href: '/blog/o-que-e-utm' },
                { label: 'O que é UTM Medium', href: '/blog/o-que-e-utm-medium' },
            ],
            pillarLink: { label: 'Ver o gerador de UTM do Migly', href: '/gerador-de-utm' },
        },
        seoArticleOQueEUtmMedium: {
            h1: 'O que é UTM Medium (utm_medium)?',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'utm_medium identifica o canal ou formato usado para divulgar o link dentro de uma origem.',
            sections: [
                { heading: 'Definição', body: 'utm_medium descreve o meio pelo qual o link foi compartilhado: story, post, e-mail, anúncio pago (cpc), link na bio. Ele complementa o utm_source, detalhando <em>como</em> o clique aconteceu dentro daquela origem.' },
                { heading: 'Exemplos comuns', body: 'Valores comuns: <code>story</code>, <code>post</code>, <code>email</code>, <code>cpc</code>, <code>bio</code>, <code>organic</code>. Use o mesmo valor sempre que o formato for o mesmo, para poder comparar entre campanhas.' },
                { heading: 'utm_source + utm_medium juntos', body: 'A combinação dos dois parâmetros dá o contexto completo: <code>utm_source=instagram&utm_medium=story</code> é diferente de <code>utm_source=instagram&utm_medium=bio</code>, mesmo vindo da mesma rede. Veja também <a href="/blog/o-que-e-utm-source">o que é UTM Source</a>.' },
                { heading: 'Como usar no Migly', body: 'Adicione <code>&utm_medium=</code> na mesma URL de destino em que você já colocou o utm_source, antes de encurtar o link no Migly.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM Source', href: '/blog/o-que-e-utm-source' },
                { label: 'O que é UTM Campaign', href: '/blog/o-que-e-utm-campaign' },
            ],
            pillarLink: { label: 'Ver o gerador de UTM do Migly', href: '/gerador-de-utm' },
        },
        seoArticleOQueEUtmCampaign: {
            h1: 'O que é UTM Campaign (utm_campaign)?',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'utm_campaign nomeia a campanha por trás do clique, permitindo agrupar resultados de vários canais sob um mesmo nome.',
            sections: [
                { heading: 'Definição', body: 'utm_campaign identifica o nome da campanha ou promoção associada ao link — por exemplo, um lançamento, uma Black Friday ou um cupom específico.' },
                { heading: 'Exemplos comuns', body: 'Valores comuns: <code>lancamento-2026</code>, <code>black-friday</code>, <code>cupom10</code>. O ideal é usar um padrão de nomenclatura consistente, para que a mesma campanha apareça sempre com o mesmo nome, mesmo divulgada em canais diferentes.' },
                { heading: 'Por que nomear campanhas com consistência importa', body: 'Se a mesma campanha for chamada de <code>lancamento</code> em um link e <code>lancamento2026</code> em outro, o painel vai tratá-las como campanhas diferentes. Combine com <a href="/blog/o-que-e-utm-source">utm_source</a> e <a href="/blog/o-que-e-utm-medium">utm_medium</a> para saber também de onde e como veio cada clique da campanha.' },
                { heading: 'Como usar no Migly', body: 'Adicione <code>&utm_campaign=</code> na URL de destino com o nome da campanha, junto dos demais parâmetros, antes de encurtar o link.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM Content', href: '/blog/o-que-e-utm-content' },
                { label: 'Como criar uma UTM', href: '/blog/como-criar-utm' },
            ],
            pillarLink: { label: 'Ver o gerador de UTM do Migly', href: '/gerador-de-utm' },
        },
        seoArticleOQueEUtmContent: {
            h1: 'O que é UTM Content (utm_content)?',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'utm_content diferencia variações de um mesmo anúncio, e-mail ou link dentro da mesma campanha.',
            sections: [
                { heading: 'Definição', body: 'utm_content é usado para diferenciar duas versões de um mesmo material — por exemplo, dois botões diferentes no mesmo e-mail, ou duas imagens diferentes testadas no mesmo anúncio.' },
                { heading: 'Quando vale a pena usar', body: 'Use utm_content quando você já está testando variações dentro da mesma campanha e do mesmo canal — por exemplo, <code>utm_content=botao-azul</code> versus <code>utm_content=botao-verde</code> — e quer saber qual variação gerou mais clique.' },
                { heading: 'Quando não é necessário', body: 'Se você só tem uma versão de anúncio ou link por campanha, utm_content pode ser deixado de fora — os outros parâmetros (<a href="/blog/o-que-e-utm-source">source</a>, <a href="/blog/o-que-e-utm-medium">medium</a>, <a href="/blog/o-que-e-utm-campaign">campaign</a>) já são suficientes.' },
                { heading: 'Como usar no Migly', body: 'Adicione <code>&utm_content=</code> na URL de destino para identificar a variação específica, antes de encurtar o link.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM Campaign', href: '/blog/o-que-e-utm-campaign' },
                { label: 'Como criar uma UTM', href: '/blog/como-criar-utm' },
            ],
            pillarLink: { label: 'Ver o gerador de UTM do Migly', href: '/gerador-de-utm' },
        },
        seoArticleComoCriarUtm: {
            h1: 'Como criar uma UTM passo a passo',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'Veja como montar uma URL com parâmetros UTM do zero e já gerar o link encurtado e rastreável com o Migly.',
            sections: [
                { heading: 'Passo 1 — Defina os parâmetros', body: 'Decida ao menos <a href="/blog/o-que-e-utm-source">utm_source</a> (de onde vem o clique) e <a href="/blog/o-que-e-utm-medium">utm_medium</a> (por qual canal). Se for uma campanha específica, adicione também <a href="/blog/o-que-e-utm-campaign">utm_campaign</a>.' },
                { heading: 'Passo 2 — Monte a URL', body: 'Adicione os parâmetros ao final da URL de destino, separados por <code>&</code> e começando com <code>?</code>: <code>https://seusite.com/pagina?utm_source=instagram&utm_medium=bio&utm_campaign=lancamento</code>.' },
                { heading: 'Passo 3 — Encurte no Migly', body: 'Cole essa URL completa (já com a UTM) no encurtador do Migly. O link curto gerado carrega a UTM internamente — não é preciso nenhum passo extra.' },
                { heading: 'Passo 4 — Compartilhe e acompanhe', body: 'Use o link em cada canal que quiser medir, com uma UTM diferente para cada um. Acompanhe os resultados no painel de UTM do Migly, com detalhamento por fonte, mídia, campanha e conteúdo.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM?', href: '/blog/o-que-e-utm' },
                { label: 'O que é UTM Content', href: '/blog/o-que-e-utm-content' },
            ],
            pillarLink: { label: 'Criar minha primeira UTM no Migly', href: '/gerador-de-utm' },
        },
        seoArticleComoRastrearCliques: {
            h1: 'Como rastrear cliques em links: guia para afiliados',
            author: 'Equipe Migly',
            date: '2026-09-08',
            intro: 'Veja como acompanhar quantos cliques cada link recebe, de onde vêm e quais campanhas convertem mais.',
            sections: [
                { heading: 'Por que rastrear cliques, não só vendas', body: 'A maioria das plataformas de afiliado (Hotmart, Eduzz, Kiwify) mostra vendas, mas não mostra quantas pessoas clicaram sem comprar. Rastrear cliques revela se o problema é pouco tráfego ou baixa conversão da oferta.' },
                { heading: 'O que um link rastreado mostra', body: 'Um link encurtado com rastreio mostra o total de cliques, a região, o dispositivo usado e, quando o link tem <a href="/blog/o-que-e-utm">UTM</a>, também a origem detalhada por fonte, mídia e campanha.' },
                { heading: 'Como configurar o rastreio', body: 'Encurte o link de afiliado no <a href="/encurtador-de-link-para-afiliados">encurtador do Migly</a>. Para saber também de onde veio cada clique, adicione parâmetros UTM na URL antes de encurtar — veja <a href="/blog/como-criar-utm">como criar uma UTM</a>.' },
                { heading: 'Comparando canais diferentes', body: 'Use um link (ou uma UTM) diferente para cada canal — bio do Instagram, grupo de WhatsApp, e-mail — e compare os cliques de cada um no painel, para saber onde vale mais a pena investir tempo.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'O que é UTM?', href: '/blog/o-que-e-utm' },
                { label: 'Como criar uma UTM', href: '/blog/como-criar-utm' },
            ],
            pillarLink: { label: 'Ver o encurtador para afiliados', href: '/encurtador-de-link-para-afiliados' },
        },
        seoArticleOpenGraphPersonalizacao: {
            h1: 'Open Graph: como personalizar a prévia dos seus links',
            author: 'Equipe Migly',
            date: '2026-10-03',
            intro: 'Open Graph é o protocolo que define a imagem, o título e a descrição que aparecem quando um link é compartilhado no WhatsApp, Instagram, Facebook ou X. Sem ele configurado, a rede social mostra o que conseguir encontrar sozinha na página de destino, às vezes nada. Com ele, você decide exatamente o que a pessoa vê antes de clicar.',
            sections: [
                { heading: 'O que é Open Graph, na prática', body: 'Open Graph é um conjunto de meta tags (propriedades <code>og:</code> no <code>&lt;head&gt;</code> da página) criado originalmente pelo Facebook para descrever como um conteúdo deve aparecer quando compartilhado. WhatsApp, Instagram, Facebook, LinkedIn, Slack, Discord e Telegram leem as mesmas tags: configure uma vez e a prévia funciona em todos esses lugares, sem precisar repetir o trabalho para cada rede.' },
                { heading: 'Por que a prévia decide o clique antes da página carregar', body: 'Para quem compartilha links de afiliado, infoproduto ou qualquer oferta, a prévia é a primeira (e às vezes única) chance de convencer alguém a clicar. Ela aparece no chat antes de a pessoa sair do aplicativo, então uma imagem genérica, cortada ou um título truncado reduzem o clique mesmo quando a página de destino em si é ótima. É julgamento antes do produto.' },
                { heading: 'Os 4 campos que toda prévia precisa', image: '/images/blog/inline/og-fields-diagram.svg', imageAlt: 'Diagrama de um card de prévia com os 4 campos do Open Graph numerados: imagem, título, descrição e URL', body: 'São quatro tags obrigatórias: <code>og:title</code> (o título mostrado), <code>og:description</code> (a descrição curta abaixo do título), <code>og:image</code> (a imagem de capa) e <code>og:url</code> (a URL canônica do conteúdo). Para a imagem, o tamanho recomendado é <strong>1200x630px</strong>, proporção 1.91:1: é o formato que WhatsApp, Instagram e Facebook cortam com menos distorção.' },
                { heading: 'O erro mais comum: deixar a prévia depender da página de destino', body: 'WhatsApp e a maioria dos apps de mensagem não executam JavaScript ao gerar a prévia: eles leem apenas o HTML que o servidor entrega na primeira resposta. Se as tags Open Graph só aparecem depois que um script roda no navegador, o crawler nunca as vê e a prévia fica genérica ou em branco. É por isso que o Migly resolve e injeta as tags de cada link diretamente no servidor, antes de qualquer JavaScript rodar.' },
                { heading: 'E o X (antigo Twitter)?', body: 'O X tem suas próprias tags (<code>twitter:card</code>, <code>twitter:title</code>, entre outras), mas quando elas não existem na página, ele usa as tags <code>og:</code> como alternativa. Na prática, configurar bem o Open Graph já cobre a esmagadora maioria dos casos, sem precisar duplicar a configuração para o X separadamente.' },
                { heading: 'Por que a prévia às vezes não muda na hora', body: 'WhatsApp e Facebook guardam a prévia em cache no servidor deles assim que alguém compartilha um link pela primeira vez. Se você editar a imagem ou o título depois disso, quem já viu aquele link continua vendo a versão antiga até o cache expirar, o que pode levar de algumas horas a alguns dias. Isso é comportamento normal da rede social, não um erro de configuração.' },
                { heading: 'Como personalizar no Migly', image: '/images/blog/inline/og-migly-editor-flow.svg', imageAlt: 'Fluxo mostrando um link sendo editado com campos de imagem, título e resumo, gerando uma prévia ao vivo', body: 'No editor de cada link encurtado, defina a imagem, o título e um resumo curto, com uma prévia ao vivo do resultado antes de salvar, sem mexer em código, sem configurar meta tag manualmente e sem acessar a página de destino. Veja o <a href="/#open-graph">recurso de prévia de link do Migly</a>.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'Como gerar leads com um e-book', href: '/blog/como-gerar-leads-com-ebook' },
                { label: 'Como transformar seus links em renda extra com o Migly PRO', href: '/blog/renda-extra-com-migly-pro' },
            ],
            pillarLink: { label: 'Ver o recurso de prévia de link do Migly', href: '/#open-graph' },
        },
        seoArticleComoGerarLeadsComEbook: {
            h1: 'Como gerar leads com um e-book (sem precisar de outra ferramenta)',
            author: 'Equipe Migly',
            date: '2026-10-03',
            intro: 'Um e-book funciona como lead magnet quando você troca um material de valor real por um contato: a pessoa baixa o conteúdo, você fica com o e-mail dela. É uma das formas mais simples de transformar tráfego que normalmente passaria direto em uma lista que você pode acionar depois, sem depender de anúncio pago.',
            sections: [
                { heading: 'O que é um lead magnet, e por que um e-book funciona bem', body: 'Um lead magnet é qualquer material de valor (um e-book, checklist ou planilha) oferecido de graça em troca de um contato, geralmente o e-mail. A pessoa recebe algo útil na hora; você recebe a permissão de falar com ela de novo. O e-book funciona especialmente bem porque resolve um problema específico, é fácil de consumir e constrói confiança antes de qualquer tentativa de venda, o início de um relacionamento, não o fim de uma campanha.' },
                { heading: 'O tamanho certo: nem panfleto, nem livro', body: 'Um lead magnet em formato e-book costuma funcionar melhor entre 15 e 40 páginas: longo o suficiente para entregar valor real e construir credibilidade, curto o suficiente para a pessoa realmente terminar de ler. Um PDF de duas páginas parece pouco esforço (e converte pouco); um e-book de 100 páginas intimida e fica na fila de leitura para sempre.' },
                { heading: 'O erro que mais mata conversão: pedir contato sem provar valor antes', body: 'O conteúdo precisa ser específico, com exemplos e dados concretos que ajudem a resolver um problema real, não um resumo genérico do que já existe em qualquer busca. Um lead magnet raso faz a pessoa desconfiar do resto do funil, mesmo que o produto principal seja ótimo.' },
                { heading: 'A estrutura de duas páginas que converte', image: '/images/blog/inline/leads-two-page-funnel.svg', imageAlt: 'Diagrama de funil com uma página de captura de e-mail levando a uma página de entrega do e-book', body: 'O modelo mais usado é separar a entrega em duas etapas: uma página que apresenta o e-book e captura nome e e-mail, e uma segunda página, mostrada só depois do cadastro, que entrega o link de download. Essa separação evita e-mails inválidos digitados às pressas e dá a chance de mostrar uma próxima oferta logo na tela de agradecimento.' },
                { heading: 'Onde a maioria perde o lead sem perceber', body: 'Divulgar o e-book em um link que leva direto para um checkout externo, sem capturar nada antes, significa perder o contato de quem clicou mas não comprou: o tráfego passa e não deixa rastro. É o cenário mais comum em quem começa a divulgar um e-book sem pensar na captura primeiro.' },
                { heading: 'Capturando o lead direto no link, com o Migly', image: '/images/blog/inline/leads-migly-flow.svg', imageAlt: 'Fluxo mostrando um link que captura o e-mail do visitante antes de entregar o e-book', body: 'O recurso de <a href="/pagina-de-vendas-para-afiliados">página de vendas do Migly</a> transforma o próprio link que você compartilha em uma página com captura de contato antes do redirecionamento: o visitante deixa o e-mail, recebe o e-book, e você fica com o lead mesmo quando ele não compra na hora. Não é preciso montar duas páginas separadas em outra ferramenta.' },
                { heading: 'Medindo o que realmente funciona', body: 'Promova o e-book em vários canais (bio do Instagram, grupo de WhatsApp, e-mail) e use um parâmetro de <a href="/blog/o-que-e-utm">UTM</a> diferente para cada um. Assim você vê qual canal trouxe mais downloads de verdade, em vez de confiar só no total de cliques.' },
                { heading: 'Um detalhe que muita gente esquece: a LGPD', body: 'Mesmo numa troca simples por e-book, a Lei Geral de Proteção de Dados exige deixar claro para que o e-mail será usado e dar uma forma fácil de descadastro. Isso vale tanto para o e-mail de entrega do material quanto para qualquer sequência de nutrição que venha depois dele. Uma frase curta na página de captura já resolve a maior parte da exigência.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'Open Graph: como personalizar a prévia dos seus links', href: '/blog/open-graph-personalizacao-de-links' },
                { label: 'Como transformar seus links em renda extra com o Migly PRO', href: '/blog/renda-extra-com-migly-pro' },
            ],
            pillarLink: { label: 'Ver a página de vendas para afiliados do Migly', href: '/pagina-de-vendas-para-afiliados' },
        },
        seoArticleRendaExtraComMiglyPro: {
            h1: 'Como transformar seus links em renda extra com o Migly PRO',
            author: 'Equipe Migly',
            date: '2026-10-03',
            intro: 'O plano PRO do Migly permite configurar um banner de anúncio próprio na tela de redirecionamento dos links que você já compartilha, sem criar conteúdo novo e sem precisar de mais seguidores. É assim que usuários reais, como Luis Eduardo, já transformaram o tráfego que tinham em renda extra.',
            sections: [
                { heading: 'Como funciona o modelo de monetização do Migly PRO', image: '/images/blog/inline/pro-redirect-comparison.svg', imageAlt: 'Comparação entre a tela de redirecionamento do plano gratuito, com anúncio padrão do Migly, e do plano PRO, com banner próprio', body: 'Todo link do Migly passa por uma tela de redirecionamento antes de chegar ao destino final. No plano gratuito, essa tela mostra um anúncio padrão do Migly. No plano PRO, você substitui esse espaço por um banner próprio, com a imagem e o link que você escolher, configurado uma vez no painel e exibido automaticamente em todos os links que você compartilha a partir dali.' },
                { heading: 'Por que isso é diferente de "ganhar dinheiro com encurtador"', body: 'Encurtadores que pagam por clique costumam repassar uma fração de centavo por acesso, variando de acordo com o país de quem clicou, e dependem de um volume alto de tráfego para gerar algo relevante. O modelo do Migly PRO é outro: você escolhe o que anunciar (um link de afiliado, um produto próprio, uma oferta) e fica com o valor integral do que esse anúncio gerar, sem dividir comissão com a plataforma de encurtamento.' },
                { heading: 'Nenhum trabalho extra, nenhuma audiência nova necessária', body: 'Não é preciso criar conteúdo novo, buscar anunciante ou negociar parceria. O banner é configurado uma vez no painel e passa a aparecer em todo link que você já compartilha a partir dali, incluindo links que você já tinha divulgado antes de assinar o PRO.' },
                { heading: 'Quem já usa esse modelo', image: '/images/blog/inline/pro-who-uses.svg', imageAlt: 'Ícones representando um afiliado, um infoprodutor e um criador de conteúdo', body: 'Afiliados que divulgam ofertas em grupos e redes sociais, infoprodutores que compartilham conteúdo próprio e criadores que já têm tráfego recorrente nos links mas nunca tinham monetizado o clique em si. O requisito é só ter links sendo clicados, não ter uma audiência grande ou um nicho específico.' },
                { heading: 'Um resultado real', body: 'O depoimento abaixo é de um usuário real do Migly, com o valor exato que ele já gerou dessa forma.' },
                { heading: 'Como configurar seu banner', body: 'No painel do Migly, em configurações de redirecionamento, defina a imagem e o link do banner que você quer exibir. A partir daí, qualquer pessoa que clicar em um dos seus links encurtados vê esse anúncio antes de seguir para o destino, sem precisar repetir a configuração link por link.' },
                { heading: 'O que esperar do resultado', body: 'Não existe um valor fixo: o quanto isso rende depende do volume de cliques que seus links já recebem e da oferta escolhida para o banner. Não é uma fonte de renda que substitui o trabalho principal, mas é receita que já estava sendo desperdiçada em cada clique que passava direto sem nenhum retorno. O ponto de partida é sempre o mesmo: configurar uma vez e deixar rodar nos links que você já compartilha.' },
            ],
            relatedLinksTitle: 'Continue aprendendo',
            relatedLinks: [
                { label: 'Open Graph: como personalizar a prévia dos seus links', href: '/blog/open-graph-personalizacao-de-links' },
                { label: 'Como gerar leads com um e-book', href: '/blog/como-gerar-leads-com-ebook' },
            ],
            pillarLink: { label: 'Ver os planos do Migly', href: '/#planos' },
        },
        blogPosts: [
            {
                slug: 'o-que-e-utm',
                href: '/blog/o-que-e-utm',
                title: 'O que é UTM?',
                excerpt: 'UTM é a forma mais simples de saber de onde veio cada clique no seu link. Sem UTM, você só sabe que alguém clicou; com UTM, sabe também onde ele viu o link.',
                image: '/images/blog/utm-o-que-e.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'o-que-e-utm-source',
                href: '/blog/o-que-e-utm-source',
                title: 'O que é UTM Source (utm_source)?',
                excerpt: 'utm_source é o parâmetro que identifica de onde veio o clique: a plataforma ou site de origem.',
                image: '/images/blog/utm-source.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'o-que-e-utm-medium',
                href: '/blog/o-que-e-utm-medium',
                title: 'O que é UTM Medium (utm_medium)?',
                excerpt: 'utm_medium identifica o canal ou formato usado para divulgar o link dentro de uma origem.',
                image: '/images/blog/utm-medium.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'o-que-e-utm-campaign',
                href: '/blog/o-que-e-utm-campaign',
                title: 'O que é UTM Campaign (utm_campaign)?',
                excerpt: 'utm_campaign nomeia a campanha por trás do clique, permitindo agrupar resultados de vários canais sob um mesmo nome.',
                image: '/images/blog/utm-campaign.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'o-que-e-utm-content',
                href: '/blog/o-que-e-utm-content',
                title: 'O que é UTM Content (utm_content)?',
                excerpt: 'utm_content diferencia variações de um mesmo anúncio, e-mail ou link dentro da mesma campanha.',
                image: '/images/blog/utm-content.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'como-criar-utm',
                href: '/blog/como-criar-utm',
                title: 'Como criar uma UTM passo a passo',
                excerpt: 'Veja como montar uma URL com parâmetros UTM do zero e já gerar o link encurtado e rastreável com o Migly.',
                image: '/images/blog/utm-criar.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'UTM',
                featured: false,
            },
            {
                slug: 'como-rastrear-cliques-em-links',
                href: '/blog/como-rastrear-cliques-em-links',
                title: 'Como rastrear cliques em links: guia para afiliados',
                excerpt: 'Veja como acompanhar quantos cliques cada link recebe, de onde vêm e quais campanhas convertem mais.',
                image: '/images/blog/utm-rastrear-cliques.svg',
                author: 'Equipe Migly',
                date: '2026-09-08',
                category: 'Afiliados',
                featured: false,
            },
            {
                slug: 'open-graph-personalizacao-de-links',
                href: '/blog/open-graph-personalizacao-de-links',
                title: 'Open Graph: como personalizar a prévia dos seus links',
                excerpt: 'A primeira impressão de um link compartilhado não é a página de destino. É a prévia que o WhatsApp, Instagram ou X mostram antes do clique. Veja como controlar exatamente o que aparece.',
                image: '/images/blog/open-graph-personalizacao-de-links.svg',
                author: 'Equipe Migly',
                date: '2026-10-03',
                category: 'Open Graph',
                featured: false,
            },
            {
                slug: 'como-gerar-leads-com-ebook',
                href: '/blog/como-gerar-leads-com-ebook',
                title: 'Como gerar leads com um e-book (sem precisar de outra ferramenta)',
                excerpt: 'Trocar um e-book pelo e-mail de quem clica é uma das formas mais simples de transformar tráfego em lista. Veja como estruturar essa troca sem sair do link que você já compartilha.',
                image: '/images/blog/como-gerar-leads-com-ebook.svg',
                author: 'Equipe Migly',
                date: '2026-10-03',
                category: 'Geração de Leads',
                featured: false,
            },
            {
                slug: 'renda-extra-com-migly-pro',
                href: '/blog/renda-extra-com-migly-pro',
                title: 'Como transformar seus links em renda extra com o Migly PRO',
                excerpt: 'Depois que começou a usar o Migly para compartilhar seus links, Luis Eduardo já conseguiu R$ 155,95 em renda extra, sem esforço, apenas incluindo publicidade nos links que já compartilhava.',
                image: '/images/blog/renda-extra-com-migly-pro.svg',
                author: 'Equipe Migly',
                date: '2026-10-03',
                category: 'Migly PRO',
                featured: true,
            },
        ],
        newsMigly: {
            title: 'Novidades do migly',
            subtitle: 'Encurtamento, personalização e coleta de métricas',
            news: [
                {
                    type: 'SHORTEN_LINKS', 
                    title: 'Personalize seus links e simplifique seus compartilhamentos',
                    text: `<p>Transforme suas URLs longas em links curtos e personalizados com nosso sistema de encurtamento. Configure a pré-visualização perfeita para suas redes sociais, definindo imagens e descrições personalizadas para compartilhamentos no WhatsApp, Instagram e outras plataformas. Torne cada link atraente e eficaz, garantindo que sua mensagem seja destacada e cativante!</p>
                        <ul>
                        <li><strong>Aumente o engajamento:</strong> Links visualmente atraentes incentivam mais cliques e compartilhamentos.</li>
                        <li><strong>Controle a aparência:</strong> Personalize imagens e descrições para se alinhar com sua marca.</li>
                        <li><strong>Facilite o compartilhamento:</strong> URLs curtas são mais fáceis de lembrar e compartilhar.</li>
                        </ul>
                        `,
                    img: '/images/news/001.jpeg'
                },
                {
                    type: 'SHORTEN_LINKS', 
                    title: 'Vantagens de Usar Links Curtos',
                    text: `
                        <p>Utilizar links curtos traz uma série de benefícios para suas campanhas e compartilhamentos online. Com nossos links extremamente curtos, você pode aproveitar ao máximo cada um desses benefícios:</p>
                        <ul>
                        <li><strong>Facilidade de Compartilhamento:</strong> Links curtos são mais fáceis de lembrar, digitar e compartilhar em qualquer plataforma.</li>
                        <li><strong>Economia de Espaço:</strong> Ideal para redes sociais com limites de caracteres, permitindo que você foque mais na sua mensagem.</li>
                        <li><strong>Estética Aperfeiçoada:</strong> Links curtos são visualmente mais atraentes e profissionais, melhorando a aparência das suas postagens.</li>
                        <li><strong>Aumento de Cliques:</strong> Links mais curtos tendem a receber mais cliques, impulsionando o tráfego para seu conteúdo.</li>
                        </ul>
                    `,
                    img: '/images/news/002.png'
                },
                {
                    type: 'SHORTEN_LINKS', 
                    title: 'Personalize Sua Tela de Carregamento',
                    text: `
<p>Aproveite ao máximo o recurso de customização da tela de carregamento e destaque sua marca em cada clique. Com a possibilidade de definir sua própria marca e um banner para publicidade, você pode transformar a experiência de carregamento em uma poderosa ferramenta de marketing. Confira os benefícios:</p>
<ul>
  <li><strong>Reforço da Marca:</strong> Exiba sua identidade visual de forma consistente, aumentando o reconhecimento e a lembrança da marca.</li>
  <li><strong>Monetização:</strong> Utilize banners publicitários para gerar receita adicional, aproveitando o tempo de carregamento dos links.</li>
  <li><strong>Engajamento do Usuário:</strong> Capte a atenção dos usuários com mensagens personalizadas e ofertas especiais durante o carregamento.</li>
  <li><strong>Experiência Personalizada:</strong> Crie uma experiência única para seus usuários, alinhada com seus objetivos de marketing.</li>
  <li><strong>Fidelização:</strong> Utilize a tela de carregamento para promover campanhas e aumentar a fidelidade dos clientes.</li>
  <li><strong>Flexibilidade:</strong> Atualize facilmente a tela de carregamento com novos banners e mensagens conforme necessário.</li>
</ul>
`,
                    img: '/images/news/003.png'
                },
                {
                    type: 'SHORTEN_LINKS', 
                    title: 'Aproveite ao Máximo as Métricas Avançadas',
                    text: `
                        <p>Nosso sistema de encurtamento de URLs oferece recursos avançados de coleta de métricas, permitindo que você obtenha insights detalhados sobre o desempenho dos seus links. Confira os benefícios de utilizar nossas ferramentas de métricas:</p>
                        <ul>
                        <li><strong>Contagem de Acessos:</strong> Monitore quantas vezes seus links foram clicados para avaliar o alcance e a popularidade.</li>
                        <li><strong>Análise Regional:</strong> Identifique de quais regiões geográficas vêm os cliques, ajudando a direcionar suas campanhas de marketing.</li>
                        <li><strong>Dimensões de Tela:</strong> Saiba quais dispositivos seus usuários estão utilizando, permitindo a otimização do conteúdo para diferentes tamanhos de tela.</li>
                        <li><strong>Compartilhamentos em Redes Sociais:</strong> Acompanhe como seus links estão sendo compartilhados nas principais redes sociais (veja o recurso "Compartilhar em").</li>
                        <li><strong>Plataformas de Acesso:</strong> Descubra em quais plataformas (desktop, mobile, tablet) seus links estão sendo acessados para melhorar a experiência do usuário.</li>
                        </ul>
                    `,
                    img: '/images/news/004.png'
                },
                {
                    type: 'SHORTEN_LINKS', 
                    title: 'Personalização Completa de URL com Domínio Próprio',
                    text: `
                        <p>Personalize suas URLs de forma completa, incluindo a possibilidade de usar seu próprio domínio. Aumente a confiança e o reconhecimento da marca ao compartilhar links curtos e personalizados, alinhados com sua identidade visual. Ideal para empresas que buscam uma presença online profissional e coesa. Confira os benefícios:</p>
                        <ul>
                        <li><strong>Identidade de Marca:</strong> Mantenha suas URLs consistentes com a identidade visual da sua marca.</li>
                        <li><strong>Confiança e Credibilidade:</strong> Aumente a confiança dos usuários com URLs profissionais e personalizadas.</li>
                        <li><strong>Domínio Próprio:</strong> Use seu próprio domínio para criar links curtos e personalizados.</li>
                        <li><strong>SEO Aprimorado:</strong> Melhore o SEO com URLs customizadas e otimizadas.</li>
                        <li><strong>Flexibilidade:</strong> Atualize e personalize suas URLs conforme suas necessidades.</li>
                        <li><strong>Engajamento:</strong> Atraia mais cliques e engajamento com URLs curtas e memoráveis.</li>
                        </ul>
                        `,
                    img: '/images/news/008.jpeg'
                },
                {
                    type: 'CHROME_EXTENSION', 
                    title: 'Encurtador de Links Automático para Google Chrome',
                    text: `
                        <p>Com a extensão Migly para Google Chrome, você pode encurtar links automaticamente e associá-los à sua conta Migly. Aproveite essa ferramenta poderosa gratuitamente e simplifique a maneira como você compartilha URLs.</p>
                        <h2>Benefícios da Extensão:</h2>
                        <ul>
                        <li><strong>Encurtamento Automático de Links:</strong> Simplifique e encurte URLs diretamente do seu navegador sem esforço manual.</li>
                        <li><strong>Associação com Conta Migly:</strong> Todos os links encurtados são automaticamente vinculados à sua conta Migly para fácil gestão e acompanhamento.</li>
                        <li><strong>Gratuita:</strong> Desfrute de todas essas funcionalidades sem custo algum.</li>
                        <li><strong>Coleta de Métricas:</strong> Acompanhe os acessos, regiões e plataformas diretamente pela sua conta Migly.</li>
                        <li><strong>Customização de URLs:</strong> Personalize a previsualização dos links com imagens e descrições específicas para redes sociais.</li>
                        <li><strong>Facilidade de Uso:</strong> Interface intuitiva e fácil de usar, que agiliza seu trabalho diário.</li>
                        <li><strong>Segurança e Confiabilidade:</strong> Utilize uma plataforma segura e confiável para encurtar e compartilhar seus links.</li>
                        </ul>
                        <p>Baixe agora na <a href="https://chromewebstore.google.com/detail/miglyin/mbadgimimpdakeglbfkadhpjphbghalb">Chrome Web Store</a>.</p>
                    `,
                    img: '/images/news/009.png'
                },
            ],
            otherNews: [
                {
                    title: 'API para desenvolvedores',
                    text: `Nossa API de encurtamento de URLs oferece uma solução robusta e fácil de integrar para desenvolvedores.`,
                    img: '/images/news/005.png',
                    src: '/api-doc'
                },
                {
                    title: 'Bio migly',
                    text: `Centralize seus links de perfis sociais em um único lugar. Acesse e compartilhe todas as suas redes com facilidade.`,
                    img: '/images/news/006.png',
                    src: '/painel/links/page-bio'
                },
                {
                    title: 'Mais métricas',
                    text: `Rastreie e analise o desempenho dos seus links por localização. Obtenha insights valiosos para otimizar suas campanhas.`,
                    img: '/images/news/007.png',
                    src: '/painel/links/shortened'
                },
            ]
        },
        otherNews: 'Conheça outros recursos',
        accessPainel: 'Acesse o painel',
        plan_BUSINESS: 'Empresarial',

        sectionDocument: 'Documento',
        sectionContact: 'Contato',
        sectionCardData: 'Dados do cartão',
        sectionBillingAddress: 'Endereço da cobrança',
        documentRequired: 'Documento obrigatório no formato somente númerico',
        documentInvalid: 'Documento inválido',
        ddiRequired: 'DDI obrigatório',
        dddRequired: 'DDD obrigatório',
        phoneNumberRequired: 'Número obrigatório',
        phoneNumberInvalid: 'Número inválido',
        cardNumber: 'Número do cartão',
        cardNumberRequired: 'Número do cartão obrigatório',
        cardNumberInvalid: 'Número do cartão inválido',
        cvvRequired: 'CVV obrigatório',
        cvvInvalid: 'CVV inválido',
        cardNameRequired: 'Nome obrigatório',
        cardNameInvalid: 'Nome inválido',
        cardExpiration: 'Mês e ano',
        cardExpirationRequired: 'Expiração obrigatória',
        cardExpirationInvalid: 'Expiração inválida',
        streetRequired: 'Rua/Logradouro obrigatória',
        cepRequired: 'CEP obrigatório',
        cepInvalid: 'CEP inválido',
        cityRequired: 'Cidade obrigatória',
        stateRequired: 'Estado obrigatório',
        subscriptionError: 'Você já contratou esse plano ou seus dados do pagamento não são válidos. Confira e tente novamente',
        subscribeButton: 'Assinar Plano',
        verifyingCardData: 'Verificando dados do cartão',
        discountNotice: 'Você será cobrado R${discountedPrice} pelos primeiros três meses, após esse período, a assinatura será ajustada para R${fullPrice}.',

        home: {
            navHowItWorks: 'Como funciona',
            navBio: 'Bio',
            navSalesPage: 'Página de Vendas',
            navLinkPreview: 'Prévia do Link',
            navBlog: 'Blog',
            blogHighlights: 'Destaques',
            blogRecentPosts: 'Posts recentes',
            openMenu: 'Abrir menu',
            languageSelector: 'Selecionar idioma',
            footerTagline: 'Encurte, unifique e acompanhe tudo sobre seus links em um só lugar.',
            footerLgpd: 'Conforme LGPD',
            footerDataProtected: 'Dados protegidos',
            footerNavigation: 'Navegação',
            footerContact: 'Contato',
            footerProductOf: 'migly.in é um produto <a class="footer-link-inline" href="https://www.exatamentese.com">exatamente soluções</a>.',

            heroTitleLine1: 'Cada link, uma métrica.',
            heroTitleLine2: 'Cada clique, uma decisão.',
            heroSubtitle: 'Encurte o link, gere sua página de bio e veja de onde vem cada clique. Tudo em um fluxo só.',
            heroTypewriterLabel: 'Veja como fica:',
            heroCtaFree: 'Comece grátis',
            heroCtaHowItWorks: 'Ver como funciona',
            noCreditCard: 'sem cartão de crédito',
            heroVisualAriaLabel: 'Demonstração animada: link curto, preview de compartilhamento, página de bio, QR code personalizável e métricas de acesso.',
            heroCustomizable: 'Personalizável',
            heroOriginIdentified: 'origem identificada',
            heroAnimPause: 'Pausar demonstração animada',
            heroAnimResume: 'Retomar demonstração animada',
            heroShortLinkBadge: 'Link encurtado',
            heroPreviewBadge: 'Preview pronto pra compartilhar',

            benefitUrl: 'URL personalizável',
            benefitMetric: 'Métrica de acessos',
            benefitPreview: 'Preview para redes sociais',
            benefitAnalytics: 'Integração Google Analytics',
            mockYourUrl: 'migly.in/você',

            proofHeadline: 'o que dizem quem já usa o migly',
            roleDeveloper: 'Desenvolvedor',
            roleSalesManager: 'Gerente de Vendas',
            roleTeacher: 'Professor e Empreendedor',
            testimonial1Quote: 'O Migly me permitiu monetizar todos meus links compartilhados.',
            testimonial2Quote: 'O Migly aumentou a exposição da nossa marca com links atrativos. Uma ferramenta indispensável!',
            testimonial3Quote: 'As métricas detalhadas do Migly nos ajudaram a entender melhor o desempenho dos nossos links e otimizar nossas campanhas de marketing.',
            pricingTestimonialQuote: 'Depois que comecei a usar o Migly para compartilhar meus links, já consegui R$ 155,95 em renda extra — sem esforço, apenas incluindo publicidade nos links que eu já compartilhava.',

            pillarsTitle: 'as três peças do seu fluxo de tráfego',
            pillarOriginTitle: 'Rastreamento de origem',
            pillarOriginDesc: 'Veja de qual campanha, rede ou anúncio veio cada clique, antes de decidir onde investir de novo.',
            pillarToggle: 'ver como funciona',
            pillarOriginDetail: 'Cada link Migly carrega a origem do clique até o painel de métricas, sem configuração extra.',
            pillarBioTitle: 'Página de bio integrada',
            pillarBioDesc: 'A mesma página de bio nasce do link que você já encurtou. Não é outro produto, é o mesmo fluxo.',
            pillarBioDetail: 'Edite cores, ordem dos links e destaque o que quiser vender primeiro.',
            bioTag: 'agregador de links',
            bioTitle: 'sua bio, sua marca, todas as redes num só link',
            bioText: 'Crie uma página biográfica personalizável, pensada pra redes sociais — reúna Instagram, YouTube, loja e qualquer link importante num só lugar, com a cara da sua marca.',
            bioBullet1Title: 'Centralização de Links',
            bioBullet1Desc: 'Reúna todos os seus links importantes em um único local.',
            bioBullet2Title: 'Facilidade de Acesso',
            bioBullet2Desc: 'Permita que seus seguidores encontrem facilmente todos os seus conteúdos e perfis.',
            bioBullet3Title: 'Personalização',
            bioBullet3Desc: 'Crie uma página que reflita sua personalidade ou marca com facilidade.',
            bioMockHandle: '@seuperfil',
            bioMockTagline: 'criador de conteúdo digital',
            bioMockInstagram: 'Instagram',
            bioMockYoutube: 'YouTube',
            bioMockStore: 'Minha loja',
            bioMockContact: 'Fale comigo',
            bioMockExampleLabel: 'exemplo',
            bioExamplesLabel: 'exemplos de bio pages que você pode criar',

            infoproductTag: 'página de vendas',
            infoproductTitle: 'todo link pode virar uma página de vendas com captura de lead',
            infoproductText: 'Antes de enviar o clique pro checkout de outra plataforma, capture o contato de quem não converteu na hora — assim você nunca perde esse lead de vista.',
            infoproductBullet1Title: 'Formulário de captura',
            infoproductBullet1Desc: 'Crie um formulário personalizado com os campos que quiser para capturar o contato do visitante.',
            infoproductBullet2Title: 'Atribuição sem perder o lead',
            infoproductBullet2Desc: 'O lead fica dentro do seu funil no Migly, não some quando ele não compra na hora.',
            infoproductBullet3Title: 'Sua marca, sua oferta',
            infoproductBullet3Desc: 'Personalize cores, imagem e descrição da página para combinar com o seu produto.',
            infoproductCta: 'Criar minha página de vendas',
            infoproductMockBrand: 'Sua Marca',
            infoproductMockBadge: 'DOWNLOAD GRATUITO',
            infoproductMockTitle: 'Guia para Criar uma Página de Coleta de Leads Eficiente',
            infoproductMockDesc: 'Dicas práticas para transformar visitantes em leads qualificados.',
            infoproductMockCta: 'Baixar agora',
            infoproductMockTopic1: 'Como criar uma oferta de valor',
            infoproductMockTopic2: 'Otimização para dispositivos móveis',
            infoproductMockTopic3: 'Como medir e otimizar resultados',
            infoproductMockFormLabel: 'Informe seu e-mail',
            infoproductMockFormBtn: 'Quero receber',

            bioExampleFitnessNiche: 'fitness',
            bioExampleFitnessDesc: 'Venha pro fitness club.',
            bioExampleFitnessLink1: 'Smart Gym',
            bioExampleFitnessLink2: 'Treine comigo',

            bioExampleWellnessNiche: 'bem-estar',
            bioExampleWellnessDesc: 'Mais calma e atenção plena.',
            bioExampleWellnessLink1: 'O que é mindfullness?',
            bioExampleWellnessLink2: 'Benefícios do Mindfullness',

            bioExampleTechNiche: 'tecnologia',
            bioExampleTechDesc: 'Avaliações sinceras de produtos.',
            bioExampleTechLink1: 'Recomendações',
            bioExampleTechLink2: 'meuInsta',

            bioExampleTravelNiche: 'viagem',
            bioExampleTravelDesc: 'Explorando o mundo um lugar de cada vez.',
            bioExampleTravelLink1: 'Blog do Viajante',
            bioExampleTravelLink2: 'Como comprar passagens',

            bioExampleFoodNiche: 'gastronomia',
            bioExampleFoodDesc: 'Receitas fáceis para o dia a dia.',
            bioExampleFoodLink1: 'Receita da semana',
            bioExampleFoodLink2: 'Meu livro de receitas',

            bioExampleMusicNiche: 'música',
            bioExampleMusicDesc: 'Sets exclusivos toda semana.',
            bioExampleMusicLink1: 'Ouça no Spotify',
            bioExampleMusicLink2: 'Próximos shows',

            bioExampleBeautyNiche: 'beleza',
            bioExampleBeautyDesc: 'Dicas de skincare que funcionam.',
            bioExampleBeautyLink1: 'Rotina completa',
            bioExampleBeautyLink2: 'Produtos que uso',

            bioExampleBusinessNiche: 'negócios',
            bioExampleBusinessDesc: 'Mentoria para empreendedores.',
            bioExampleBusinessLink1: 'Agende uma sessão',
            bioExampleBusinessLink2: 'Meu e-book grátis',

            pillarExtensionTitle: 'Extensão Chrome',
            pillarExtensionDesc: 'Encurte qualquer link direto do navegador, sem abrir o painel toda vez.',
            pillarInstallExtension: 'instalar extensão',
            pillarExtensionDetail: 'Fica instalada no Chrome e mantém seu link Migly a um clique de distância o dia inteiro.',
            pillarsSeoLinksHtml: 'Quer se aprofundar? Veja nosso <a href="/gerador-de-utm">gerador de UTM</a> ou nosso <a href="/encurtador-de-link-para-afiliados">encurtador de link para afiliados</a>.',

            lpAfiliados: {
                heroTitleLine1: 'Um link curto pra cada campanha.',
                heroTitleLine2: 'Um painel pra ver o que funciona.',
                heroSubtitle: 'Encurte seus links de afiliado, marque a origem de cada um e veja de onde vêm seus cliques.',
                heroSecondaryLink: 'Ver todos os recursos',
                trackingTitle: 'Saiba de onde vêm seus cliques',
                trackingDesc: 'Cada link mostra a rede, campanha ou anúncio que gerou o clique, direto no painel de métricas. Assim você sabe onde vale a pena investir de novo.',
                trackingImageAlt: 'Painel de métricas de cliques do Migly',
                bioTitle: 'Uma página de bio pra reunir todos os seus links',
                bioDesc: 'Em vez de escolher um único link pra colocar no perfil, use a página de bio do Migly pra reunir todas as suas ofertas e redes em um só lugar.',
                bioImageAlt: 'Página de bio do Migly reunindo vários links',
                finalCtaTitle: 'Pronto pra organizar seus links de afiliado?',
                redirectImageAlt: 'Tela de redirecionamento de link do Migly',
                configImageAlt: 'Tela de configurações de link do Migly',
                opengraphImageAlt: 'Personalização de prévia (Open Graph) de um link no Migly',
            },

            proTag: 'recurso do plano PRO',
            ogTitle: 'a prévia do seu link também vende',
            ogText1: 'Todo link que você compartilha carrega um protocolo chamado <strong>Open Graph</strong>: as metatags que fazem o WhatsApp, o X, o LinkedIn e o Facebook montarem, antes mesmo do clique, aquela prévia com imagem, título e descrição. Sem controle sobre isso, a prévia mostra o que a página de destino definiu — às vezes uma imagem genérica, um título técnico, ou nada.',
            ogText2: 'Com o Migly, você reescreve essa prévia inteira: troca a imagem, escreve o título e o resumo do seu jeito. Nada do link original sobra na prévia — só a versão que você quer mostrar pra quem recebe.',
            ogBullet1: 'Imagem própria no lugar da imagem — ou ausência dela — do site original',
            ogBullet2: 'Título escrito por você, sem depender do título da página de destino',
            ogBullet3: 'Resumo pensado pra gerar clique, não a descrição genérica do site',
            viewProPlans: 'Ver planos PRO',
            ogCarouselAriaLabel: 'Prévia do link em diferentes redes sociais',
            statusOnline: 'online',
            mockProductTitle: 'Coleção inverno 2026',
            mockProductDesc: 'Peças novas todo mês, frete grátis.',
            sponsored: 'Patrocinado',
            mockFacebookCaption: 'Chegou a coleção de inverno! Confira 👇',
            actionLike: 'Curtir',
            actionComment: 'Comentar',
            actionShare: 'Compartilhar',
            followersCount: '1.204 seguidores',
            mockLinkedinCaption: 'Nossa coleção de inverno chegou. Veja o catálogo completo:',

            mockYourProduct: 'seu produto aqui',
            mockSeeOffer: 'ver oferta',
            mockRedirectingIn: 'redirecionando em 3s',
            mockBrandName: 'Sua Marca',
            mockCustomScreen: 'tela personalizada',
            mockAdScreen: 'sua publicidade',
            monetizeTag: 'monetize com o plano PRO',
            promoTitle: 'cada clique pode virar uma venda',
            promoText: 'Antes do redirecionamento, use a tela de carregamento pra divulgar um produto seu, uma promoção ou uma parceria — e transforme o tráfego que seus links já recebem em uma nova fonte de receita.',
            promoBullet1: 'Divulgue produtos próprios ou de parceiros e monetize cada clique',
            promoBullet2: 'Banner com imagem, texto e link de destino, do jeito que você quiser',
            promoBullet3: 'Tempo de espera que você define, link por link',
            promoBullet4: 'Inclua sua marca e personalize a tela de carregamento do seu jeito',

            calcTitle: 'quanto tráfego você está rastreando hoje?',
            calcSubtitle: 'Estime quantos cliques por mês seu link recebe e veja o que dá pra descobrir sobre cada um deles com o Migly.',
            calcLabel: 'Cliques por mês no seu link',
            numberLocale: 'pt-BR',
            clicksPerMonth: 'cliques/mês',
            calcResultLabel: 'com o migly, cada um desses cliques pode te dizer',
            calcResultCaption: 'pontos de dado por mês, só com o que já rastreamos:',
            metricQr: 'Se veio de QR Code',
            metricVisitors: 'Visitantes e acessos',
            metricRegion: 'País, estado e cidade',
            metricScreen: 'Tamanho de tela',
            metricShare: 'Rede usada pra compartilhar',
            metricPeriod: 'Acessos por dia, mês e ano',
            metricUtm: 'UTM da campanha, quando a origem registrar',
            chartsHeading: 'e no seu painel, cada clique vira gráfico',
            chartsSubheading: 'prévia de como esses dados aparecem na sua conta, atualizados em tempo real.',
            chartCurrentPeriod: 'Este período',
            chartPreviousPeriod: 'Período anterior',
            chartDirectLink: 'Link direto',
            chartClicks: 'Cliques',

            apiMockCommentCreate: '# criar um link encurtado',
            apiMockCommentResponse: '// resposta',
            apiTitle: 'conecte o migly ao seu sistema',
            apiText: 'Tudo que dá pra fazer no painel também dá pra fazer via API: criar e editar links, e consultar as métricas de cada um deles, direto do seu código — sem depender de exportar planilha nem copiar link por link.',
            apiBullet1: 'Crie e edite links direto do seu sistema, em lote se precisar',
            apiBullet2: 'Consulte cliques, região e período por API, sem abrir o painel',
            apiBullet3: 'Documentação interativa (Swagger) e token de autorização gerados no painel',
        },
    },
    'en': {
        genericError: 'Something went wrong. Please try again.',
        projectDescription : 'Shorten links and urls for free with migly.in',
        shortenToURL: 'Shorten to URL',
        bioPageMarketingText: `My migly connects all your pages, social media posts, YouTube videos, and any content or project you have online into a single bio page.
        Besides a short link, you'll get a QR Code linked to your bio. Print it and make it easy for people to reach your projects.`,
        sponsoredAdMaxDiscountTag: 'Up to -80%',
        sponsoredAdGenericDescription: 'Special limited-time offer.',
        sponsoredAdCta: 'See offer',
        sponsoredAdLabel: 'Ad',
        continueToDestination: 'Continue',
        redirectOwnerUpsellText: 'This ad shows up because this link is on the free plan. On PRO, you decide: put your own promotion here, or remove ads entirely.',
        adCategoryAccessories: 'Accessories',
        adCategoryFood: 'Food',
        adCategoryBeauty: 'Beauty',
        adCategoryShoes: 'Shoes',
        adCategoryHome: 'Home',
        adCategoryElectronics: 'Electronics',
        adCategoryGeneral: 'Deals',
        adCategoryKids: 'Kids',
        adCategoryWomensFashion: 'Women\'s Fashion',
        adCategoryMensFashion: 'Men\'s Fashion',
        adCategoryStationeryArt: 'Stationery & Art',
        adCategoryPet: 'Pet',
        adCategoryHealth: 'Health',
        videoNotSupported: 'Your browser does not support the video tag.',
        audioNotSupported: 'Your browser does not support the audio tag.',
        close: 'Close',
        checkDiscount: 'Check it out',
        hidePromotion: 'Click here to stop showing this promotion',
        isAProductOf: 'is a product of',

        shortenAddress: `Shorten address`,
        urlCopiedToClipboard: 'url copied to clipboard',
        copyUrl: 'Copy link',
        viewUrl: 'Visit link',
        toClean: 'To Clean',
        invalidUrl : `Invalid URL`,
        login: `Login`,
        signUp: `Sign Up`,
        anchorLink1: '',
        all: 'Todos',
        original: 'Original',

        plansAndPrices: `Plans and Prices`,
        plansAndPricesDescription: 'Get an essential solution to generate, share and track links for all forms of communication. Choose your plan below.',
        plansLadderBaseTitle: 'Start with {plan}',
        plansLadderMoreTitle: 'Everything in {plan}, plus',
        planFilterTag: 'Find your plan',
        planFilterTitle: 'Which plan fits you best?',
        planFilterSubtitle: 'Toggle the features you need and we\'ll show the cheapest plan that already includes them all.',
        planFilterEmptyState: 'Toggle at least one feature to see the recommendation.',
        planFilterRecommendedLabel: 'Recommended plan',
        plan_FREE: 'Free',
        plan_BASIC: 'Basic',
        plan_PRO: 'Pro',
        plan_BUSINESS: 'Business',
        plan_URL_SHORTNER_FREE: 'Free',
        plan_URL_SHORTNER_BASIC: 'Basic',
        plan_URL_SHORTNER_PRO: 'Professional',
        plan_URL_SHORTNER_BUSINESS: 'Business',
        myAccount: 'My account',
        accept: 'Accept',
        termsOfUse: 'Terms of Use',
        privacyPolicy: 'Privacy policy',
        userSignTermsAndPrivacyPolicy: 'Terms of Use and Privacy Policy',

        /* Direct translation of the current (1.0.2) Portuguese version only — see
         * the matching 'pt-br' entries for older historical versions, which are
         * intentionally kept in their original language as a legal record of
         * what a given user agreed to at signup time. Not a substitute for
         * professional legal review before being treated as the governing text. */
        termsOfUseHtml : {
            '1.0.2' : `
    <h1>Terms of Use</h1>
<p style="margin-top: 15px"><i><strong>Last updated: DATEUPDATE</strong></i></p>

    <h2>1. Service Description</h2>
    <p>Migly is a URL shortener that enables the creation of a link aggregator (bio link) and collects access metrics. It also allows URL customization and use of the redirect wait time for promotion or advertising.</p>

    <h2>2. Conditions of Use</h2>
    <p>To use the service, the user must:</p>
    <ul>
        <li>Be at least 18 years old</li>
        <li>Comply with local laws</li>
    </ul>

    <h2>3. Usage Restrictions</h2>
    <p>Users are prohibited from:</p>
    <ul>
        <li>Using the service for illegal purposes</li>
        <li>Sending spam</li>
        <li>Violating third-party rights</li>
        <li>Directing to gambling, phishing, pornography, or any act considered a crime internationally or within national territory (Brazil)</li>
    </ul>
    <p>Accounts that violate these rules may be deactivated without prior notice.</p>

    <h2>4. Intellectual Property</h2>
    <p>All content and functionality of the Migly application, including but not limited to text, graphics, logos, and images, are the exclusive property of Exatamente Soluções or its licensors and are protected by intellectual property laws.</p>

    <h2>5. Limitation of Liability</h2>
    <p>Neither Migly nor Exatamente Soluções is responsible for the final destination address of a shortened link or for any damages caused by such redirects.</p>

    <h2>6. Changes to the Service</h2>
    <p>Policies will be updated and users will always be informed if any rule or system feature changes. Users will be notified after logging into the dashboard.</p>

    <h2>7. Termination</h2>
    <p>The agreement may be terminated at any time. However, since payment is made in advance, no refund will be issued after the evaluation period (seven days). The customer should pay close attention to billing cycles.</p>

    <h2>8. Contact</h2>
    <p>For support and questions related to using the application, please contact us at: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

    <h2>Additional Terms</h2>
    <p><strong>Jurisdiction and Applicable Law:</strong> These Terms of Use are governed by the laws of Brazil. Any disputes will be resolved under Brazilian jurisdiction.</p>
    <p><strong>Updates:</strong> Users will be informed of updates to this document via notification after logging into the dashboard.</p>
            `
        },
        privacyPolicyHtml : {
            '1.0.2' : `
            <h1>Privacy Policy</h1>
<p style="margin-top: 15px"><i><strong>Last updated: DATEUPDATE</strong></i></p>

<h2>1. Information Collected</h2>
<p><strong>Personal Data:</strong></p>
<ul>
    <li>Name</li>
    <li>Email</li>
    <li>Profile picture</li>
    <li>For subscribers: tax ID, full name, credit card data (processed through the Pagar.me payment system)</li>
</ul>
<p><strong>Browsing Data:</strong></p>
<ul>
    <li>URLs accessed and browser tabs open, for users of the Google Chrome extension</li>
</ul>

<h2>2. Use of Information</h2>
<p>The information collected is used to:</p>
<ul>
    <li>Personalize services</li>
    <li>Improve the application</li>
    <li>Perform statistical analysis</li>
    <li>Collect data and target advertising to Migly users who click a shortened link</li>
</ul>
<p>We do not share this information with third parties.</p>

<h2>3. Storage and Security</h2>
<p>Information is stored in secure databases and protected servers. Payment data is held by Pagar.me. For more information about Pagar.me's privacy policy, see <a href="https://migly.in/xC61">here</a>.</p>

<h2>4. User Rights</h2>
<p>Users have the right to:</p>
<ul>
    <li>Access their data</li>
    <li>Correct inaccurate data</li>
    <li>Delete their data</li>
</ul>
<p>Users may exercise these rights by emailing: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

<h2>5. Cookies and Similar Technologies</h2>
<p>We use cookies to:</p>
<ul>
    <li>Target advertising to users of shortened links</li>
    <li>Collect consumption preferences</li>
</ul>
<p>The data collected is not correlated to a specific user.</p>

<h2>6. Contact</h2>
<p>For privacy-related questions, please contact Exatamente Soluções at: <a href="mailto:contato@exatamente-solucoes.com">contato@exatamente-solucoes.com</a>.</p>

<h2>Additional Terms</h2>
<p><strong>Jurisdiction and Applicable Law:</strong> This Privacy Policy is governed by the laws of Brazil. Any disputes will be resolved under Brazilian jurisdiction.</p>
<p><strong>Updates:</strong> Users will be informed of updates to this document via notification after logging into the dashboard.</p>

            `
        },

        cancel: 'Cancel',
        save: 'Save',
        edit: 'Edit',
        name: 'Name',
        required: 'Required',
        invalid: 'Invalid',
        number: 'Number',
        cpfCnpj: 'Tax ID',
        cvv: 'CVV',
        creditCardNamePrinted: 'Name (as printed on card)',
        publicStreet: 'Street address',
        complement: 'Complement',
        cep: 'ZIP code',
        city: 'City',
        state: 'State',
        ddi: 'Country code',
        ddd: 'Area code',
        plan: 'Plan',
        register: 'sign up',
        getPlan: 'Select',
        currentPlan: 'Your current plan',
        assignPlan: 'Subscribe to {plan}',
        assignPlanAuth: 'You need to log in to subscribe to this plan',
        closeCheckoutConfirmTitle: 'Leave without finishing?',
        closeCheckoutConfirmText: 'Whatever you\'ve filled in will be lost if you leave now.',
        closeCheckoutConfirmStay: 'Keep filling out',
        closeCheckoutConfirmLeave: 'Leave anyway',
        assignPlanSuccessTitle: 'Subscription to {plan} confirmed!',
        assignPlanSuccess: 'We received your payment details. Please wait for the charge to be processed.',
        toAccessPanel: 'Go to dashboard',
        trialPeriod: 'If this is your first activation, you\'ll have seven days to try it out.',
        youAssignPlan: 'You are subscribed to the ',
        month: 'month',
        year: 'year',
        montly: 'monthly',
        yearly: 'yearly',
        payPerYearInfo: 'Save up to 30% paying yearly',

        sectionDocument: 'Document',
        sectionContact: 'Contact',
        sectionCardData: 'Card details',
        sectionBillingAddress: 'Billing address',
        documentRequired: 'Document is required, numbers only',
        documentInvalid: 'Invalid document',
        ddiRequired: 'Country code is required',
        dddRequired: 'Area code is required',
        phoneNumberRequired: 'Number is required',
        phoneNumberInvalid: 'Invalid number',
        cardNumber: 'Card number',
        cardNumberRequired: 'Card number is required',
        cardNumberInvalid: 'Invalid card number',
        cvvRequired: 'CVV is required',
        cvvInvalid: 'Invalid CVV',
        cardNameRequired: 'Name is required',
        cardNameInvalid: 'Invalid name',
        cardExpiration: 'Expiration date',
        cardExpirationRequired: 'Expiration date is required',
        cardExpirationInvalid: 'Invalid expiration date',
        streetRequired: 'Street address is required',
        cepRequired: 'ZIP code is required',
        cepInvalid: 'Invalid ZIP code',
        cityRequired: 'City is required',
        stateRequired: 'State is required',
        subscriptionError: 'You already have this plan, or your payment details are invalid. Please check and try again',
        subscribeButton: 'Subscribe',
        verifyingCardData: 'Verifying card details',
        invalidCard: 'Invalid card',
        discountNotice: 'You will be charged R${discountedPrice} for the first three months; after that, your subscription will adjust to R${fullPrice}.',

        UNLIMITED_LINKS: 'Unlimited links',
        desc_UNLIMITED_LINKS: {icons: ['mdi-link', 'mdi-all-inclusive'], description: "There's no limit to the number of links you can shorten — create as many as you want."},
        BIO: 'Migly bio page',
        INFOPRODUCT: 'Lead-capture sales page',
        SMS: 'sms (SMS sending template)',
        desc_BIO: {icons: ['mdi-bio', 'mdi-vector-union', 'mdi-text-account'], description: "Make it easy to access all your social networks, contact info and online projects with your unified bio link page."},
        onboardingWelcomeTitle: "Let's show you what you can already do",
        onboardingProgress: 'Step {current} of {total}',
        onboardingBtnNext: 'Next',
        onboardingBtnFinish: 'Finish',
        onboardingBtnDismiss: 'End tour',
        onboardingRelaunch: 'Replay guided tour',
        onboardingStepShortenTitle: 'Shorten your first link',
        onboardingStepShortenBody: 'Paste a long URL and generate a short, easy-to-share link in seconds.',
        onboardingStepPreviewTitle: 'Generate a preview',
        onboardingStepPreviewBody: 'Customize how your link looks when shared on social media, with an image, title and description.',
        onboardingStepTagsTitle: 'Organize with tags',
        onboardingStepTagsBody: 'Create tags to group and filter your links by campaign, project or channel.',
        onboardingStepBannerTitle: 'Redirect banner',
        onboardingStepBannerBody: 'Show a banner and a call to action on the redirect screen before sending your visitor to the final destination.',
        onboardingStepConfigTitle: 'General configuration',
        onboardingStepConfigBody: "Adjust your account's default behavior, such as wait time and redirect banner.",
        onboardingStepBioTitle: 'Create your bio page',
        onboardingStepBioBody: 'Bring all your important links together in one customizable page to share on social media.',
        onboardingStepInfoproductTitle: 'Turn a link into a sales page',
        onboardingStepInfoproductBody: "Capture the contact of anyone who clicks before sending them to another platform's checkout, with a lead-capture form on the link's destination page.",
        QR_CODE: 'QR Codes',
        desc_QR_CODE: {icons: ['mdi-data-matrix-scan'], description: "Make your links even easier to access with QR Codes. With this feature your customers won't even need to type in your page's address."},
        UNLIMITED_CLICKS: 'Links with no click limit',
        desc_UNLIMITED_CLICKS: {icons: ['mdi-cursor-default-click', 'mdi-all-inclusive'], description: "Shortened links are always available and never expire, and they also have no click limit — your customers or followers will always be able to reach your shortened links."},
        COUNT_CLICKS: 'Click counting',
        desc_COUNT_CLICKS: {icons: ['mdi-cursor-default-click', 'mdi-counter'], description: "Know exactly how many people clicked on your links."},
        REPORT_COMPLETE: 'Full report',
        desc_REPORT_COMPLETE: {icons: ['mdi-chart-arc', 'mdi-chart-donut-variant', 'mdi-chart-histogram'], description: "Full report on your link accesses by device, region and platform."},
        LOGO_LOADING: 'Full customization',
        desc_LOGO_LOADING: {icons: ['mdi-link', 'mdi-office-building', 'mdi-cog'], description: "Show your company's name on loading and redirect screens for your generated links, with full URL customization and social media preview customization."},
        VERIFY_LINK: 'Broken link checks',
        desc_VERIFY_LINK: {icons: ['mdi-link' , 'mdi-cube-scan'], description: "We periodically check your shortened links and let you know when one stops working, so you know when you're losing traffic."},
        UPDATE_LINK: 'Edit generated links\' destination',
        desc_UPDATE_LINK: {icons: ['mdi-link', 'mdi-circle-edit-outline'], description: "You can edit any shortened link after creating it, changing its destination or even the shortened name itself."},
        SEND_SMS: 'SMS sending',
        desc_SEND_SMS: {icons: ['mdi-message-processing' , 'mdi-clock-outline', 'mdi-message-badge-outline'], description: "We send and schedule SMS messages to your customers. <br> You'll need to buy credits to send messages.<br> Each SMS costs <i>R$ 0.30</i> and you get R$ 4.00 every month when you subscribe to the Pro plan"},
        API_ACCESS: 'API access for integration',
        API_ACCESS_LINK: 'Integration API access',
        CUSTOM_DOMAIN: 'Custom domain',
        desc_CUSTOM_DOMAIN: {icons: ['mdi-link', 'mdi-circle-edit-outline'], description: "You can attach a custom domain to your generated links, something like https://your-company.com/{code}. You'll need to buy or configure a domain."},
        desc_API_ACCESS: {icons: ['mdi-dev-to', 'mdi-api'], description: "You can shorten your links programmatically using our <a href='/api-doc' target='_blank'>API</a>"},
        desc_INFOPRODUCT: {icons: ['mdi-cart-outline', 'mdi-account-arrow-right-outline'], description: "Turn any link into a sales page with a lead-capture form, so you never lose the contact of someone who clicked but didn't convert on another platform's checkout."},
        emptyLinksTitle: "You haven't created any links yet",
        emptyLinksSubtitle: 'Meanwhile, check out everything Migly can do for you:',

        API: "Application Programming Interface (API)",
        CHROME_EXTENSION: "Chrome extension",
        DAY: "Day",
        LOADING_PAGE: "Loading screen customization",
        LOADING_PAGE_DESC: "Feature available for subscribers of the URL shortener's professional plan.",
        MONTH: "Month",
        PLAN_URL_SHORTNER_BASIC_SUBSCRIPTION: "Basic",
        PLAN_URL_SHORTNER_BUSINESS_SUBSCRIPTION: "Business",
        PLAN_URL_SHORTNER_FREE_SUBSCRIPTION: "Free",
        PLAN_URL_SHORTNER_PRO_SUBSCRIPTION: "Professional",
        PROCESSING: "Processing",
        ProfitWithUs: "Earn with us",
        SAVED: "Saved",
        SCHEDULED: "Scheduled",
        SENT: "Sent",
        SHORTEN_LINKS: "Shortener",
        STANDARD: "Standard (migly dashboard)",
        URL_SHORTNER: "Link shortener",
        URL_SHORTNER_BASIC: "Basic link shortener",
        URL_SHORTNER_BUSINESS: "Business link shortener",
        URL_SHORTNER_FREE: "Free link shortener",
        URL_SHORTNER_PRO: "Professional link shortener",
        YEAR: "Year",
        about: "About",
        aboutDesc: "Set a username, name and description for your page.",
        acceptAllCookiesPreferencies: "Accept all cookies",
        access: "Accesses",
        accessByDay: "Clicks per day",
        accessCount: "Access Count",
        accessCountBlockMessage: "Feature available for subscribers of the URL shortener's basic plan.",
        accessPainel: "Access the dashboard",
        accountSuspendedTitle: "Account suspended for security reasons",
        accountSuspendedDesc: "We identified potentially malicious content associated with your account and access has been suspended pending review.",
        accountSuspendedContact: "Contact contato@exatamente-solucoes.com for more information.",
        accountSuspendedClose: "Got it",
        active: "Active",
        add: "Add",
        addEmoji: "Add Emoji ",
        addLink: "Add link",
        addVariable: "Add variable",
        add_image: "Add image",
        add_instagram: "Add Instagram",
        add_sample_link: "Add simple link",
        add_whatsapp: "Add WhatsApp",
        add_youtube: "Add YouTube video",
        addressType: "Shortening method",
        addressTypeDesc: "It's the source that generated the short link.",
        addressTypeDesc_API: "Links shortened via the developer API",
        addressTypeDesc_BIO: "Links associated with your biolink (my migly)",
        addressTypeDesc_CHROME_EXTENSION: "Links shortened using the Google Chrome extension",
        addressTypeDesc_STANDARD: "Links shortened through this Dashboard",
        addressType_ALL: "All types",
        addressType_API: "API",
        addressType_BIO: "Biolink (my migly)",
        addressType_CHROME_EXTENSION: "Google Chrome extension",
        addressType_STANDARD: "This Dashboard (site)",
        advanced: "Advanced",
        advancedConfiguration: "Advanced settings",
        allDesc: "All properties.",
        allPeriod: "All time",
        analytcsDescription: "Analytics in link shorteners provide vital insights to optimize strategies. By measuring clicks, sources and user behavior, you maximize engagement and ROI. Essential for informed decision-making and online success.",
        analytcsSubTitle: "track your links' statistics",
        analytcsTitle: "your migly's performance",
        apiDoc: "Documentation",
        apiRefSwagger: "API Reference (Swagger)",
        appView: "Other Apps",
        appViewDesc: "View within other apps",
        application: "Application",
        apply: "Apply",
        "architects-daughter": "Architects Daughter",
        areYouSure: "Are you sure?",
        article: "Article",
        "article:author": "Article author's URL.",
        "article:expiration_time": "Article expiration date and time.",
        "article:modified_time": "Article's last modification date and time.",
        "article:published_time": "Article publication date and time.",
        "article:section": "Site section where the article belongs.",
        "article:tag": "Article keywords.",
        articles: "Articles",
        articlesDesc: "Properties specific to articles.",
        aspectRatio: "Screen aspect ratio",
        assignPlanCardInfo: "We don't store credit card data. This information is used only to process the plan subscription and is deleted afterwards.",
        audio: "Audio",
        audios: "Audios",
        audiosDesc: "Properties related to the page's audios.",
        authorization: "Authorization",
        autoWhatssShortenLinks: "Shorten links in the message",
        backToHome: "Back to home",
        background: "Background",
        backgroundColor: "Background color",
        basics: "Basics",
        basicsDesc: "Essential properties for any page.",
        billed: "Billed",
        bioBrandCtaTitle: "Create your migly profile",
        bioBrandHome: "Home",
        bioBrandPlans: "Plans and pricing",
        bioBrandPrivacyPolicy: "Privacy policy",
        bioHeadline: "Highlight phrase",
        bioHeadlinePlaceholder: "e.g. Product designer",
        bioLocationStatus: "Current status",
        bioLocationStatusPlaceholder: "e.g. In the feedback loop.",
        biopage: "Bio page",
        "book:author": "Book author's URL.",
        "book:isbn": "Book's ISBN number.",
        "book:release_date": "Book release date.",
        "book:tag": "Book keywords.",
        books: "Books",
        booksDesc: "Properties specific to books.",
        bottomOfPage: "Bottom of page",
        "brazil.number.only": "Only Brazilian numbers are allowed",
        browserDefault: "Browser Default",
        byCities: "Cities",
        byCountries: "Countries",
        byStates: "States",
        callToAction: "🛒 See more.",
        cancelSubscrible: "Cancel subscription",
        canceled: "Canceled",
        capturingPreview: "Capturing preview...",
        capturingPreviewDone: "Link preview updated",
        cencelRedirected: "Cancel redirect",
        cities: "Cities",
        clean: "Clear",
        clear: "Clear",
        clearFilters: "Clear filters",
        clearSelection: "Clear selection",
        clickDateRange: "",
        clickToCopy: "Click to copy",
        clicks: "Clicks",
        clicksOrderByASC: "Least accessed",
        clicksOrderByDESC: "Most accessed",
        color: "Color",
        comingSoon: "Coming soon",
        config: "Settings",
        configPageLoadInfo: "Customize your loading page",
        confirmCancelSubscrible: "Confirm",
        content: "Content",
        cookie_advertising: "Advertising cookies",
        cookie_advertising_desc: "These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant ads on other websites. They don't directly store personal information but are based on uniquely identifying your browser and internet device. If you don't allow these cookies, you'll experience less targeted advertising.",
        cookie_analytics: "Performance cookies",
        cookie_analytics_desc: "These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information collected by these cookies is aggregated and therefore anonymous. If you don't allow these cookies, we won't know when you visited our site.",
        cookie_necessary: "Strictly necessary cookies",
        cookie_necessary_desc: "These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions you take that amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not work. These cookies do not store any personally identifiable information.",
        cookie_research: "Functionality cookies",
        cookie_research_desc: "These cookies allow the site to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we've added to our pages. If you don't allow these cookies, some or all of these features may not work properly.",
        cookiesRequiredInfo: "This site uses cookies to improve your browsing experience, analyze data, conduct research and target advertising. To change your preferences, click \"Manage preferences\". By clicking \"Accept all cookies\", you agree to the use of cookies on your device. <span id=\"onetrust-reject-all-banner-desc\">Clicking \"Reject all cookies\" means you do not agree to the use of cookies that are not strictly necessary on your device</span>.<a class=\"link\" href=\"/privacy-policy\" aria-label=\"More information about your privacy, opens in a new tab\" rel=\"noopener\" target=\"_blank\"> migly's cookie and tracking notice</a>.",
        copyLink: "Link copied",
        copyYoutubeUrl: "Use a YouTube video URL. Example https://www.youtube.com/watch?v=dxVaP0-aFIE or https://www.youtube.com/embed/dxVaP0-aFIE",
        countAllLinks: "Access count for all links",
        countLinksTo: "Count for the link ",
        countries: "Countries",
        createBio: "Create your bio page",
        createYourLeedPage: "Create your lead capture page",
        createYoutMiglyPage: "Create your migly",
        creationDate: "Link creation",
        creationDateDesc: "Dates of when the link was generated. You can limit by start and end dates.",
        cropImageTitle: "Crop and resize image",
        ctaText: "Banner text",
        current_cycle_billing_at: "Billed on ",
        current_cycle_cycle: "Cycle",
        current_cycle_start_at: "Billing cycle from ",
        current_cycle_status: "Status",
        dashboardExampleBadge: "Example",
        dashboardExampleUnlock: "Available on the PRO plan",
        dashboardInfoText: "Data Display: The chart shows data filtered by the reporting period and the link view in the dashboard.",
        dashboardPeriodLockedTooltip: "Available from the basic plan",
        dateCreateEnd: "Link creation end date",
        dateCreateIni: "Link creation start date",
        dateCreateOrderByASC: "Oldest",
        dateCreateOrderByDESC: "Newest",
        ddiDescrition: "Country code",
        default: "Default",
        delete: "Delete",
        deleteAddressInfoPlan: "The link address can only be changed from the basic plan onwards",
        deleteConfirm: "Confirm Deletion",
        deleteLink: "Delete Link",
        deleted: "Deleted",
        derivedTagTooltip: "Automatically captured tag - cannot be edited or removed",
        description: "Description",
        descriptionColor: "Description color",
        destinationURL: "Destination URL",
        disclosure: "Promotion",
        disclosureDescription: "Take advantage of the loading screen to effectively promote your sites, products or services. Maximize your business's visibility and reach while your users wait for the redirect!",
        displayToWindowSizeDescrition: "Access by device based on screen size",
        doUpgrade: "Upgrade",
        domain: "Domain",
        domainAndSubdomain: "Domain and subdomain",
        domainPreviewCode: "code",
        domains: "Domains",
        downloadQrCode: "Download QR Code",
        draggableLinksInfo: "Drag and drop to reorder links",
        editAddress: "Edit migly link",
        editAparenceLink: "Edit link preview",
        editAparenceLinkInfo: "This feature lets you show a small preview of the link's content. Apps like Facebook, WhatsApp and Telegram take advantage of this feature.",
        editCodeAndDirectionLink: "Edit code and destination",
        editLink: "Edit link",
        editLinkSubdomain: "Subdomain",
        editLinkSubdomainSubtitle: "Choose your sales page's address - this is the link you'll share and track.",
        editLinkTags: "Edit Link tags",
        endAt: "to",
        enterYourWhatsappNumber: "Enter your WhatsApp phone number",
        errorIn: "Status",
        errorLinkLoad: "Error fetching link information",
        invalidImageFile: "This file couldn't be used - please select a valid image.",
        example: "Example",
        excluded: "Excluded",
        expiredAt: "Expires at",
        failed: "Failed",
        false: "No",
        filter: "Filter",
        filterDashBoardTitle: "Filter",
        filters: "Filters",
        follow: "Follow",
        followMetrics: "Track metrics",
        font: "Font",
        footerSubtitle: "Include your company info, contact, links and more.",
        footerTitle: "Site footer",
        infoproductProgressLabel: 'Page progress',
        infoproductStepLabel: 'Step',
        infoproductTitleHint: 'Main headline shown at the top of your sales page. Be direct to spark interest.',
        infoproductSubtitleHint: 'Highlight text shown above the title, like a badge or quick call-out.',
        infoproductShortDescriptionHint: 'Short summary of the offer, shown right below the title.',
        infoproductActionHint: 'Text on the main button that drives the visitor to act, like downloading the material or accessing the content.',
        infoproductProductImageHint: 'Featured product image, shown prominently on the page.',
        infoproductItensTitleHint: 'Title for the list of topics, themes or benefits of your product.',
        infoproductDescriptionHint: 'Full text about the product, shown in a dedicated section further down the page.',
        infoproductResourceHint: 'PDF file delivered to the visitor after filling out the form.',
        infoproductFormFieldNameHint: 'Name shown above the field in the lead capture form, like "Full name" or "WhatsApp".',
        infoproductFooterTextHint: 'Institutional info shown in the page footer, like company details or legal notice.',
        infoproductPreviewDevicesTitle: "See how your page will look on your lead's phone.",
        infoproductPanelSubtitle: 'Create sales pages with a lead capture form from your links.',
        infoproductNavBenefits: 'Benefits',
        infoproductNavAbout: 'About',
        infoproductNavContact: 'Contact',
        emptyInfoproductsTitle: "You haven't created any sales pages yet",
        emptyInfoproductsSubtitle: 'Create your first sales page with lead capture from a link.',

        accessNow: 'Access now',
        actionName: 'Call-to-action button',
        advance: 'Next',
        alphanumeric: 'Alphanumeric',
        btnActionColor: 'Button color',
        btnActionTextColor: 'Button text color',
        colorInfoproductMore: 'Description background color',
        colorSiteHeader: 'Header color',
        colorfooterBackgroundColor: 'Footer background color',
        createInfoProduct: 'Create sales page',
        descriptionBackgroundColor: 'Description background color',
        downloadNow: 'Download now',
        eBook: 'E-book',
        eBookSendDescription: 'As soon as a lead fills out the form, your PDF file is delivered to them right away.',
        editInfoProduct: 'Edit sales page',
        file: 'File',
        footerBackgroundColor: 'Footer background color',
        footerTextColor: 'Footer text color',
        formColor: 'Form color',
        formField: 'Form field',
        infoproductContactEmailInfo: 'Email is always included in the contact form.',
        infoproductContactSubtitle: "Build the form that captures the lead's info before delivering the content. Choose exactly which fields to collect.",
        infoproductContactTitle: 'Contact form',
        infoproductFormFieldName: 'Field name',
        infoproductFormFieldType: 'Type',
        infoproductFormFieldValue: 'Value',
        infoproductFormInputFieldType: 'Input type',
        infoproductFormSelectFildValues: 'Options available in the selector',
        infoproductMoreSubtitle: 'Write the full description of what the lead will get. This text appears in its own section, further down the page.',
        infoproductMoreTitle: 'More about your sales page',
        infoproductResourceResponsability: 'Responsibility for PDF and image content',
        infoproductResourceResponsabilityDesc: `<i><p>By using PDFs and images in our system, you agree to take full responsibility for the content and copyright associated with these files. Make sure you hold the necessary rights to share them and that your content is appropriate and complies with our terms of service.</p>
        <p>You are responsible for ensuring that no illegal, defamatory, obscene or offensive material is shared. Also make sure not to include confidential or personal information without proper authorization.</p>
        <p>Please note that any violation of copyright, privacy or other legal rights arising from improper use of PDFs and images in our system will be your responsibility.</p></i>`,
        infoproductType: 'Sales page type',
        invalidSize: 'Invalid size',
        itensColor: 'Item color',
        itensTitleColor: 'Items title color',
        leeds: 'Leads',
        leedsDescription: "Capture the info of anyone interested in your product before granting access or download - you keep every lead's contact, even if they don't convert right away.",
        leedsPage: 'Lead-capture page',
        linkSendDescription: 'As soon as a lead fills out the form, your link is sent to them right away.',
        logoOrlogotipo: 'Site or product logo',
        logoOrlogotipoSizeInfo: 'Choose a square image (1:1 ratio), such as 500 x 500 pixels, with a transparent background.',
        maxSize: 'Max file size is {0} - your file is {1}.',
        numeric: 'Numeric',
        onlineAddress: 'Online address',
        orIn: 'or at',
        pageAparence: 'Page appearance',
        pageAparenceSubtitle: "Customize your sales page's header, logo, text and main image.",
        pageType: 'Page type',
        productImage: 'Product image',
        productSubtitle: 'Choose what the lead gets after filling out the form: a PDF e-book or an access link.',
        selecField: 'Selector',
        selectFieldDescription: 'Selector fields collect information the user picks from a list of options.',
        selectFieldNumericDescription: 'A combination of numeric characters',
        shortDescription: 'A short description',
        shortDescriptionColor: 'Short description color',
        siteType: 'Web page',
        siteTypeSubtitle: 'Confirm this is a lead-capture page and accept responsibility for the content you upload.',
        subdomainAlreadyInUSe: 'This subdomain is already in use',
        subtitle: 'Subtitle',
        subtitleColor: 'Subtitle color',
        textField: 'Text field',
        textFieldAlphanumericDescription: 'A combination of letters and numbers',
        textFieldDescription: 'Text fields collect information typed in by the user.',
        topicAndThemesTitle: 'Topic, benefit or item',
        topicsAndThemes: 'Topics, items and benefits',
        topicsAndThemesSubtitle: 'List the key topics, benefits or outcomes of your product - it helps the lead decide the form is worth filling out.',
        topicsAndThemesTitle: "Title for your product's item list",
        yourPageAvailibleIn: 'Your page will be available at ',
        emptyLeadsTitle: 'No leads captured yet',
        emptyLeadsSubtitle: 'Leads who fill out this page\'s form will show up here.',
        future: "Trial",
        game: "Game",
        generalAparence: "General appearance",
        generalAparenceDesc: "Set the page's colors and text",
        generateAuthorization: "Generate access token",
        generateWhatsAppLink: "Generate WhatsApp link",
        geoChartBarInfo: "Views by city",
        geoChartLineInfo: "Views by state",
        geoDescription: "Access by region",
        geoTitle: "Region",
        goTo: "Go to",
        googleAnalitcs: "Google Analytics",
        googleAnalitcsDescription: "You can integrate your shortened links and bio page with Google Analytics. See how to get your measurement ID",
        googleAnalitcsExample: "UA-XXXXXX-X or G-XXXXXXX",
        googleAnalitcsId: "MEASUREMENT ID",
        googleChromeWebStoreMiglyAction: "install now!",
        googleChromeWebStoreMiglySubTitle: "discover amazing features and browse more efficiently. our extension is fast, secure and easy to use!",
        googleChromeWebStoreMiglyTitle: "improve your online experience with our extension!",
        googleChromeWebStoreMiglyTitleXS: "Shorten links",
        headerColor: "Header color",
        help: "Help",
        helpAction: "Send an email",
        helpDescription: "Have a question about Migly, need to report a problem, or want to learn more about our features? We're here to help! Contact our team at <b>contato@exatamente-solucoes.com</b> and we'll be glad to assist you. Your feedback is very important to us!",
        helpTitle: "Get in Touch",
        hostinger_ads: "Complete solution to host your site",
        icon: "Icon",
        image: "Image",
        imageBanner: "Banner",
        images: "Images",
        imagesDesc: "Properties related to the page's images.",
        infoYouMiglyPage: "My migly connects all your pages, social media posts, YouTube videos, and any content or project you have online into a single bio page.\n               Besides a short link, you'll get a QR Code linked to your bio. Print it and make it easy for people to reach your projects.",
        instagram: "Instagram",
        instagramAutofillFailed: "Couldn't automatically fetch the profile picture. A default Instagram icon will be shown instead.",
        instagramFollowers: "followers",
        instagramFollowing: "following",
        "insufient.credits": "Insufficient credit",
        interval: "Frequency",
        "invalid.dateTimeScheduled": "Invalid scheduled date and time",
        "invalid.subscription": "Invalid subscription",
        invalidNumber: "Invalid number",
        invalidPhone: "Invalid phone number",
        irregular: "Irregular",
        last30Days: "Last 30 days",
        last7Days: "Last 7 days",
        last90Days: "Last 90 days",
        lastYear: "Last year",
        learnMore: "Learn more",
        lg: "Desktop",
        link: "Link",
        linkAparencePreview: "Set how the link looks when shared on WhatsApp and social media",
        linkCodeChangeWarning: "Changing the code will make the current link stop working immediately. Anyone who already saved or shared this link won't be able to access it anymore.",
        linkErrorTitle: "This link may have stopped working. Check the possible causes.",
        linkInterstitialInactiveInfo: "Turn on the switch above to configure the banner and wait time shown before redirecting this link.",
        linkInterstitialSubtitle: "Customize the banner and wait time shown only for this link, overriding the account's general settings.",
        linkInterstitialTitle: "Promotion on this link",
        linkUrlChangeWarning: "When you change the destination address, this link's social media preview will be updated automatically.",
        link_instagram_profile: "Link to the Instagram profile",
        links: "Links",
        linksErrorTitle: "One or more links may have stopped working",
        linksErrorVerify: "You have {0} shortened links whose original address may have stopped working",
        loaderTime: "Display time before redirecting will be ",
        loaderTimeSubtitle: "Set the wait time before redirecting to the final destination.",
        loaderTimeTitle: "Wait time",
        loggout: "Log out",
        logoPicture: "Your brand's image",
        lora: "Lora",
        manageCookiesDescription: "<div id=\"ot-pc-desc\">When you visit a website, it may store or retrieve information in your browser, mostly in the form of cookies. This information might be about you, your preferences, or your device, and is mostly used to make the site work as you expect it to. The information usually doesn't directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience on the site and the services we are able to offer.\n            <br><a href=\"/privacy-policy\" class=\"link\" rel=\"noopener\" target=\"_blank\" aria-label=\"More information about your privacy, opens in a new tab\" tabindex=\"0\"> More information</a></div>",
        manageCookiesPreferencies: "Manage preferences",
        manageCookiesTitle: "Privacy preference center",
        maxFileSizeOG: "The image size must be less than 2 MB!",
        md: "Laptop",
        merriweather: "Merriweather",
        message: "Message",
        messageToUserNotLoggedInURLShortener: "Your link was generated successfully, however it isn't associated with your account yet. As a result, you won't be able to access detailed metrics or customize the link's social media preview.",
        metrics: "Metrics",
        monthly: "monthly",
        montserrat: "Montserrat",
        moveForward: "Next",
        multipart: "File",
        music: "Music",
        new: "New",
        newLink: "Add link",
        newLinkWhatsapp: "Generate your WhatsApp Link",
        newSection: "Add section",
        newsMiglySubtitle: "Shortening, customization and metrics collection",
        newsMiglyTitle: "What's new in migly",
        next_billing_at: "Next billing at",
        noData: "Not found",
        noDataDescription: "Search by tags, parts of the URL or dashboard options",
        notVerified: "Not verified",
        notifications: "Notifications",
        notifyCarouselLoadingPage: "Loading screen",
        notifyCarouselTitle: "What you can do with migly",
        notifyNoConfigSubtitle: "Set the brand and wait time shown between the click and the redirect of your links.",
        notifyNoLinksSubtitle: "Turn a long URL into a short link, track clicks and metrics in real time, and customize the appearance for WhatsApp, Instagram and other networks.",
        notifyNoLinksTitle: "Shorten your first link",
        notifyNoOpenGraphSubtitle: "Add an image, title and description so your links look like this when shared:",
        notifyNoOpenGraphTitle: "Customize how your links look",
        notifyOpenGraphExampleDescription: "A short, catchy description for social media",
        notifyOpenGraphExampleDomain: "yourdomain.com/promo",
        notifyOpenGraphExampleTitle: "Your link's title",
        "noto-serif-oriya": "Noto Serif Oriya",
        novelty: "New",
        "number.invalid.value": "Invalid number",
        of: "of",
        "og:audio": "Audio.",
        "og:audio:secure_url": "Secure audio (HTTPS).",
        "og:audio:type": "Audio format, such as audio/mpeg.",
        "og:description": "Brief description of the page.",
        "og:determiner": "Word before the title, such as \"a\" or \"an\".",
        "og:image": "Main image of the page.",
        "og:image:height": "Image height in pixels.",
        "og:image:secure_url": "Secure image (HTTPS).",
        "og:image:type": "Image format, such as image/jpeg.",
        "og:image:url": "Image.",
        "og:image:width": "Image width in pixels.",
        "og:locale": "Page language and region, such as en_US.",
        "og:site_name": "Site name.",
        "og:title": "Page title.",
        "og:type": "Content type, such as website or article.",
        "og:url": "Page URL.",
        "og:video": "Video.",
        "og:video:height": "Video height in pixels.",
        "og:video:secure_url": "Secure video (HTTPS).",
        "og:video:type": "Video format, such as video/mp4.",
        "og:video:width": "Video width in pixels.",
        online: "Online",
        onlineAddressId: "Link identifier",
        onlyIcon: "icon only",
        "open-sans": "Open Sans",
        openGraph: "Customize a link preview (Open Graph)",
        openGraphDescription: "Open Graph is a technology that gives you control over how your web page is shared on social media.",
        openGraphDescriptionInfo: "When a Facebook user likes a URL with Open Graph implemented, a connection is created between the user and that URL.\n\n        Through this connection, it becomes possible to interact with the users who liked it, the same way interactions happen with a Facebook page.\n        \n        For example: posting updates to the user, targeting ads and appearing in the \"Activities and Interests\" section of the profile of whoever liked it.\n        \n        Pages with this implementation enrich the user experience around liking and sharing information.\n        \n        In addition to defining how the web page will be represented in social media feeds.",
        opengraphAdvanced: "Customize advanced fields",
        opengraphBackToSimple: "Back to simple",
        opengraphEditDescription: "Set how your link will be displayed on social media, with a custom title, description and image.",
        opengraphEditTitle: "Customize the Link Display",
        opengraphPreviewTitle: "Preview",
        opengraphRefetch: "Fetch the destination page's data again and update the fields you haven't customized",
        opengraphRefetchDone: "Link data updated",
        opengraphRefetchError: "Couldn't start the update",
        opengraphRefetchPending: "The update is still in progress, try again shortly",
        opengraphRefetching: "Fetching updated data from the destination page...",
        operationCannotBeUndone: "This action cannot be undone",
        optional: "optional",
        optionals: "Optional",
        optionalsDesc: "Additional properties that can be included.",
        or: "or",
        orCreateAccount: "Or create your account",
        orderBy: "Sort by",
        originalAddress: "Original address",
        originalLink: "Original link",
        otherNews: "Discover other features",
        others: "Other",
        page: "page",
        pageBio: "Migly Bio",
        pageNotFoundDesc: "The link you accessed may have been removed or never existed.",
        pageNotFoundTitle: "This page doesn't exist",
        panel: "Dashboard",
        payPerMonth: "Pay monthly",
        payPerYear: "Pay yearly",
        period: "Access period",
        "permanent-marker-regular": "Permanent Marker",
        personalizeCta: "Customize",
        phoneNumber: "Phone number",
        placement: "Placement",
        plans: "Plans",
        platformDescription: "Access by platform",
        platformTitle: "Platform",
        possibleCauses: "Possible causes:",
        preview: "Preview",
        previewLink: "Link preview",
        previewOpenGraph: "Preview",
        previewSCreenLoader: "Preview",
        pricing: "Price",
        primaryLink: "Primary link",
        problens: "Issues",
        product: "Product",
        "product:availability": "Product availability, such as \"in stock\".",
        "product:price:amount": "Product price.",
        "product:price:currency": "Price currency, such as USD.",
        "product:retailer_item_id": "Retailer item ID.",
        products: "Products",
        productsDesc: "Properties specific to products.",
        profile: "Profile",
        profileDesc: "Set your profile picture and cover photo.",
        projectDescriptionShortenUrl: "Migly is an effective tool for shortening links. Create your account now and access our dashboard. Use our shortener to turn long URLs into short links.",
        qrCode: "QR Code",
        raleway: "Raleway",
        recommendedImageSize: "Recommended size:",
        referrerDescription: "Access by referring site (referrer)",
        refused: "Decline",
        region: "Region",
        regular: "Regular",
        rejectCookiesPreferencies: "Reject all cookies",
        remove: "Remove",
        report: "Report",
        reportLink: "Report Link",
        reportLinkDescription: "Help us keep the web safe! Use this form to report broken, fake, suspicious or potentially malicious links. Your contribution is essential to ensure a more reliable and secure online experience for everyone.",
        reportLinkPlaceholder: "For example: The shortened link redirects to a suspected phishing site.",
        reportLinkSendDescription: "Thank you for helping keep the web safe. Your contribution is essential to ensure a more reliable and secure online experience. Our team will review the reported link and take the necessary action.",
        reportLinkSendTitle: "Thanks for your report!",
        reportLinkTitle: "Report Suspicious and Malicious Links",
        resourceOnlyPlan: "Feature available only on the",
        results: "results",
        roboto: "Roboto",
        sample_link: "Simple Link",
        saveConfigError: "Couldn't save the settings. Please try again.",
        saveTagsError: "Couldn't save the tags. Please try again.",
        saved: "Saved",
        screenLoading: "Loading Screen",
        screenLoadingDescription: "Customize the loading screen by setting your company's or product's brand and name.",
        search: "Search",
        searchLinksDesc: "Search links by parts of the URL, tags or link identifier code",
        searchNav: "Search links, bio page or navigate the dashboard",
        searchShortURL: "Search Links",
        sectionColor: "Section color",
        sectionTextColor: "Section text color",
        sections: "Sections",
        sectionsAndlinks: "Links and sections",
        seeAllSocialLinks: "See all social networks",
        securityBlockedCta: "Go to Migly",
        securityBlockedDesc: "Migly identified that this link's destination may pose a security risk. For your safety, access to the destination has been blocked.",
        securityBlockedTitle: "Navigation interrupted",
        securityContinueButton: "Continue to the destination",
        securityVerifyingDesc: "The destination hasn't been validated by Migly yet.",
        securityVerifyingStillInProgress: "Verification is still in progress. Please try again in a moment.",
        securityVerifyingTitle: "We're verifying this address",
        selectCountryOnMap: "Select a country on the map or ranking to see the breakdown by state and city.",
        selectEndDate: "--",
        selectYourSocialNetworks: "Add links to your social networks",
        send: "Send",
        setAllPeriod: "Enter the full period",
        setDomainAndSubdomain: "Customize your URLs by setting your own domain and subdomain. This feature lets you use your brand or visual identity in every shortened link, increasing trust and brand recognition. With custom domains and subdomains, your URLs may not be shorter, but they'll be more professional and consistent.",
        setDomainAndSubdomainSuport: "To set up a domain and subdomain, contact our support team at contato@exatamente-solucoes.com after subscribing to the business plan.",
        setEndPeriod: "Enter the end of the period",
        setPrimaryLink: "Set as primary link",
        setStartPeriod: "Enter the start of the period",
        settings: "Settings",
        shadow: "Shadow",
        shape: "Shape",
        shapeDesc: "Section shape with border smoothing, padding or shadow",
        share: "Share",
        shareOn: "Share on",
        sharedOn: "Shared on social media",
        sharedOnViews: "Views by share",
        sharedOnViewsDisclaimer: "To collect this metric, the link needs to be shared using the \"Share on\" feature, accessed from the links list or Migly Bio.",
        shorten: "shorten",
        shortenALink: "Shorten links",
        shortenAddressBenefit1: "Customizable URL",
        shortenAddressBenefit2: "access metrics",
        shortenAddressBenefit3: "Customize the link preview for social media",
        shortenAddressBenefit4: "Google Analytics integration",
        shortenAddressInfo: "Shorten your link in seconds and share it in a practical, elegant way. Simple, fast and free!",
        shortenAddressInfoWitoutLogin: "\n        <h3>Your Link Is Ready! 🚀</h3>\n        <p>\nLiked how easy that was? Now imagine all the advantages you can get by creating an account with Migly:\n\nTrack your metrics: Find out how many people are clicking your links, where they're coming from and much more.\nFull customization: Create custom URLs that are easy to remember and share links with your own brand.\nSecurity and control: Protect your links with passwords and set expiration dates.\nSmart automation: Automatically shorten links as you browse and manage all your links in one place.\nDon't waste time! Create your account now and unlock Migly's full potential!\n        </p>\n        ",
        shortenAddressMoreTitle: "your migly can be + than 1 link shortener",
        shortenAddressTitle: "Shorten your link",
        shortenFree: "Sign in with Google",
        shortenToURLExample: "Example youtube.com or a phone number",
        shortenUrlBenefit1: "Shorten links from Instagram, YouTube, WhatsApp or any other site.",
        shortenUrlBenefit2: "Create a single link that leads to all your social networks and projects.",
        shortenUrlBenefit3: "You can track analytics and have full control over your links.",
        shortenWithMigly: "Shorten with migly",
        shortenedUrl: "Shortened URL",
        siteHeader: "Site Header",
        siteName: "Site name",
        sitesShortened: "Shortened sites",
        situation: "Status",
        situationDesc: "Every day the shortened links' addresses are checked; when a link fails the check, its status becomes irregular.",
        sm: "Tablet",
        socialIconsColor: "Social icons color",
        socialLinks: "Social networks",
        socials: "Social Networks",
        startAt: "from",
        start_at: "Started at",
        start_in: "Starts at",
        states: "States",
        subdomain: "Subdomain",
        subsEmptyDesc: "Subscribe to a paid plan to unlock advanced features.",
        subscriptions: "Subscriptions",
        swaggerUi: "See our API docs",
        "tag.derived.immutable": "Automatically captured tags cannot be edited or removed",
        tags: "Tags",
        tagsFilterLabel: "Link/campaign tags",
        tagsFilterDesc: "Filter by the tag you use to organize your links by campaign.",
        tagsFilterPlaceholder: "Search tag...",
        test: "Test",
        text: "Text",
        textCancel: "When you cancel your subscription, we won't renew it the following month. The benefits associated with your plan type will remain available until the end of the cycle.",
        textColor: "Text color",
        thisLinkError: "Some people may have trouble accessing this link. Last checked on ",
        timeUnit: "Data aggregated by",
        title: "Title",
        titleCancel: "Subscription cancellation",
        titleColor: "Title color",
        toChart: "Analyze clicks on this link",
        toCheck: "Check",
        toConfirm: "Confirm",
        toGoBack: "Back",
        toSee: "View",
        today: "Today",
        topLinksTitle: "Most accessed links",
        topOfPage: "Top of page",
        totalClicks: "Total clicks",
        totalClicksInBioPage: "clicks on your page's links",
        true: "Yes",
        tryMigly: "Try migly",
        tryPlan: "7-day free trial",
        typeIn: "Shortening method",
        unbilled: "Unbilled",
        undefined: "Undefined",
        undefinedGeoLocation: "*It's not always possible to get the state and city where the link was viewed. In these cases, it will be shown as 'Undefined'.",
        uniqueLink: "Connect everything with a single link",
        unique_views: "Visitors",
        updateAddress: "Change link",
        updateAddressInfo: "Change the shortened link's code or destination",
        updateTagsInfo: "Setting tags for shortened links can help you find them easily in search.",
        upgradeToPlus: "Upgrade",
        "url.rejected": "URL rejected",
        "url.rejected.missing.scheme": "Invalid URL - add http:// or https:// before the address",
        "code.reserved": "This code is reserved and cannot be used",
        username: "Username",
        username_instagram_profile: "Instagram username",
        utmHierarchyAllSources: "All sources",
        utmHierarchyDisclaimer: "Browse the source of your accesses: source (utm_source), then medium (utm_medium), campaign (utm_campaign) and content (utm_content). Click an item to see the next level.",
        utmHierarchyExpandTree: "View full tree",
        utmHierarchyTitle: "Traffic source by campaign (UTM)",
        utmSourceDescription: "Access by source (utm_source)",
        variables: "Variables",
        video: "Video",
        videoOther: "Videos (Other)",
        videos: "Videos",
        videosDesc: "Properties related to the page's videos.",
        viewMoreByStateCity: "View by state and city",
        views: "Views",
        viewsComparePreviusPeriod: "Compared to the previous period.",
        viewsDesc: "Clicks or views on the links generated during the selected period",
        viewsPerDate: "Views by date",
        viewsPerDateDisclaimer: "*Daily Access Chart: Shows only days with recorded accesses. For more details, click and expand the chart.",
        viewsPerDomains: "Views by Domain",
        viewsPerRegion: "Views by region",
        viewsPerRegionDisclaimer: "It's not always possible to get the exact region of the view.",
        viewsPerScreenSize: "Views by screen size",
        viewsPerScreenSizeDisclaimer: "The breakdown is done by screen size, not by the device accessed. ",
        viewsPerState: "Views by state",
        watchOnYoutube: "Watch on YouTube",
        website: "Website",
        whatsAppNumber: "Number",
        whatsAppText: "Default Message",
        whatsapp: "WhatsApp",
        whatspaMessage: "WhatsApp Message",
        whatspaMessageFormated: "Formatted WhatsApp Message",
        whatssInfoShortenLinks: "When you include links in the message, they'll be shortened automatically.",
        whattsappNumber: "WhatsApp mobile number",
        withClicks: "Links with accesses",
        withClicksDesc: "Links with at least one access. You can still filter by start and end dates for links with at least one access.",
        withGoogle: "With Google",
        withoutClicks: "Links without accesses",
        withoutClicksDesc: "Links without access. You can still filter by start and end dates for links without at least one view.",
        withoutDomain: "No domain",
        withoutIcon: "No Icon",
        withoutNotifications: "No notifications",
        worldMap: "World map",
        xl: "TV",
        xs: "Smartphone",
        youWillBeRedirectedTo: "You will be redirected to",
        yourCompanyOrProductHere: "Discounts up to 30% off in store and free shipping! 🐰 ",
        yourCompanyOrProductHereText: "From accessories to special gifts, find everything you need!",
        youtube: "YouTube",
        linkErrorCauses: ["The user with the link needs to be logged into the original site. Note: LinkedIn, Instagram and other social networks require you to be logged into the platform to view certain profiles.","Not all users may have access to the original link.","Link copied from a logged-in area within the original site.","The original address may have been changed.","The link or URL no longer exists.","Service unavailable."],
        shortenAddressBenefits: [{"icon":"md-"}],
        displays: [{"id":"xs","description":"Small to large phone","icon":"mdi-cellphone","color":"#304FFE"},{"id":"sm","description":"Small to medium tablet","icon":"mdi-tablet","color":"#3D5AFE"},{"id":"md","description":"Large tablet to laptop","icon":"mdi-laptop","color":"#536DFE"},{"id":"lg","description":"Monitor to large TVs","icon":"mdi-monitor","color":"#2962FF"},{"id":"xl","description":"4K and ultra-wide screens","icon":"mdi-television","color":"#2979FF"}],
        shareOptions: [{"icon":"mdi-whatsapp","description":"WhatsApp","url":"https://api.whatsapp.com/send/?text=","color":"#004D40","value":"w"},{"icon":"mdi-facebook","description":"Facebook","url":"https://www.facebook.com/sharer.php?u=","color":"#3b5998","value":"f"},{"icon":"mdi-twitter","description":"Twitter","url":"https://twitter.com/intent/tweet?text=","color":"#00acee","value":"t"},{"icon":"mdi-linkedin","description":"LinkedIn","url":"https://www.linkedin.com/sharing/share-offsite/?url=","color":"#0e76a8","value":"l"},{"icon":"mdi-facebook-messenger","description":"Messenger","url":"https://www.messenger.com/login.php?next=","color":"#008ad3","value":"m"},{"icon":"mdi-email","description":"Email","url":"mailto:?subject=&body=","color":"dark","value":"e"},{"icon":"mdi-qrcode-scan","description":"QRCode","url":null,"color":"dark","value":"q"}],
        socialOptions: [{"icon":"mdi-instagram","name":"Instagram","url":"https://instagram.com/"},{"icon":"mdi-whatsapp","name":"WhatsApp","url":"https://api.whatsapp.com/send/?phone="},{"icon":"mdi-facebook","name":"Facebook","url":"https://facebook.com/"},{"icon":"mdi-twitter","name":"Twitter","url":"https://twitter.com/"},{"icon":"mdi-linkedin","name":"LinkedIn","url":"https://linkedin.com/in/"},{"icon":"mdi-youtube","name":"YouTube","url":"https://youtube.com/user/"},{"icon":"mdi-pinterest","name":"Pinterest","url":"https://pinterest.com/"},{"icon":"mdi-music-note","name":"TikTok","url":"https://tiktok.com/@"},{"icon":"mdi-snapchat","name":"Snapchat","url":"https://snapchat.com/add/"},{"icon":"mdi-reddit","name":"Reddit","url":"https://reddit.com/user/"},{"icon":"mdi-github","name":"GitHub","url":"https://github.com/"},{"icon":"mdi-twitch","name":"Twitch","url":"https://twitch.tv/"},{"icon":"mdi-controller","name":"Discord","url":"https://discord.com/users/"},{"icon":"mdi-alpha-t","name":"Telegram","url":"https://t.me/"}],
        verificationOptions: {"0":"Regular","1":"Irregular","3":"Not verified"},
        platforms: [{"id":"android","color":"deep-purple accent-4","name":"Android","icon":"mdi-android"},{"id":"macintosh","color":"indigo darken-2","name":"Macintosh (macOS)","icon":"mdi-apple"},{"id":"windows","color":"blue","name":"Windows","icon":"mdi-microsoft-windows"},{"id":"iphone","color":"indigo darken-2","name":"iPhone (iOS)","icon":"mdi-apple"},{"id":"linux","color":"primary","name":"Linux","icon":"mdi-linux"},{"id":"ipad","color":"indigo darken-2","name":"iPad (iOS)","icon":"mdi-apple"},{"id":"others","color":"indigo darken-2","name":"Other","icon":"mdi-crosshairs-question"},{"id":"Linux aarch64","color":"primary","name":"","icon":"mdi-linux"},{"id":"Win32","color":"blue","name":"","icon":"mdi-microsoft-windows"},{"id":"Linux armv8l","color":"primary","name":"","icon":"mdi-linux"},{"id":"Linux armv7l","color":"primary","name":"","icon":"mdi-linux"},{"id":"MacIntel","color":"indigo darken-2","name":"","icon":"mdi-apple"},{"id":"Linux x86_64","color":"primary","name":"","icon":"mdi-linux"},{"id":"Linux i686","color":"primary","name":"","icon":"mdi-linux"},{"id":"Linux armv81","color":"primary","name":"","icon":"mdi-linux"},{"id":"X11; Linux x86_64","color":"primary","name":"","icon":"mdi-linux"},{"id":"Win64","color":"blue","name":"","icon":"mdi-microsoft-windows"},{"id":"PlayStation 4","color":"red","name":"PlayStation 4","icon":"mdi-sony-playstation"},{"id":"Windows Phone","color":"red","name":"Windows Phone","icon":"mdi-microsoft-windows"}],

        home: {
            navHowItWorks: 'How it works',
            navBio: 'Bio',
            navSalesPage: 'Sales Page',
            navLinkPreview: 'Link Preview',
            navBlog: 'Blog',
            blogHighlights: 'Highlights',
            blogRecentPosts: 'Recent posts',
            openMenu: 'Open menu',
            languageSelector: 'Select language',
            footerTagline: 'Shorten, unify and track everything about your links in one place.',
            footerLgpd: 'LGPD compliant',
            footerDataProtected: 'Data protected',
            footerNavigation: 'Navigation',
            footerContact: 'Contact',
            footerProductOf: 'migly.in is a product by <a class="footer-link-inline" href="https://www.exatamentese.com">exatamente soluções</a>.',

            heroTitleLine1: 'Every link, a metric.',
            heroTitleLine2: 'Every click, a decision.',
            heroSubtitle: 'Shorten the link, build your bio page and see where every click comes from. All in one flow.',
            heroTypewriterLabel: 'See how it looks:',
            heroCtaFree: 'Start for free',
            heroCtaHowItWorks: 'See how it works',
            noCreditCard: 'no credit card required',
            heroVisualAriaLabel: 'Animated demo: short link, share preview, bio page, customizable QR code and access metrics.',
            heroCustomizable: 'Customizable',
            heroOriginIdentified: 'origin identified',
            heroAnimPause: 'Pause animated demo',
            heroAnimResume: 'Resume animated demo',
            heroShortLinkBadge: 'Shortened link',
            heroPreviewBadge: 'Preview ready to share',

            benefitUrl: 'Customizable URL',
            benefitMetric: 'Access metrics',
            benefitPreview: 'Social media preview',
            benefitAnalytics: 'Google Analytics integration',
            mockYourUrl: 'migly.in/you',

            proofHeadline: 'what people who already use migly say',
            roleDeveloper: 'Developer',
            roleSalesManager: 'Sales Manager',
            roleTeacher: 'Teacher and Entrepreneur',
            testimonial1Quote: 'Migly let me monetize every link I share.',
            testimonial2Quote: 'Migly increased our brand exposure with attractive links. An indispensable tool!',
            testimonial3Quote: 'Migly\'s detailed metrics helped us better understand how our links perform and optimize our marketing campaigns.',
            pricingTestimonialQuote: 'Since I started using Migly to share my links, I\'ve already made R$ 155.95 in extra income — with zero effort, just by adding ads to links I was already sharing.',

            pillarsTitle: 'the three pieces of your traffic flow',
            pillarOriginTitle: 'Origin tracking',
            pillarOriginDesc: 'See which campaign, network or ad each click came from, before deciding where to invest again.',
            pillarToggle: 'see how it works',
            pillarOriginDetail: 'Every Migly link carries the click origin all the way to the metrics dashboard, with no extra setup.',
            pillarBioTitle: 'Built-in bio page',
            pillarBioDesc: 'The same bio page is born from the link you already shortened. Not another product — the same flow.',
            pillarBioDetail: 'Edit colors, reorder links and highlight whatever you want to sell first.',
            bioTag: 'link aggregator',
            bioTitle: 'your bio, your brand, every network in one link',
            bioText: 'Create a customizable bio page built for social media — bring Instagram, YouTube, your store and every important link into one place, styled like your brand.',
            bioBullet1Title: 'Link Centralization',
            bioBullet1Desc: 'Bring all your important links together in one place.',
            bioBullet2Title: 'Easy Access',
            bioBullet2Desc: 'Let your followers easily find all your content and profiles.',
            bioBullet3Title: 'Customization',
            bioBullet3Desc: 'Create a page that reflects your personality or brand with ease.',
            bioMockHandle: '@yourprofile',
            bioMockTagline: 'digital content creator',
            bioMockInstagram: 'Instagram',
            bioMockYoutube: 'YouTube',
            bioMockStore: 'My store',
            bioMockContact: 'Get in touch',
            bioMockExampleLabel: 'example',
            bioExamplesLabel: 'example bio pages you can create',

            infoproductTag: 'sales page',
            infoproductTitle: 'any link can become a sales page with lead capture',
            infoproductText: "Before the click goes to another platform's checkout, capture the contact of whoever didn't convert right away — so you never lose sight of that lead.",
            infoproductBullet1Title: 'Capture form',
            infoproductBullet1Desc: 'Build a custom form with whatever fields you need to capture a visitor\'s contact.',
            infoproductBullet2Title: 'Attribution without losing the lead',
            infoproductBullet2Desc: "The lead stays inside your Migly funnel instead of disappearing when they don't buy right away.",
            infoproductBullet3Title: 'Your brand, your offer',
            infoproductBullet3Desc: 'Customize colors, image and description to match your product.',
            infoproductCta: 'Create my sales page',
            infoproductMockBrand: 'Your Brand',
            infoproductMockBadge: 'FREE DOWNLOAD',
            infoproductMockTitle: 'Guide to Building an Effective Lead Capture Page',
            infoproductMockDesc: 'Practical tips to turn visitors into qualified leads.',
            infoproductMockCta: 'Download now',
            infoproductMockTopic1: 'How to craft a valuable offer',
            infoproductMockTopic2: 'Optimizing for mobile devices',
            infoproductMockTopic3: 'Measuring and improving results',
            infoproductMockFormLabel: 'Enter your email',
            infoproductMockFormBtn: 'Send it to me',

            bioExampleFitnessNiche: 'fitness',
            bioExampleFitnessDesc: 'Come join the fitness club.',
            bioExampleFitnessLink1: 'Smart Gym',
            bioExampleFitnessLink2: 'Train with me',

            bioExampleWellnessNiche: 'wellness',
            bioExampleWellnessDesc: 'More calm and mindfulness.',
            bioExampleWellnessLink1: 'What is mindfulness?',
            bioExampleWellnessLink2: 'Benefits of mindfulness',

            bioExampleTechNiche: 'tech',
            bioExampleTechDesc: 'Honest product reviews.',
            bioExampleTechLink1: 'Recommendations',
            bioExampleTechLink2: 'my Instagram',

            bioExampleTravelNiche: 'travel',
            bioExampleTravelDesc: 'Exploring the world one place at a time.',
            bioExampleTravelLink1: 'Traveler\'s blog',
            bioExampleTravelLink2: 'How to buy flight tickets',

            bioExampleFoodNiche: 'food',
            bioExampleFoodDesc: 'Easy everyday recipes.',
            bioExampleFoodLink1: 'Recipe of the week',
            bioExampleFoodLink2: 'My recipe book',

            bioExampleMusicNiche: 'music',
            bioExampleMusicDesc: 'Exclusive sets every week.',
            bioExampleMusicLink1: 'Listen on Spotify',
            bioExampleMusicLink2: 'Upcoming shows',

            bioExampleBeautyNiche: 'beauty',
            bioExampleBeautyDesc: 'Skincare tips that actually work.',
            bioExampleBeautyLink1: 'Full routine',
            bioExampleBeautyLink2: 'Products I use',

            bioExampleBusinessNiche: 'business',
            bioExampleBusinessDesc: 'Mentoring for entrepreneurs.',
            bioExampleBusinessLink1: 'Book a session',
            bioExampleBusinessLink2: 'My free e-book',

            pillarExtensionTitle: 'Chrome extension',
            pillarExtensionDesc: 'Shorten any link straight from your browser, without opening the dashboard every time.',
            pillarInstallExtension: 'install extension',
            pillarExtensionDetail: 'Stays installed in Chrome and keeps your Migly link one click away all day long.',
            pillarsSeoLinksHtml: 'Want to go deeper? Check out our <a href="/gerador-de-utm">UTM generator</a> or our <a href="/encurtador-de-link-para-afiliados">affiliate link shortener</a>.',

            lpAfiliados: {
                heroTitleLine1: 'One short link for every campaign.',
                heroTitleLine2: 'One dashboard to see what works.',
                heroSubtitle: 'Shorten your affiliate links, tag the origin of each one, and see where your clicks come from.',
                heroSecondaryLink: 'See all features',
                trackingTitle: 'Know where your clicks come from',
                trackingDesc: 'Every link shows the network, campaign or ad that generated the click, right in the metrics dashboard. That way you know where it pays to invest again.',
                trackingImageAlt: 'Migly click metrics dashboard',
                bioTitle: 'One bio page for all your links',
                bioDesc: 'Instead of picking a single link for your profile, use a Migly bio page to bring together every offer and network in one place.',
                bioImageAlt: 'Migly bio page bringing together several links',
                finalCtaTitle: 'Ready to organize your affiliate links?',
                redirectImageAlt: 'Migly link redirect screen',
                configImageAlt: 'Migly link settings screen',
                opengraphImageAlt: 'Open Graph preview customization for a Migly link',
            },

            proTag: 'PRO plan feature',
            ogTitle: 'your link preview sells too',
            ogText1: 'Every link you share carries a protocol called <strong>Open Graph</strong>: the metatags that make WhatsApp, X, LinkedIn and Facebook build that preview with image, title and description before the click even happens. Without control over it, the preview shows whatever the destination page defined — sometimes a generic image, a technical title, or nothing at all.',
            ogText2: 'With Migly, you rewrite that whole preview: swap the image, write the title and the summary your way. Nothing from the original link is left in the preview — only the version you want to show whoever receives it.',
            ogBullet1: 'Your own image instead of the original site\'s image — or lack of one',
            ogBullet2: 'A title written by you, with no dependency on the destination page\'s title',
            ogBullet3: 'A summary built to earn the click, not the site\'s generic description',
            viewProPlans: 'View PRO plans',
            ogCarouselAriaLabel: 'Link preview across different social networks',
            statusOnline: 'online',
            mockProductTitle: 'Winter Collection 2026',
            mockProductDesc: 'New pieces every month, free shipping.',
            sponsored: 'Sponsored',
            mockFacebookCaption: 'The winter collection is here! Check it out 👇',
            actionLike: 'Like',
            actionComment: 'Comment',
            actionShare: 'Share',
            followersCount: '1,204 followers',
            mockLinkedinCaption: 'Our winter collection has arrived. See the full catalog:',

            mockYourProduct: 'your product here',
            mockSeeOffer: 'see offer',
            mockRedirectingIn: 'redirecting in 3s',
            mockBrandName: 'Your Brand',
            mockCustomScreen: 'custom screen',
            mockAdScreen: 'your ad',
            monetizeTag: 'monetize with the PRO plan',
            promoTitle: 'every click can become a sale',
            promoText: 'Before redirecting, use the loading screen to promote your own product, a promotion or a partnership — and turn the traffic your links already get into a new revenue stream.',
            promoBullet1: 'Promote your own or partner products and monetize every click',
            promoBullet2: 'Banner with image, text and destination link, however you want it',
            promoBullet3: 'Wait time you define, link by link',
            promoBullet4: 'Add your brand and customize the loading screen your way',

            calcTitle: 'how much traffic are you tracking today?',
            calcSubtitle: 'Estimate how many clicks per month your link gets and see what you can find out about each one with Migly.',
            calcLabel: 'Clicks per month on your link',
            numberLocale: 'en-US',
            clicksPerMonth: 'clicks/month',
            calcResultLabel: 'with migly, each of these clicks can tell you',
            calcResultCaption: 'data points per month, just with what we already track:',
            metricQr: 'Whether it came from a QR Code',
            metricVisitors: 'Visitors and accesses',
            metricRegion: 'Country, state and city',
            metricScreen: 'Screen size',
            metricShare: 'Network used to share',
            metricPeriod: 'Accesses by day, month and year',
            metricUtm: 'Campaign UTM, whenever the source has one',
            chartsHeading: 'and in your dashboard, every click becomes a chart',
            chartsSubheading: 'a preview of how this data shows up in your account, updated in real time.',
            chartCurrentPeriod: 'This period',
            chartPreviousPeriod: 'Previous period',
            chartDirectLink: 'Direct link',
            chartClicks: 'Clicks',

            apiMockCommentCreate: '# create a short link',
            apiMockCommentResponse: '// response',
            apiTitle: 'connect migly to your system',
            apiText: 'Everything you can do in the dashboard can also be done through the API: create and edit links, and check the metrics for each one, straight from your code — no more exporting spreadsheets or copying links one by one.',
            apiBullet1: 'Create and edit links straight from your system, in bulk if you need to',
            apiBullet2: 'Check clicks, region and time period through the API, without opening the dashboard',
            apiBullet3: 'Interactive documentation (Swagger) and an authorization token, both generated in the dashboard',
        },
    },
};

const i18n = new VueI18n({
    locale: 'pt-br', // set locale
    fallbackLocale: 'pt-br', // pt-br is the most complete locale; used when a key is missing in 'en'
    messages, // set locale messages
});

export default i18n;